import * as React from 'react';
import React__default, { Fragment as Fragment$1, isValidElement, cloneElement, createElement, useLayoutEffect, useEffect, useState, useCallback, useRef, useMemo, createContext, useContext, useReducer, useImperativeHandle, useId as useId$8 } from 'react';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { createPortal } from 'react-dom';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function match(value, lookup) {
  if (value in lookup) {
    var returnValue = lookup[value];

    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return typeof returnValue === 'function' ? returnValue.apply(void 0, args) : returnValue;
  }

  var error = new Error("Tried to handle \"" + value + "\" but there is no handler defined. Only defined handlers are: " + Object.keys(lookup).map(function (key) {
    return "\"" + key + "\"";
  }).join(', ') + ".");
  if (Error.captureStackTrace) Error.captureStackTrace(error, match);
  throw error;
}

var Features;

(function (Features) {
  /** No features at all */
  Features[Features["None"] = 0] = "None";
  /**
   * When used, this will allow us to use one of the render strategies.
   *
   * **The render strategies are:**
   *    - **Unmount**   _(Will unmount the component.)_
   *    - **Hidden**    _(Will hide the component using the [hidden] attribute.)_
   */

  Features[Features["RenderStrategy"] = 1] = "RenderStrategy";
  /**
   * When used, this will allow the user of our component to be in control. This can be used when
   * you want to transition based on some state.
   */

  Features[Features["Static"] = 2] = "Static";
})(Features || (Features = {}));

var RenderStrategy;

(function (RenderStrategy) {
  RenderStrategy[RenderStrategy["Unmount"] = 0] = "Unmount";
  RenderStrategy[RenderStrategy["Hidden"] = 1] = "Hidden";
})(RenderStrategy || (RenderStrategy = {}));

function render(_ref) {
  var props = _ref.props,
      slot = _ref.slot,
      defaultTag = _ref.defaultTag,
      features = _ref.features,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible,
      name = _ref.name;
  // Visible always render
  if (visible) return _render(props, slot, defaultTag, name);
  var featureFlags = features != null ? features : Features.None;

  if (featureFlags & Features.Static) {
    var _props$static = props["static"],
        isStatic = _props$static === void 0 ? false : _props$static,
        rest = _objectWithoutPropertiesLoose$1(props, ["static"]); // When the `static` prop is passed as `true`, then the user is in control, thus we don't care about anything else


    if (isStatic) return _render(rest, slot, defaultTag, name);
  }

  if (featureFlags & Features.RenderStrategy) {
    var _match;

    var _props$unmount = props.unmount,
        unmount = _props$unmount === void 0 ? true : _props$unmount,
        _rest = _objectWithoutPropertiesLoose$1(props, ["unmount"]);

    var strategy = unmount ? RenderStrategy.Unmount : RenderStrategy.Hidden;
    return match(strategy, (_match = {}, _match[RenderStrategy.Unmount] = function () {
      return null;
    }, _match[RenderStrategy.Hidden] = function () {
      return _render(_extends$2({}, _rest, {
        hidden: true,
        style: {
          display: 'none'
        }
      }), slot, defaultTag, name);
    }, _match));
  } // No features enabled, just render


  return _render(props, slot, defaultTag, name);
}

function _render(props, slot, tag, name) {
  var _ref2;

  if (slot === void 0) {
    slot = {};
  }

  var _omit = omit(props, ['unmount', 'static']),
      _omit$as = _omit.as,
      Component = _omit$as === void 0 ? tag : _omit$as,
      children = _omit.children,
      _omit$refName = _omit.refName,
      refName = _omit$refName === void 0 ? 'ref' : _omit$refName,
      passThroughProps = _objectWithoutPropertiesLoose$1(_omit, ["as", "children", "refName"]); // This allows us to use `<HeadlessUIComponent as={MyComponent} refName="innerRef" />`


  var refRelatedProps = props.ref !== undefined ? (_ref2 = {}, _ref2[refName] = props.ref, _ref2) : {};
  var resolvedChildren = typeof children === 'function' ? children(slot) : children; // Allow for className to be a function with the slot as the contents

  if (passThroughProps.className && typeof passThroughProps.className === 'function') {
    passThroughProps.className = passThroughProps.className(slot);
  }

  if (Component === Fragment$1) {
    if (Object.keys(passThroughProps).length > 0) {
      if (!isValidElement(resolvedChildren) || Array.isArray(resolvedChildren) && resolvedChildren.length > 1) {
        throw new Error(['Passing props on "Fragment"!', '', "The current component <" + name + " /> is rendering a \"Fragment\".", "However we need to passthrough the following props:", Object.keys(passThroughProps).map(function (line) {
          return "  - " + line;
        }).join('\n'), '', 'You can apply a few solutions:', ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', 'Render a single element as the child so that we can forward the props onto that element.'].map(function (line) {
          return "  - " + line;
        }).join('\n')].join('\n'));
      }

      return cloneElement(resolvedChildren, Object.assign({}, // Filter out undefined values so that they don't override the existing values
      mergeEventFunctions(compact(omit(passThroughProps, ['ref'])), resolvedChildren.props, ['onClick']), refRelatedProps));
    }
  }

  return createElement(Component, Object.assign({}, omit(passThroughProps, ['ref']), Component !== Fragment$1 && refRelatedProps), resolvedChildren);
}
/**
 * We can use this function for the following useCase:
 *
 * <Menu.Item> <button onClick={console.log} /> </Menu.Item>
 *
 * Our `Menu.Item` will have an internal `onClick`, if you passthrough an `onClick` to the actual
 * `Menu.Item` component we will call it correctly. However, when we have an `onClick` on the actual
 * first child, that one should _also_ be called (but before this implementation, it was just
 * overriding the `onClick`). But it is only when we *render* that we have access to the existing
 * props of this component.
 *
 * It's a bit hacky, and not that clean, but it is something internal and we have tests to rely on
 * so that we can refactor this later (if needed).
 */


function mergeEventFunctions(passThroughProps, existingProps, functionsToMerge) {
  var clone = Object.assign({}, passThroughProps);

  var _loop = function _loop() {
    var func = _step.value;

    if (passThroughProps[func] !== undefined && existingProps[func] !== undefined) {
      var _Object$assign;

      Object.assign(clone, (_Object$assign = {}, _Object$assign[func] = function (event) {
        // Props we control
        if (!event.defaultPrevented) passThroughProps[func](event); // Existing props on the component

        if (!event.defaultPrevented) existingProps[func](event);
      }, _Object$assign));
    }
  };

  for (var _iterator = _createForOfIteratorHelperLoose(functionsToMerge), _step; !(_step = _iterator()).done;) {
    _loop();
  }

  return clone;
}

function compact(object) {
  var clone = Object.assign({}, object);

  for (var key in clone) {
    if (clone[key] === undefined) delete clone[key];
  }

  return clone;
}

function omit(object, keysToOmit) {
  if (keysToOmit === void 0) {
    keysToOmit = [];
  }

  var clone = Object.assign({}, object);

  for (var _iterator2 = _createForOfIteratorHelperLoose(keysToOmit), _step2; !(_step2 = _iterator2()).done;) {
    var key = _step2.value;
    if (key in clone) delete clone[key];
  }

  return clone;
}

var useIsoMorphicEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

var state = {
  serverHandoffComplete: false
};
function useServerHandoffComplete() {
  var _useState = useState(state.serverHandoffComplete),
      serverHandoffComplete = _useState[0],
      setServerHandoffComplete = _useState[1];

  useEffect(function () {
    if (serverHandoffComplete === true) return;
    setServerHandoffComplete(true);
  }, [serverHandoffComplete]);
  useEffect(function () {
    if (state.serverHandoffComplete === false) state.serverHandoffComplete = true;
  }, []);
  return serverHandoffComplete;
}

function useSyncRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  var cache = useRef(refs);
  useEffect(function () {
    cache.current = refs;
  }, [refs]);
  return useCallback(function (value) {
    for (var _iterator = _createForOfIteratorHelperLoose(cache.current), _step; !(_step = _iterator()).done;) {
      var ref = _step.value;
      if (ref == null) continue;
      if (typeof ref === 'function') ref(value);else ref.current = value;
    }
  }, [cache]);
}

// TODO: This must already exist somewhere, right? 🤔
// Ref: https://www.w3.org/TR/uievents-key/#named-key-attribute-values
var Keys$1;

(function (Keys) {
  Keys["Space"] = " ";
  Keys["Enter"] = "Enter";
  Keys["Escape"] = "Escape";
  Keys["Backspace"] = "Backspace";
  Keys["ArrowLeft"] = "ArrowLeft";
  Keys["ArrowUp"] = "ArrowUp";
  Keys["ArrowRight"] = "ArrowRight";
  Keys["ArrowDown"] = "ArrowDown";
  Keys["Home"] = "Home";
  Keys["End"] = "End";
  Keys["PageUp"] = "PageUp";
  Keys["PageDown"] = "PageDown";
  Keys["Tab"] = "Tab";
})(Keys$1 || (Keys$1 = {}));

// See: https://github.com/facebook/react/issues/7711
// See: https://github.com/facebook/react/pull/20612
// See: https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#concept-fe-disabled (2.)
function isDisabledReactIssue7711(element) {
  var _ref, _parent;

  var parent = element.parentElement;
  var legend = null;

  while (parent && !(parent instanceof HTMLFieldSetElement)) {
    if (parent instanceof HTMLLegendElement) legend = parent;
    parent = parent.parentElement;
  }

  var isParentDisabled = (_ref = ((_parent = parent) == null ? void 0 : _parent.getAttribute('disabled')) === '') != null ? _ref : false;
  if (isParentDisabled && isFirstLegend(legend)) return false;
  return isParentDisabled;
}

function isFirstLegend(element) {
  if (!element) return false;
  var previous = element.previousElementSibling;

  while (previous !== null) {
    if (previous instanceof HTMLLegendElement) return false;
    previous = previous.previousElementSibling;
  }

  return true;
}

// didn't take care of the Suspense case. To fix this we used the approach the @reach-ui/auto-id
// uses.
//
// Credits: https://github.com/reach/reach-ui/blob/develop/packages/auto-id/src/index.tsx

var id$1 = 0;

function generateId() {
  return ++id$1;
}

function useId$7() {
  var ready = useServerHandoffComplete();

  var _useState = useState(ready ? generateId : null),
      id = _useState[0],
      setId = _useState[1];

  useIsoMorphicEffect(function () {
    if (id === null) setId(generateId());
  }, [id]);
  return id != null ? '' + id : undefined;
}

function useIsMounted$1() {
  var mounted = useRef(false);
  useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  return mounted;
}

var DescriptionContext = /*#__PURE__*/createContext(null);

function useDescriptionContext() {
  var context = useContext(DescriptionContext);

  if (context === null) {
    var err = new Error('You used a <Description /> component, but it is not inside a relevant parent.');
    if (Error.captureStackTrace) Error.captureStackTrace(err, useDescriptionContext);
    throw err;
  }

  return context;
}

function useDescriptions() {
  var _useState = useState([]),
      descriptionIds = _useState[0],
      setDescriptionIds = _useState[1];

  return [// The actual id's as string or undefined
  descriptionIds.length > 0 ? descriptionIds.join(' ') : undefined, // The provider component
  useMemo(function () {
    return function DescriptionProvider(props) {
      var register = useCallback(function (value) {
        setDescriptionIds(function (existing) {
          return [].concat(existing, [value]);
        });
        return function () {
          return setDescriptionIds(function (existing) {
            var clone = existing.slice();
            var idx = clone.indexOf(value);
            if (idx !== -1) clone.splice(idx, 1);
            return clone;
          });
        };
      }, []);
      var contextBag = useMemo(function () {
        return {
          register: register,
          slot: props.slot,
          name: props.name,
          props: props.props
        };
      }, [register, props.slot, props.name, props.props]);
      return React__default.createElement(DescriptionContext.Provider, {
        value: contextBag
      }, props.children);
    };
  }, [setDescriptionIds])];
} // ---

var DEFAULT_DESCRIPTION_TAG = 'p';
function Description(props) {
  var context = useDescriptionContext();
  var id = "headlessui-description-" + useId$7();
  useIsoMorphicEffect(function () {
    return context.register(id);
  }, [id, context.register]);
  var passThroughProps = props;

  var propsWeControl = _extends$2({}, context.props, {
    id: id
  });

  return render({
    props: _extends$2({}, passThroughProps, propsWeControl),
    slot: context.slot || {},
    defaultTag: DEFAULT_DESCRIPTION_TAG,
    name: context.name || 'Description'
  });
}

var Context$1 = /*#__PURE__*/createContext(null);
Context$1.displayName = 'OpenClosedContext';
var State;

(function (State) {
  State[State["Open"] = 0] = "Open";
  State[State["Closed"] = 1] = "Closed";
})(State || (State = {}));

function useOpenClosed() {
  return useContext(Context$1);
}
function OpenClosedProvider(_ref) {
  var value = _ref.value,
      children = _ref.children;
  return React__default.createElement(Context$1.Provider, {
    value: value
  }, children);
}

function resolveType(props) {
  var _props$as;

  if (props.type) return props.type;
  var tag = (_props$as = props.as) != null ? _props$as : 'button';
  if (typeof tag === 'string' && tag.toLowerCase() === 'button') return 'button';
  return undefined;
}

function useResolveButtonType(props, ref) {
  var _useState = useState(function () {
    return resolveType(props);
  }),
      type = _useState[0],
      setType = _useState[1];

  useIsoMorphicEffect(function () {
    setType(resolveType(props));
  }, [props.type, props.as]);
  useIsoMorphicEffect(function () {
    if (type) return;
    if (!ref.current) return;

    if (ref.current instanceof HTMLButtonElement && !ref.current.hasAttribute('type')) {
      setType('button');
    }
  }, [type, ref]);
  return type;
}

function disposables() {
  var disposables = [];
  var api = {
    requestAnimationFrame: function (_requestAnimationFrame) {
      function requestAnimationFrame() {
        return _requestAnimationFrame.apply(this, arguments);
      }

      requestAnimationFrame.toString = function () {
        return _requestAnimationFrame.toString();
      };

      return requestAnimationFrame;
    }(function () {
      var raf = requestAnimationFrame.apply(void 0, arguments);
      api.add(function () {
        return cancelAnimationFrame(raf);
      });
    }),
    nextFrame: function nextFrame() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      api.requestAnimationFrame(function () {
        api.requestAnimationFrame.apply(api, args);
      });
    },
    setTimeout: function (_setTimeout) {
      function setTimeout() {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function () {
      var timer = setTimeout.apply(void 0, arguments);
      api.add(function () {
        return clearTimeout(timer);
      });
    }),
    add: function add(cb) {
      disposables.push(cb);
    },
    dispose: function dispose() {
      for (var _iterator = _createForOfIteratorHelperLoose(disposables.splice(0)), _step; !(_step = _iterator()).done;) {
        var dispose = _step.value;
        dispose();
      }
    }
  };
  return api;
}

var LabelContext = /*#__PURE__*/createContext(null);

function useLabelContext() {
  var context = useContext(LabelContext);

  if (context === null) {
    var err = new Error('You used a <Label /> component, but it is not inside a relevant parent.');
    if (Error.captureStackTrace) Error.captureStackTrace(err, useLabelContext);
    throw err;
  }

  return context;
}

function useLabels() {
  var _useState = useState([]),
      labelIds = _useState[0],
      setLabelIds = _useState[1];

  return [// The actual id's as string or undefined.
  labelIds.length > 0 ? labelIds.join(' ') : undefined, // The provider component
  useMemo(function () {
    return function LabelProvider(props) {
      var register = useCallback(function (value) {
        setLabelIds(function (existing) {
          return [].concat(existing, [value]);
        });
        return function () {
          return setLabelIds(function (existing) {
            var clone = existing.slice();
            var idx = clone.indexOf(value);
            if (idx !== -1) clone.splice(idx, 1);
            return clone;
          });
        };
      }, []);
      var contextBag = useMemo(function () {
        return {
          register: register,
          slot: props.slot,
          name: props.name,
          props: props.props
        };
      }, [register, props.slot, props.name, props.props]);
      return React__default.createElement(LabelContext.Provider, {
        value: contextBag
      }, props.children);
    };
  }, [setLabelIds])];
} // ---

var DEFAULT_LABEL_TAG = 'label';
function Label(props) {
  var _props$passive = props.passive,
      passive = _props$passive === void 0 ? false : _props$passive,
      passThroughProps = _objectWithoutPropertiesLoose$1(props, ["passive"]);

  var context = useLabelContext();
  var id = "headlessui-label-" + useId$7();
  useIsoMorphicEffect(function () {
    return context.register(id);
  }, [id, context.register]);

  var propsWeControl = _extends$2({}, context.props, {
    id: id
  });

  var allProps = _extends$2({}, passThroughProps, propsWeControl); // @ts-expect-error props are dynamic via context, some components will
  //                  provide an onClick then we can delete it.


  if (passive) delete allProps['onClick'];
  return render({
    props: allProps,
    slot: context.slot || {},
    defaultTag: DEFAULT_LABEL_TAG,
    name: context.name || 'Label'
  });
}

var GroupContext = /*#__PURE__*/createContext(null);
GroupContext.displayName = 'GroupContext'; // ---

var DEFAULT_GROUP_TAG = Fragment$1;

function Group(props) {
  var _useState = useState(null),
      switchElement = _useState[0],
      setSwitchElement = _useState[1];

  var _useLabels = useLabels(),
      labelledby = _useLabels[0],
      LabelProvider = _useLabels[1];

  var _useDescriptions = useDescriptions(),
      describedby = _useDescriptions[0],
      DescriptionProvider = _useDescriptions[1];

  var context = useMemo(function () {
    return {
      "switch": switchElement,
      setSwitch: setSwitchElement,
      labelledby: labelledby,
      describedby: describedby
    };
  }, [switchElement, setSwitchElement, labelledby, describedby]);
  return React__default.createElement(DescriptionProvider, {
    name: "Switch.Description"
  }, React__default.createElement(LabelProvider, {
    name: "Switch.Label",
    props: {
      onClick: function onClick() {
        if (!switchElement) return;
        switchElement.click();
        switchElement.focus({
          preventScroll: true
        });
      }
    }
  }, React__default.createElement(GroupContext.Provider, {
    value: context
  }, render({
    props: props,
    defaultTag: DEFAULT_GROUP_TAG,
    name: 'Switch.Group'
  }))));
} // ---


var DEFAULT_SWITCH_TAG = 'button';
function Switch(props) {
  var checked = props.checked,
      onChange = props.onChange,
      passThroughProps = _objectWithoutPropertiesLoose$1(props, ["checked", "onChange"]);

  var id = "headlessui-switch-" + useId$7();
  var groupContext = useContext(GroupContext);
  var internalSwitchRef = useRef(null);
  var switchRef = useSyncRefs(internalSwitchRef, groupContext === null ? null : groupContext.setSwitch);
  var toggle = useCallback(function () {
    return onChange(!checked);
  }, [onChange, checked]);
  var handleClick = useCallback(function (event) {
    if (isDisabledReactIssue7711(event.currentTarget)) return event.preventDefault();
    event.preventDefault();
    toggle();
  }, [toggle]);
  var handleKeyUp = useCallback(function (event) {
    if (event.key !== Keys$1.Tab) event.preventDefault();
    if (event.key === Keys$1.Space) toggle();
  }, [toggle]); // This is needed so that we can "cancel" the click event when we use the `Enter` key on a button.

  var handleKeyPress = useCallback(function (event) {
    return event.preventDefault();
  }, []);
  var slot = useMemo(function () {
    return {
      checked: checked
    };
  }, [checked]);
  var propsWeControl = {
    id: id,
    ref: switchRef,
    role: 'switch',
    type: useResolveButtonType(props, internalSwitchRef),
    tabIndex: 0,
    'aria-checked': checked,
    'aria-labelledby': groupContext == null ? void 0 : groupContext.labelledby,
    'aria-describedby': groupContext == null ? void 0 : groupContext.describedby,
    onClick: handleClick,
    onKeyUp: handleKeyUp,
    onKeyPress: handleKeyPress
  };
  return render({
    props: _extends$2({}, passThroughProps, propsWeControl),
    slot: slot,
    defaultTag: DEFAULT_SWITCH_TAG,
    name: 'Switch'
  });
} // ---

Switch.Group = Group;
Switch.Label = Label;
Switch.Description = Description;

function useIsInitialRender() {
  var initial = useRef(true);
  useEffect(function () {
    initial.current = false;
  }, []);
  return initial.current;
}

function once(cb) {
  var state = {
    called: false
  };
  return function () {
    if (state.called) return;
    state.called = true;
    return cb.apply(void 0, arguments);
  };
}

function addClasses(node) {
  var _node$classList;

  for (var _len = arguments.length, classes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    classes[_key - 1] = arguments[_key];
  }

  node && classes.length > 0 && (_node$classList = node.classList).add.apply(_node$classList, classes);
}

function removeClasses(node) {
  var _node$classList2;

  for (var _len2 = arguments.length, classes = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    classes[_key2 - 1] = arguments[_key2];
  }

  node && classes.length > 0 && (_node$classList2 = node.classList).remove.apply(_node$classList2, classes);
}

var Reason;

(function (Reason) {
  Reason["Finished"] = "finished";
  Reason["Cancelled"] = "cancelled";
})(Reason || (Reason = {}));

function waitForTransition(node, done) {
  var d = disposables();
  if (!node) return d.dispose; // Safari returns a comma separated list of values, so let's sort them and take the highest value.

  var _getComputedStyle = getComputedStyle(node),
      transitionDuration = _getComputedStyle.transitionDuration,
      transitionDelay = _getComputedStyle.transitionDelay;

  var _map = [transitionDuration, transitionDelay].map(function (value) {
    var _value$split$filter$m = value.split(',') // Remove falsy we can't work with
    .filter(Boolean) // Values are returned as `0.3s` or `75ms`
    .map(function (v) {
      return v.includes('ms') ? parseFloat(v) : parseFloat(v) * 1000;
    }).sort(function (a, z) {
      return z - a;
    }),
        _value$split$filter$m2 = _value$split$filter$m[0],
        resolvedValue = _value$split$filter$m2 === void 0 ? 0 : _value$split$filter$m2;

    return resolvedValue;
  }),
      durationMs = _map[0],
      delaysMs = _map[1]; // Waiting for the transition to end. We could use the `transitionend` event, however when no
  // actual transition/duration is defined then the `transitionend` event is not fired.
  //
  // TODO: Downside is, when you slow down transitions via devtools this timeout is still using the
  // full 100% speed instead of the 25% or 10%.


  if (durationMs !== 0) {
    d.setTimeout(function () {
      done(Reason.Finished);
    }, durationMs + delaysMs);
  } else {
    // No transition is happening, so we should cleanup already. Otherwise we have to wait until we
    // get disposed.
    done(Reason.Finished);
  } // If we get disposed before the timeout runs we should cleanup anyway


  d.add(function () {
    return done(Reason.Cancelled);
  });
  return d.dispose;
}

function transition(node, base, from, to, entered, done) {
  var d = disposables();

  var _done = done !== undefined ? once(done) : function () {};

  removeClasses.apply(void 0, [node].concat(entered));
  addClasses.apply(void 0, [node].concat(base, from));
  d.nextFrame(function () {
    removeClasses.apply(void 0, [node].concat(from));
    addClasses.apply(void 0, [node].concat(to));
    d.add(waitForTransition(node, function (reason) {
      removeClasses.apply(void 0, [node].concat(to, base));
      addClasses.apply(void 0, [node].concat(entered));
      return _done(reason);
    }));
  }); // Once we get disposed, we should ensure that we cleanup after ourselves. In case of an unmount,
  // the node itself will be nullified and will be a no-op. In case of a full transition the classes
  // are already removed which is also a no-op. However if you go from enter -> leave mid-transition
  // then we have some leftovers that should be cleaned.

  d.add(function () {
    return removeClasses.apply(void 0, [node].concat(base, from, to, entered));
  }); // When we get disposed early, than we should also call the done method but switch the reason.

  d.add(function () {
    return _done(Reason.Cancelled);
  });
  return d.dispose;
}

function useSplitClasses(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return useMemo(function () {
    return classes.split(' ').filter(function (className) {
      return className.trim().length > 1;
    });
  }, [classes]);
}

var TransitionContext = /*#__PURE__*/createContext(null);
TransitionContext.displayName = 'TransitionContext';
var TreeStates;

(function (TreeStates) {
  TreeStates["Visible"] = "visible";
  TreeStates["Hidden"] = "hidden";
})(TreeStates || (TreeStates = {}));

function useTransitionContext() {
  var context = useContext(TransitionContext);

  if (context === null) {
    throw new Error('A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.');
  }

  return context;
}

function useParentNesting() {
  var context = useContext(NestingContext);

  if (context === null) {
    throw new Error('A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.');
  }

  return context;
}

var NestingContext = /*#__PURE__*/createContext(null);
NestingContext.displayName = 'NestingContext';

function hasChildren(bag) {
  if ('children' in bag) return hasChildren(bag.children);
  return bag.current.filter(function (_ref) {
    var state = _ref.state;
    return state === TreeStates.Visible;
  }).length > 0;
}

function useNesting(done) {
  var doneRef = useRef(done);
  var transitionableChildren = useRef([]);
  var mounted = useIsMounted$1();
  useEffect(function () {
    doneRef.current = done;
  }, [done]);
  var unregister = useCallback(function (childId, strategy) {
    var _match;

    if (strategy === void 0) {
      strategy = RenderStrategy.Hidden;
    }

    var idx = transitionableChildren.current.findIndex(function (_ref2) {
      var id = _ref2.id;
      return id === childId;
    });
    if (idx === -1) return;
    match(strategy, (_match = {}, _match[RenderStrategy.Unmount] = function () {
      transitionableChildren.current.splice(idx, 1);
    }, _match[RenderStrategy.Hidden] = function () {
      transitionableChildren.current[idx].state = TreeStates.Hidden;
    }, _match));

    if (!hasChildren(transitionableChildren) && mounted.current) {
      doneRef.current == null ? void 0 : doneRef.current();
    }
  }, [doneRef, mounted, transitionableChildren]);
  var register = useCallback(function (childId) {
    var child = transitionableChildren.current.find(function (_ref3) {
      var id = _ref3.id;
      return id === childId;
    });

    if (!child) {
      transitionableChildren.current.push({
        id: childId,
        state: TreeStates.Visible
      });
    } else if (child.state !== TreeStates.Visible) {
      child.state = TreeStates.Visible;
    }

    return function () {
      return unregister(childId, RenderStrategy.Unmount);
    };
  }, [transitionableChildren, unregister]);
  return useMemo(function () {
    return {
      children: transitionableChildren,
      register: register,
      unregister: unregister
    };
  }, [register, unregister, transitionableChildren]);
}

function noop() {}

var eventNames = ['beforeEnter', 'afterEnter', 'beforeLeave', 'afterLeave'];

function ensureEventHooksExist(events) {
  var result = {};

  for (var _iterator = _createForOfIteratorHelperLoose(eventNames), _step; !(_step = _iterator()).done;) {
    var _events$name;

    var name = _step.value;
    result[name] = (_events$name = events[name]) != null ? _events$name : noop;
  }

  return result;
}

function useEvents(events) {
  var eventsRef = useRef(ensureEventHooksExist(events));
  useEffect(function () {
    eventsRef.current = ensureEventHooksExist(events);
  }, [events]);
  return eventsRef;
} // ---


var DEFAULT_TRANSITION_CHILD_TAG = 'div';
var TransitionChildRenderFeatures = Features.RenderStrategy;

function TransitionChild(props) {
  var _match3;

  var beforeEnter = props.beforeEnter,
      afterEnter = props.afterEnter,
      beforeLeave = props.beforeLeave,
      afterLeave = props.afterLeave,
      enter = props.enter,
      enterFrom = props.enterFrom,
      enterTo = props.enterTo,
      entered = props.entered,
      leave = props.leave,
      leaveFrom = props.leaveFrom,
      leaveTo = props.leaveTo,
      rest = _objectWithoutPropertiesLoose$1(props, ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"]);

  var container = useRef(null);

  var _useState = useState(TreeStates.Visible),
      state = _useState[0],
      setState = _useState[1];

  var strategy = rest.unmount ? RenderStrategy.Unmount : RenderStrategy.Hidden;

  var _useTransitionContext = useTransitionContext(),
      show = _useTransitionContext.show,
      appear = _useTransitionContext.appear,
      initial = _useTransitionContext.initial;

  var _useParentNesting = useParentNesting(),
      register = _useParentNesting.register,
      unregister = _useParentNesting.unregister;

  var id = useId$7();
  var isTransitioning = useRef(false);
  var nesting = useNesting(function () {
    // When all children have been unmounted we can only hide ourselves if and only if we are not
    // transitioning ourselves. Otherwise we would unmount before the transitions are finished.
    if (!isTransitioning.current) {
      setState(TreeStates.Hidden);
      unregister(id);
      events.current.afterLeave();
    }
  });
  useIsoMorphicEffect(function () {
    if (!id) return;
    return register(id);
  }, [register, id]);
  useIsoMorphicEffect(function () {
    var _match2;

    // If we are in another mode than the Hidden mode then ignore
    if (strategy !== RenderStrategy.Hidden) return;
    if (!id) return; // Make sure that we are visible

    if (show && state !== TreeStates.Visible) {
      setState(TreeStates.Visible);
      return;
    }

    match(state, (_match2 = {}, _match2[TreeStates.Hidden] = function () {
      return unregister(id);
    }, _match2[TreeStates.Visible] = function () {
      return register(id);
    }, _match2));
  }, [state, id, register, unregister, show, strategy]);
  var enterClasses = useSplitClasses(enter);
  var enterFromClasses = useSplitClasses(enterFrom);
  var enterToClasses = useSplitClasses(enterTo);
  var enteredClasses = useSplitClasses(entered);
  var leaveClasses = useSplitClasses(leave);
  var leaveFromClasses = useSplitClasses(leaveFrom);
  var leaveToClasses = useSplitClasses(leaveTo);
  var events = useEvents({
    beforeEnter: beforeEnter,
    afterEnter: afterEnter,
    beforeLeave: beforeLeave,
    afterLeave: afterLeave
  });
  var ready = useServerHandoffComplete();
  useEffect(function () {
    if (ready && state === TreeStates.Visible && container.current === null) {
      throw new Error('Did you forget to passthrough the `ref` to the actual DOM node?');
    }
  }, [container, state, ready]); // Skipping initial transition

  var skip = initial && !appear;
  useIsoMorphicEffect(function () {
    var node = container.current;
    if (!node) return;
    if (skip) return;
    isTransitioning.current = true;
    if (show) events.current.beforeEnter();
    if (!show) events.current.beforeLeave();
    return show ? transition(node, enterClasses, enterFromClasses, enterToClasses, enteredClasses, function (reason) {
      isTransitioning.current = false;
      if (reason === Reason.Finished) events.current.afterEnter();
    }) : transition(node, leaveClasses, leaveFromClasses, leaveToClasses, enteredClasses, function (reason) {
      isTransitioning.current = false;
      if (reason !== Reason.Finished) return; // When we don't have children anymore we can safely unregister from the parent and hide
      // ourselves.

      if (!hasChildren(nesting)) {
        setState(TreeStates.Hidden);
        unregister(id);
        events.current.afterLeave();
      }
    });
  }, [events, id, isTransitioning, unregister, nesting, container, skip, show, enterClasses, enterFromClasses, enterToClasses, leaveClasses, leaveFromClasses, leaveToClasses]);
  var propsWeControl = {
    ref: container
  };
  var passthroughProps = rest;
  return React__default.createElement(NestingContext.Provider, {
    value: nesting
  }, React__default.createElement(OpenClosedProvider, {
    value: match(state, (_match3 = {}, _match3[TreeStates.Visible] = State.Open, _match3[TreeStates.Hidden] = State.Closed, _match3))
  }, render({
    props: _extends$2({}, passthroughProps, propsWeControl),
    defaultTag: DEFAULT_TRANSITION_CHILD_TAG,
    features: TransitionChildRenderFeatures,
    visible: state === TreeStates.Visible,
    name: 'Transition.Child'
  })));
}

function Transition(props) {
  // @ts-expect-error
  var show = props.show,
      _props$appear = props.appear,
      appear = _props$appear === void 0 ? false : _props$appear,
      unmount = props.unmount,
      passthroughProps = _objectWithoutPropertiesLoose$1(props, ["show", "appear", "unmount"]);

  var usesOpenClosedState = useOpenClosed();

  if (show === undefined && usesOpenClosedState !== null) {
    var _match4;

    show = match(usesOpenClosedState, (_match4 = {}, _match4[State.Open] = true, _match4[State.Closed] = false, _match4));
  }

  if (![true, false].includes(show)) {
    throw new Error('A <Transition /> is used but it is missing a `show={true | false}` prop.');
  }

  var _useState2 = useState(show ? TreeStates.Visible : TreeStates.Hidden),
      state = _useState2[0],
      setState = _useState2[1];

  var nestingBag = useNesting(function () {
    setState(TreeStates.Hidden);
  });
  var initial = useIsInitialRender();
  var transitionBag = useMemo(function () {
    return {
      show: show,
      appear: appear || !initial,
      initial: initial
    };
  }, [show, appear, initial]);
  useEffect(function () {
    if (show) {
      setState(TreeStates.Visible);
    } else if (!hasChildren(nestingBag)) {
      setState(TreeStates.Hidden);
    }
  }, [show, nestingBag]);
  var sharedProps = {
    unmount: unmount
  };
  return React__default.createElement(NestingContext.Provider, {
    value: nestingBag
  }, React__default.createElement(TransitionContext.Provider, {
    value: transitionBag
  }, render({
    props: _extends$2({}, sharedProps, {
      as: Fragment$1,
      children: React__default.createElement(TransitionChild, Object.assign({}, sharedProps, passthroughProps))
    }),
    defaultTag: Fragment$1,
    features: TransitionChildRenderFeatures,
    visible: state === TreeStates.Visible,
    name: 'Transition'
  })));
}

Transition.Child = function Child(props) {
  var hasTransitionContext = useContext(TransitionContext) !== null;
  var hasOpenClosedContext = useOpenClosed() !== null;
  return !hasTransitionContext && hasOpenClosedContext ? React__default.createElement(Transition, Object.assign({}, props)) : React__default.createElement(TransitionChild, Object.assign({}, props));
};

Transition.Root = Transition;

function ArrowDownIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l4.293-4.293a1 1 0 011.414 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$w = React.forwardRef(ArrowDownIcon);
var ArrowDownIcon$1 = ForwardRef$w;

function ArrowLeftIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$v = React.forwardRef(ArrowLeftIcon);
var ArrowLeftIcon$1 = ForwardRef$v;

function ArrowRightIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$u = React.forwardRef(ArrowRightIcon);
var ArrowRightIcon$1 = ForwardRef$u;

function ArrowUpIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$t = React.forwardRef(ArrowUpIcon);
var ArrowUpIcon$1 = ForwardRef$t;

function CalendarIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$s = React.forwardRef(CalendarIcon);
var CalendarIcon$1 = ForwardRef$s;

function CheckCircleIcon$2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$r = React.forwardRef(CheckCircleIcon$2);
var CheckCircleIcon$3 = ForwardRef$r;

function ChevronDoubleLeftIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$q = React.forwardRef(ChevronDoubleLeftIcon);
var ChevronDoubleLeftIcon$1 = ForwardRef$q;

function ChevronDoubleRightIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$p = React.forwardRef(ChevronDoubleRightIcon);
var ChevronDoubleRightIcon$1 = ForwardRef$p;

function ChevronDownIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$o = React.forwardRef(ChevronDownIcon);
var ChevronDownIcon$1 = ForwardRef$o;

function ChevronLeftIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$n = React.forwardRef(ChevronLeftIcon);
var ChevronLeftIcon$1 = ForwardRef$n;

function ChevronRightIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$m = React.forwardRef(ChevronRightIcon);
var ChevronRightIcon$1 = ForwardRef$m;

function ChevronUpIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$l = React.forwardRef(ChevronUpIcon);
var ChevronUpIcon$1 = ForwardRef$l;

function ClockIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$k = React.forwardRef(ClockIcon);
var ClockIcon$1 = ForwardRef$k;

function DotsCircleHorizontalIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$j = React.forwardRef(DotsCircleHorizontalIcon);
var DotsCircleHorizontalIcon$1 = ForwardRef$j;

function DotsHorizontalIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"
  }));
}

const ForwardRef$i = React.forwardRef(DotsHorizontalIcon);
var DotsHorizontalIcon$1 = ForwardRef$i;

function DotsVerticalIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
  }));
}

const ForwardRef$h = React.forwardRef(DotsVerticalIcon);
var DotsVerticalIcon$1 = ForwardRef$h;

function ExclamationCircleIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$g = React.forwardRef(ExclamationCircleIcon);
var ExclamationCircleIcon$1 = ForwardRef$g;

function ExclamationIcon$2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$f = React.forwardRef(ExclamationIcon$2);
var ExclamationIcon$3 = ForwardRef$f;

function EyeOffIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
  }));
}

const ForwardRef$e = React.forwardRef(EyeOffIcon);
var EyeOffIcon$1 = ForwardRef$e;

function EyeIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 12a2 2 0 100-4 2 2 0 000 4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$d = React.forwardRef(EyeIcon);
var EyeIcon$1 = ForwardRef$d;

function InformationCircleIcon$2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$c = React.forwardRef(InformationCircleIcon$2);
var InformationCircleIcon$3 = ForwardRef$c;

function MenuAlt1Icon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$b = React.forwardRef(MenuAlt1Icon);
var MenuAlt1Icon$1 = ForwardRef$b;

function SearchIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$a = React.forwardRef(SearchIcon);
var SearchIcon$1 = ForwardRef$a;

function XCircleIcon$2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$9 = React.forwardRef(XCircleIcon$2);
var XCircleIcon$3 = ForwardRef$9;

function XIcon$2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}

const ForwardRef$8 = React.forwardRef(XIcon$2);
var XIcon$3 = ForwardRef$8;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

function ButtonGroup(props) {
    var _a;
    var children = props.children, style = props.style, className = props.className, appearance = props.appearance, size = props.size, rest = __rest(props, ["children", "style", "className", "appearance", "size"]);
    return (React__default.createElement("span", __assign({ className: classnames("group-btn", (_a = {},
            _a[className] = className,
            _a)), style: style }, rest), React__default.Children.map(children, function (child) { return React__default.cloneElement(child, { appearance: appearance, size: size }); })));
}

var LoadingIcon = function (_a) {
    var className = _a.className;
    return (React__default.createElement("svg", { className: classnames("loading", className), xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
        React__default.createElement("circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "3" }),
        React__default.createElement("path", { fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })));
};

var ForwardedButton = React__default.forwardRef(function Button(_a, ref) {
    var _b;
    var icon = _a.icon, intent = _a.intent, block = _a.block, isLoading = _a.isLoading, isDisabled = _a.isDisabled, className = _a.className, style = _a.style, children = _a.children, size = _a.size, iconPos = _a.iconPos, appearance = _a.appearance, props = __rest(_a, ["icon", "intent", "block", "isLoading", "isDisabled", "className", "style", "children", "size", "iconPos", "appearance"]);
    var iconNode = null;
    if (icon && !isLoading) {
        iconNode = icon;
    }
    else if (isLoading) {
        iconNode = React__default.createElement(LoadingIcon, null);
    }
    return (React__default.createElement("button", __assign({ type: "button" }, props, { disabled: isDisabled, className: classnames("btn", (_b = {
                "btn-block": block && appearance !== "text"
            },
            _b["btn-intent-".concat(intent)] = intent &&
                (appearance === "text" ||
                    (appearance === "primary" && ["success", "danger"].includes(intent))),
            _b["btn-loading"] = isLoading,
            _b["btn-icon-only"] = iconNode !== null && React__default.Children.count(children) === 0,
            _b["btn-".concat(appearance)] = true,
            _b["btn-icon-".concat(iconPos)] = true,
            _b["btn-".concat(size)] = true,
            _b[className] = className,
            _b)), ref: ref, style: style }),
        block && appearance !== "text" && iconNode ? (React__default.createElement("span", { className: "btn-block-icon" }, iconNode)) : (iconNode),
        React__default.createElement("span", { className: "btn-text-wrapper" }, children)));
});
ForwardedButton.defaultProps = {
    appearance: "default",
    isDisabled: false,
    isLoading: false,
    block: false,
    size: "md",
    iconPos: "left"
};
var Button = ForwardedButton;
Button.Group = ButtonGroup;

var iconsMap = {
    info: React__default.createElement(InformationCircleIcon$3, null),
    success: React__default.createElement(CheckCircleIcon$3, null),
    danger: React__default.createElement(XCircleIcon$3, null),
    warning: React__default.createElement(ExclamationIcon$3, null)
};
function Alert(_a) {
    var _b;
    var title = _a.title, intent = _a.intent, closable = _a.closable, className = _a.className, style = _a.style, children = _a.children;
    var _c = __read(useState(true), 2), display = _c[0], setDisplay = _c[1];
    var close = useCallback(function () { return setDisplay(false); }, []);
    var node = (React__default.createElement("div", { className: "alert-inner" },
        React__default.createElement("div", { className: "alert-icon" }, iconsMap[intent]),
        React__default.createElement("div", { className: "alert-wrapper" },
            title && React__default.createElement("h3", { className: "alert-title" }, title),
            children !== undefined && (React__default.createElement("div", { className: "alert-body" }, typeof children === "string" ? React__default.createElement("p", null, children) : children))),
        closable && (React__default.createElement("div", { className: "alert-close" },
            React__default.createElement("div", { className: "alert-close-inner" },
                React__default.createElement(Button, { icon: React__default.createElement(XIcon$3, null), intent: intent, appearance: "text", onClick: close, "aria-label": "Dismiss" }))))));
    var props = {
        role: "alert",
        style: style,
        className: classnames("alert", (_b = {},
            _b["alert-".concat(intent)] = true,
            _b[className] = className,
            _b))
    };
    if (closable)
        return (React__default.createElement(Transition, __assign({ show: display, enter: "alert-transition-enter", enterFrom: "alert-transition-enter-from", enterTo: "alert-transition-enter-to", leave: "alert-transition-leave", leaveFrom: "alert-transition-leave-from", leaveTo: "alert-transition-leave-to" }, props), node));
    return React__default.createElement("div", __assign({}, props), node);
}
Alert.defaultProps = {
    intent: "info",
    closable: false
};

function Badge(_a) {
    var _b;
    var size = _a.size, intent = _a.intent, className = _a.className, style = _a.style, children = _a.children;
    return (React__default.createElement("span", { className: classnames("badge", (_b = {},
            _b[className] = className,
            _b["badge-".concat(size)] = true,
            _b["badge-intent-".concat(intent)] = true,
            _b)), style: style }, children));
}
Badge.defaultProps = {
    size: "md"
};

function InternalBreadcrumb(props) {
    var _a;
    var children = props.children, style = props.style, className = props.className;
    return (React__default.createElement("nav", { className: classnames("breadcrumb", (_a = {},
            _a[className] = className,
            _a)), "aria-label": props["aria-label"], style: style },
        React__default.createElement("ol", { className: "breadcrumb-wrapper" }, React__default.Children.map(children, function (child, idx) {
            if (React__default.isValidElement(child)) {
                return React__default.cloneElement(child, {
                    hasSeparator: idx + 1 !== React__default.Children.count(children)
                });
            }
        }))));
}
function BreadcrumbItem(_a) {
    var _b;
    var children = _a.children, className = _a.className, href = _a.href, style = _a.style, _c = _a.hasSeparator, hasSeparator = _c === void 0 ? true : _c;
    var link;
    var linkClassName = classnames("breadcrumb-item", {
        "breadcrumb-item-current": !hasSeparator
    });
    if (href) {
        link = (React__default.createElement("a", { className: linkClassName, href: href }, children));
    }
    else {
        link = React__default.createElement("span", { className: linkClassName }, children);
    }
    return (React__default.createElement("li", { className: classnames((_b = {}, _b[className] = className, _b)), style: style },
        React__default.createElement("div", { className: "breadcrumb-item-content" },
            link,
            hasSeparator && React__default.createElement(ChevronRightIcon$1, { className: "breadcrumb-separator", "aria-hidden": "true" }))));
}
var Breadcrumb = InternalBreadcrumb;
Breadcrumb.Item = BreadcrumbItem;
BreadcrumbItem.displayName = "Breadcrumb.Item";

function InternalIconButton(_a, ref) {
    var _b;
    var children = _a.children, style = _a.style, className = _a.className, props = __rest(_a, ["children", "style", "className"]);
    return (React__default.createElement("button", __assign({ className: classnames("icon-btn", (_b = {},
            _b[className] = className,
            _b)), style: style, ref: ref, type: props.type }, props), children));
}
var IconButton = React__default.forwardRef(InternalIconButton);
IconButton.defaultProps = {
    type: "button"
};

function Checkbox(_a) {
    var _b;
    var _c;
    var checked = _a.checked, onChange = _a.onChange, value = _a.value, children = _a.children, className = _a.className, style = _a.style, isDisabled = _a.isDisabled, isIndeterminate = _a.isIndeterminate, help = _a.help;
    var ref = useRef();
    useEffect(function () {
        if (ref.current) {
            ref.current.indeterminate = isIndeterminate;
        }
    });
    var context = useContext(CheckboxGroupContext);
    var isChecked;
    if (context) {
        isChecked = (_c = context.value) === null || _c === void 0 ? void 0 : _c.includes(value);
    }
    else {
        isChecked = checked;
    }
    return (React__default.createElement("label", { className: classnames("checkbox-container", (_b = {
                "checkbox-container-disabled": isDisabled,
                "checkbox-container-with-help": Boolean(help)
            },
            _b[className] = className,
            _b)), style: style },
        React__default.createElement("input", { ref: ref, className: "checkbox", type: "checkbox", checked: isChecked, disabled: isDisabled, onChange: function (e) {
                if (context) {
                    context.setValue(value);
                }
                else {
                    if (typeof onChange === "function")
                        onChange(e.target.checked);
                }
            }, "aria-checked": isIndeterminate ? "mixed" : isChecked }),
        help ? (React__default.createElement("div", null,
            React__default.createElement("span", { className: "checkbox-text checkbox-text-withhelp" }, children),
            React__default.createElement("p", { className: "checkbox-text-help" }, help))) : (children && React__default.createElement("span", { className: "checkbox-text" }, children))));
}
Checkbox.Group = CheckboxGroup;
var CheckboxGroupContext = React__default.createContext(null);
function CheckboxGroup(_a) {
    var _b;
    var onChange = _a.onChange, value = _a.value, children = _a.children, _c = _a.orientation, orientation = _c === void 0 ? "horizontal" : _c;
    return (React__default.createElement("div", { role: "group", className: classnames("checkbox-group", (_b = {},
            _b["checkbox-group-".concat(orientation)] = true,
            _b)) },
        React__default.createElement(CheckboxGroupContext.Provider, { value: {
                value: value,
                setValue: function (val) {
                    var values = new Set(value);
                    if (!values.has(val))
                        values.add(val);
                    else
                        values.delete(val);
                    onChange(Array.from(values));
                }
            } }, children)));
}

function useControlledState(value, defaultValue, onChange) {
    if (typeof value === "function") {
        throw new TypeError("Les fonctions ne sont pas supportées en tant que valeurs.");
    }
    const [stateValue, setStateValue] = useState(value || defaultValue);
    const ref = useRef(value !== undefined);
    const isControlled = value !== undefined;
    const stateRef = useRef(stateValue);
    ref.current = isControlled;
    const setValue = useCallback((value, ...args) => {
        const onChangeCaller = (value, ...onChangeArgs) => {
            if (onChange) {
                if (stateRef.current !== value) {
                    if (typeof value === "function")
                        onChange(value(stateRef.current), ...onChangeArgs);
                    else
                        onChange(value, ...onChangeArgs);
                }
            }
            if (!isControlled) {
                stateRef.current = value;
            }
        };
        if (!isControlled) {
            setStateValue(value);
        }
        onChangeCaller(value, ...args);
    }, [isControlled, onChange]);
    if (isControlled) {
        stateRef.current = value;
    }
    else {
        value = stateValue;
    }
    return [value, setValue];
}

/**
 * Exécute un effect lors du unmount d'un composant
 */
function useUnmountEffect(effect) {
    useEffect(() => () => {
        effect();
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
}

/**
 * Comme `useCallback` mais la fonction est debounced
 *
 * @param callback
 * @param deps Liste des dépendances de `useCallback`
 * @param delay Délai.
 * @param maxWait Le temps maximum que `callback` est autorisé à être retardé avant d'être invoquée. 0 signifie pas d'attente maximale.
 */
function useDebouncedCallback(callback, deps, delay, maxWait = 0) {
    const timeout = useRef();
    const waitTimeout = useRef();
    const lastCall = useRef();
    const clear = () => {
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = undefined;
        }
        if (waitTimeout.current) {
            clearTimeout(waitTimeout.current);
            waitTimeout.current = undefined;
        }
    };
    // Annule l'exécution planifiée au unmount
    useUnmountEffect(clear);
    return useMemo(() => {
        const execute = () => {
            if (!lastCall.current)
                return;
            const context = lastCall.current;
            lastCall.current = undefined;
            callback.apply(context.this, context.args);
            clear();
        };
        const wrapped = function (...args) {
            if (timeout.current) {
                clearTimeout(timeout.current);
            }
            lastCall.current = { args, this: this };
            // planifie l'exécution
            timeout.current = setTimeout(execute, delay);
            // planifie l'exécution avec un délai maximum
            if (maxWait > 0 && !waitTimeout.current) {
                waitTimeout.current = setTimeout(execute, maxWait);
            }
        };
        Object.defineProperties(wrapped, {
            length: { value: callback.length },
            name: { value: `${callback.name || "anonymous"}__debounced__${delay}` }
        });
        return wrapped;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [delay, maxWait, ...deps]);
}

/**
 * Retourne une fonction qui donne si le composant est monté.
 *
 */
function useIsMounted() {
    const isMounted = useRef(false);
    const get = useCallback(() => isMounted.current, []);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return get;
}

/**
 * Comme `useState` mais est protégé sur les composants non montés.
 */
function useSafeState(initialState) {
    const [state, setState] = useState(initialState);
    const isMounted = useIsMounted();
    return [
        state,
        useCallback((value) => {
            if (isMounted())
                setState(value);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])
    ];
}

/**
 * Comme `useSafeState` mais debounced.
 *
 * @param initialState Initial state to pass to underlying `useSafeState`.
 * @param delay Délai.
 * @param maxWait Temps maximum autorisé à être retardé. 0 signifie pas d'attente maximale.
 */
function useDebouncedState(initialState, delay, maxWait = 0) {
    const [state, setState] = useSafeState(initialState);
    return [state, useDebouncedCallback(setState, [], delay, maxWait)];
}

// eslint-disable-next-line @typescript-eslint/ban-types
function useTimeout(fn, delay) {
    const timeout = useRef();
    const callback = useRef(fn);
    const set = useCallback(() => {
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            callback.current();
        }, delay);
    }, [delay]);
    const clear = useCallback(() => {
        timeout.current && clearTimeout(timeout.current);
    }, []);
    useEffect(() => {
        callback.current = fn;
    }, [fn]);
    useEffect(() => {
        set();
        return clear;
    }, [delay, clear, set]);
    return { clear, reset: set };
}

const stateChanger = (state) => !state;
/**
 * Retourne une fonction qui force un re-render du composant
 */
function useForceUpdate() {
    const [, setState] = useSafeState(false);
    return useCallback(() => {
        setState(stateChanger);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

const isBrowser$4 = typeof window !== "undefined" &&
    typeof navigator !== "undefined" &&
    typeof document !== "undefined";
/**
 * Quand utiliser ce hook ? À chaque fois qu'on utilise un useLayoutEffect qui peut potentiellement se passer en SSR
 * (useLayoutEffect pas disponible en SSR)
 */
const useIsomorphicEffect = isBrowser$4 ? useLayoutEffect : useEffect;

let serverHandoffComplete = false;
let id = 0;
const genId = () => ++id;
/**
 * @deprecated utiliser `useId` de react 18 à la place
 * Auto-génère des ID pour l'accessibilité et le SSR
 *
 * https://github.com/reach/reach-ui/blob/develop/packages/auto-id/src/index.tsx
 */
const useId$6 = () => {
    const initialId = serverHandoffComplete ? genId() : null;
    const [id, setId] = useState(initialId);
    useIsomorphicEffect(() => {
        if (id === null) {
            setId(genId());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (serverHandoffComplete === false) {
            serverHandoffComplete = true;
        }
    }, []);
    return id != null ? String(id) : undefined;
};

/**
 * @param element Détecte si il y a une intéraction en déhors de l'élement
 * @param onInteractOutside Fonction appelée quand il y a une intéraction en dehors
 */
function useInteractOutside(element, onInteractOutside) {
    const stateRef = useRef({
        isPointerDown: false
    });
    const state = stateRef.current;
    useEffect(() => {
        const onPointerDown = (e) => {
            if (isValidEvent(e, element)) {
                state.isPointerDown = true;
                if (e.button === 0) {
                    e.preventDefault();
                }
            }
        };
        const onPointerUp = (e) => {
            if (state.isPointerDown && onInteractOutside && isValidEvent(e, element)) {
                state.isPointerDown = false;
                onInteractOutside(e);
                if (e.button === 0) {
                    e.preventDefault();
                }
            }
        };
        document.addEventListener("pointerdown", onPointerDown, true);
        document.addEventListener("pointerup", onPointerUp, true);
        return () => {
            document.removeEventListener("pointerdown", onPointerDown, true);
            document.removeEventListener("pointerup", onPointerUp, true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onInteractOutside, element, state.isPointerDown]);
}
function isValidEvent(e, element) {
    if (e.button > 0) {
        return false;
    }
    if (e.target) {
        const ownerDocument = e.target.ownerDocument;
        if (!ownerDocument) {
            return false;
        }
    }
    return element && !element.contains(e.target);
}

/**
 * Retourne la valeur passée au hook lors du render précédent.
 * @param value Valeur à garder en mémoire
 */
function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

/**
 * Comme `useRef`, mais retourne une ref immuable qui contient la valeur réelle.
 */
function useSyncedRef(value) {
    const _ref = useRef(value);
    _ref.current = value;
    return useMemo(() => Object.freeze({
        get current() {
            return _ref.current;
        }
    }), []);
}

const isBrowser$2 = typeof window !== "undefined" &&
    typeof navigator !== "undefined" &&
    typeof document !== "undefined";
let IS_LOCAL_STORAGE_AVAILABLE = false;
try {
    IS_LOCAL_STORAGE_AVAILABLE = isBrowser$2 && !!window.localStorage;
}
catch (_a) {
    IS_LOCAL_STORAGE_AVAILABLE = false;
}

let observerSingleton;
function getResizeObserver() {
    if (typeof window === "undefined")
        return undefined;
    if (observerSingleton)
        return observerSingleton;
    const callbacks = new Map();
    const observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => { var _a; return (_a = callbacks.get(entry.target)) === null || _a === void 0 ? void 0 : _a.forEach((cb) => setTimeout(() => cb(entry), 0)); });
    });
    observerSingleton = {
        observer,
        subscribe: (target, callback) => {
            let cbs = callbacks.get(target);
            if (!cbs) {
                // si la cible n'a pas encore d'observer on la register
                cbs = new Set();
                callbacks.set(target, cbs);
                observer.observe(target);
            }
            cbs.add(callback);
        },
        unsubscribe: (target, callback) => {
            const cbs = callbacks.get(target);
            if (cbs) {
                cbs.delete(callback);
                if (!cbs.size) {
                    // si aucun observateur unregister complètement la cible
                    callbacks.delete(target);
                    observer.unobserve(target);
                }
            }
        }
    };
    return observerSingleton;
}
/**
 * Appelle un callback chaque fois que ResizeObserver détecte une modification de la taille de la cible.
 *
 * @param target Ref React ou Element à observer.
 * @param callback Callback appelé quand la taille change.
 */
function useResizeObserver(target, callback) {
    const ro = getResizeObserver();
    const cb = useSyncedRef(callback);
    useEffect(() => {
        if (!ro)
            return;
        let subscribed = true;
        const tgt = target && "current" in target ? target.current : target;
        if (!tgt)
            return;
        const handler = (...args) => {
            if (subscribed) {
                cb.current(...args);
            }
        };
        ro.subscribe(tgt, handler);
        return () => {
            subscribed = false;
            ro.unsubscribe(tgt, handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, ro]);
}

const isBrowser$1$1 = typeof window !== "undefined" &&
    typeof navigator !== "undefined" &&
    typeof document !== "undefined";
const queriesMap = new Map();
const querySubscribe = (query, setState) => {
    let entry = queriesMap.get(query);
    if (!entry) {
        const mql = matchMedia(query);
        const dispatchers = new Set();
        const listener = () => {
            dispatchers.forEach((d) => d(mql.matches));
        };
        if (mql.addEventListener)
            mql.addEventListener("change", listener, { passive: true });
        else
            mql.addListener(listener);
        entry = {
            mql,
            dispatchers,
            listener
        };
        queriesMap.set(query, entry);
    }
    entry.dispatchers.add(setState);
    setState(entry.mql.matches, true);
};
const queryUnsubscribe = (query, setState) => {
    const entry = queriesMap.get(query);
    if (entry) {
        const { mql, dispatchers, listener } = entry;
        dispatchers.delete(setState);
        if (!dispatchers.size) {
            queriesMap.delete(query);
            if (mql.removeEventListener)
                mql.removeEventListener("change", listener);
            else
                mql.removeListener(listener);
        }
    }
};
/**
 * Observe l'état d'une media query CSS
 *
 * Renvoi `false` dans les environnements SSR
 *
 * @param query media query CSS.
 * @param matchOnMount si l'état du hook doit être récupéré pendant un `useEffect` au lieu de la récupération synchrone.
 * Mettez ce paramètre à `true` pour les cas d'utilisation de SSR.
 */
function useMediaQuery(query, matchOnMount) {
    const rerender = useForceUpdate();
    const previousQuery = usePrevious(query);
    const state = useRef();
    const setState = useCallback((matches, initial) => {
        if (state.current !== matches) {
            state.current = matches;
            if (!initial || matchOnMount)
                rerender();
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [matchOnMount]);
    if (!matchOnMount && isBrowser$1$1 && previousQuery !== query) {
        querySubscribe(query, setState);
    }
    useEffect(() => {
        if (matchOnMount) {
            querySubscribe(query, setState);
        }
        return () => queryUnsubscribe(query, setState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);
    return state.current;
}

function usePreventScroll(isActive) {
    useEffect(() => {
        const { paddingRight, overflow } = document.body.style;
        if (isActive) {
            document.body.style.paddingRight = `${window.innerWidth - document.documentElement.clientWidth}px`;
            document.body.style.overflow = "hidden";
        }
        return () => {
            document.body.style.overflow = overflow;
            document.body.style.paddingRight = paddingRight;
        };
    }, [isActive]);
}

const isBrowser$3 = typeof window !== "undefined" &&
    typeof navigator !== "undefined" &&
    typeof document !== "undefined";
let IS_SESSION_STORAGE_AVAILABLE = false;
try {
    IS_SESSION_STORAGE_AVAILABLE = isBrowser$3 && !!window.sessionStorage;
}
catch (_a) {
    IS_SESSION_STORAGE_AVAILABLE = false;
}

function useWindowEvent(event, listener, options) {
    useEffect(() => {
        window.addEventListener(event, listener, options);
        return () => window.removeEventListener(event, listener, options);
    }, [event, listener, options]);
}

var RadioGroupContext = React__default.createContext(null);
function RadioGroup(_a) {
    var _b;
    var value = _a.value, onChange = _a.onChange, children = _a.children, _c = _a.orientation, orientation = _c === void 0 ? "horizontal" : _c, _d = _a.isSuperRadioGroup, isSuperRadioGroup = _d === void 0 ? false : _d;
    // Force orientation vertical en mode super
    if (isSuperRadioGroup) {
        orientation = "vertical";
    }
    return (React__default.createElement(RadioGroupContext.Provider, { value: { currentValue: value, onChange: onChange } },
        React__default.createElement("div", { role: "radiogroup", className: classnames("form-radio-group", (_b = {},
                _b["form-radio-group-".concat(orientation)] = true,
                _b["form-super-radio-group"] = isSuperRadioGroup,
                _b)) }, children)));
}
function Radio(_a) {
    var value = _a.value, children = _a.children, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, help = _a.help;
    var _c = useContext(RadioGroupContext), currentValue = _c.currentValue, onChange = _c.onChange;
    var checked = value === currentValue;
    return (React__default.createElement("label", { className: classnames("form-radio-label", {
            "form-radio-label-disabled": isDisabled,
            "form-radio-label-with-help": Boolean(help),
            "form-radio-checked": checked
        }) },
        React__default.createElement("input", { type: "radio", className: "form-radio", disabled: isDisabled, checked: checked, onChange: function (e) {
                if (e.target.checked && !isDisabled) {
                    onChange(value);
                }
            } }),
        help ? (React__default.createElement("div", null,
            React__default.createElement("span", { className: "form-radio-text" }, children),
            React__default.createElement("p", { className: "form-radio-help" }, help))) : (React__default.createElement("span", { className: "form-radio-text" }, children))));
}
Radio.Group = RadioGroup;

function InternalInput(_a, ref) {
    var _b;
    var addonAfter = _a.addonAfter, addonBefore = _a.addonBefore, trailingIcon = _a.trailingIcon, leadingIcon = _a.leadingIcon, className = _a.className, style = _a.style, validationState = _a.validationState, keepTrailingIconWithError = _a.keepTrailingIconWithError, allowClear = _a.allowClear, isLoading = _a.isLoading, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange, _c = _a.size, size = _c === void 0 ? "md" : _c, props = __rest(_a, ["addonAfter", "addonBefore", "trailingIcon", "leadingIcon", "className", "style", "validationState", "keepTrailingIconWithError", "allowClear", "isLoading", "value", "defaultValue", "onChange", "size"]);
    var _d = __read(useControlledState(value, defaultValue || "", onChange), 2), internalValue = _d[0], internalOnChange = _d[1];
    var clear = useCallback(function () { return internalOnChange(""); }, [internalOnChange]);
    var hasError = validationState === "invalid";
    var hasClearIcon = allowClear && internalValue;
    var hasTrailingIcon = isLoading || hasClearIcon || hasError || trailingIcon !== undefined;
    var trailingNode = useMemo(function () {
        return hasError && !keepTrailingIconWithError ? (React__default.createElement(ExclamationCircleIcon$1, null)) : hasError && keepTrailingIconWithError ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(ExclamationCircleIcon$1, null),
            isLoading ? React__default.createElement(LoadingIcon, null) : trailingIcon !== undefined && trailingIcon,
            hasClearIcon && React__default.createElement(XCircleIcon$3, { className: "form-input-icon-clear", onClick: clear }))) : (React__default.createElement(React__default.Fragment, null,
            isLoading ? React__default.createElement(LoadingIcon, null) : trailingIcon !== undefined && trailingIcon,
            hasClearIcon && React__default.createElement(XCircleIcon$3, { className: "form-input-icon-clear", onClick: clear })));
    }, [hasError, keepTrailingIconWithError, hasClearIcon, trailingIcon, isLoading, clear]);
    return (React__default.createElement("div", { className: classnames("form-input-wrapper", (_b = {
                "form-input-wrapper-withaddon": addonBefore || addonAfter,
                "form-input-error": hasError
            },
            _b[className] = className,
            _b)) },
        addonBefore && React__default.createElement("span", { className: "form-input-addon-before" }, addonBefore),
        leadingIcon && (React__default.createElement("div", { className: classnames("form-input-icon form-input-icon-leading", {
                "form-input-icon-leading-withaddon": addonBefore
            }) }, leadingIcon)),
        React__default.createElement("input", __assign({}, props, { className: classnames("form-input", {
                "form-input-sm": size === "sm",
                "form-input-withaddon-before": addonBefore,
                "form-input-withaddon-after": addonAfter,
                "form-input-withicon-leading": leadingIcon,
                "form-input-withicon-trailing1": (trailingIcon || hasClearIcon || hasError) && !keepTrailingIconWithError,
                "form-input-withicon-trailing2": (trailingIcon || hasClearIcon) && hasError && keepTrailingIconWithError,
                "form-input-withicon-trailing3": trailingIcon && hasClearIcon && hasError && keepTrailingIconWithError
            }), style: style, ref: ref, value: internalValue, onChange: function (e) { return internalOnChange(e.target.value); } })),
        hasTrailingIcon && (React__default.createElement("div", { className: classnames("form-input-icon form-input-icon-trailing", {
                "form-input-icon-trailing-withaddon": addonAfter
            }) }, trailingNode)),
        addonAfter && React__default.createElement("span", { className: "form-input-addon-after" }, addonAfter)));
}
var Input$1 = React__default.forwardRef(InternalInput);
Input$1.defaultProps = {
    type: "text",
    keepTrailingIconWithError: false,
    allowClear: false
};

function RelativeDate(_a) {
    var close = _a.close, lib = _a.lib, relativeDate = _a.relativeDate, currentDate = _a.currentDate, setCurrentDate = _a.setCurrentDate;
    var _b = __read(useState(relativeDate), 2), rDate = _b[0], setRDate = _b[1];
    var isWide = useMediaQuery("(min-width: 640px)", true);
    var ref = useRef();
    useInteractOutside(ref.current, close);
    var quantity = function (term) {
        return Math.abs(rDate[term]) !== 1 && rDate[term] !== 0 ? "plural" : "single";
    };
    var updateValue = function (term) { return function (value) {
        setRDate(function (v) {
            var _a;
            return (__assign(__assign({}, v), (_a = {}, _a[term] = Number(value), _a)));
        });
    }; };
    var updateFromNow = function (fnw) { return setRDate(function (date) { return (__assign(__assign({}, date), { fromNow: Number(fnw) })); }); };
    var _relativedate = __assign({}, currentDate);
    for (var period in _relativedate)
        _relativedate[period] = currentDate[period] + rDate[period] * rDate.fromNow;
    var validate = function () {
        var year = _relativedate.year, month = _relativedate.month, day = _relativedate.day;
        var kDate = lib.keyedDate(new Date(year, month, day));
        setCurrentDate(kDate);
        setRDate(__assign(__assign({}, lib.nullDate), { fromNow: rDate.fromNow }));
        close();
    };
    var viewdate = lib.localePattern.format(_relativedate);
    var size = "sm";
    var optionsPeriod = Object.keys(lib.relative.dateTerms).map(function (term) { return (React__default.createElement("div", { key: term, className: "panel-relative-outer-input" },
        React__default.createElement(Input$1, { min: "0", step: "1", type: "number", size: size, value: rDate[term] || "", className: "panel-relative-input", onChange: updateValue(term) }),
        React__default.createElement("label", { className: classnames("panel-relative-label", size) }, lib.relative.dateTerms[term][quantity(term)]))); });
    var optionsFomNow = Object.keys(lib.relative.vueFromNow).map(function (term) { return (React__default.createElement(Radio, { key: term, value: lib.relative.vueFromNow[term].value.toString() }, lib.relative.vueFromNow[term].term)); });
    return (React__default.createElement("div", { ref: ref, className: "panel-relative" },
        !isWide && (React__default.createElement(IconButton, { className: "calendar-panel-icon", onClick: close },
            React__default.createElement(XCircleIcon$3, null))),
        React__default.createElement(Radio.Group, { value: rDate.fromNow.toString(), onChange: updateFromNow, orientation: "vertical" }, optionsFomNow),
        React__default.createElement("div", { className: "options-period" }, optionsPeriod),
        React__default.createElement(Button, { appearance: "primary", size: "sm", block: true, onClick: validate, className: "period-validate" }, viewdate)));
}

function ShortCuts$1(_a) {
    var shortcutsDate = _a.shortcutsDate, selectDate = _a.selectDate, lib = _a.lib, close = _a.close;
    var isWide = useMediaQuery("(min-width: 640px)", true);
    var ref = useRef();
    useInteractOutside(ref.current, close);
    return (React__default.createElement("ul", { ref: ref, className: "panel-shortcuts" },
        !isWide && (React__default.createElement(IconButton, { className: "calendar-panel-icon", onClick: close },
            React__default.createElement(XCircleIcon$3, null))),
        shortcutsDate.map(function (sh) { return (React__default.createElement("li", { key: sh.label, onClick: function () {
                if (typeof sh.onClick === "function") {
                    var date = sh.onClick();
                    if (date instanceof Date) {
                        selectDate(lib.keyedDate(date));
                        close();
                    }
                }
            }, className: "panel-shortcuts-item" }, sh.label)); })));
}

function Calendar(_a) {
    var lib = _a.lib, size = _a.size, view = _a.view, shortcuts = _a.shortcuts, currentDate = _a.currentDate, isDateInvalid = _a.isDateInvalid, selectDate = _a.selectDate, selectMonth = _a.selectMonth, range = _a.range;
    var _b = __read(useState("viewDay"), 2), isView = _b[0], setToggleView = _b[1];
    var _c = __read(useState(false), 2), panel = _c[0], setPanel = _c[1];
    var _d = __read(useState(false), 2), shortcutsPanel = _d[0], setShortcutsPanel = _d[1];
    var isWide = useMediaQuery("(min-width: 640px)", true);
    var onShowRelativeDatePanel = function () { return setPanel(function (p) { return !p; }); };
    var onShowShortcutsPanel = function () { return setShortcutsPanel(function (p) { return !p; }); };
    var setCurrentDate = function (date) { return function () { return selectDate(date); }; };
    var toggleView = function () {
        return setToggleView(function (view) { return (view === "viewDay" ? "viewMonthYear" : "viewDay"); });
    };
    var week = lib.getDaysName();
    var monthsName = lib.getMonthsName();
    var goViews = lib.sequenceDate(view);
    var currentMonth = monthsName[view.month].long;
    var goPrevMonth = function () { return selectMonth(goViews.prev); };
    var goNextMonth = function () { return selectMonth(goViews.next); };
    var viewFromDate = lib.monthViewFromDate(view);
    var days = lib.selectedDay(currentDate, viewFromDate);
    var weeks = lib.groupInWeeks(days);
    var today = function () {
        var day = lib.keyedDate(new Date());
        selectDate(day);
    };
    var defaultRelativeDate = lib.keyedDate(new Date());
    return (React__default.createElement("div", { className: "carton-calendar-wrapper" },
        shortcuts && shortcuts.length > 0 && (isWide || shortcutsPanel) && (React__default.createElement("aside", { className: "carton-calendar-panel left" },
            React__default.createElement(ShortCuts$1, { shortcutsDate: shortcuts, selectDate: selectDate, lib: lib, close: onShowShortcutsPanel }))),
        React__default.createElement("section", { className: classnames("carton-calendar", size) },
            React__default.createElement("header", { className: "carton-calendar-header" },
                React__default.createElement(IconButton, { onClick: goPrevMonth, className: classnames("calendar-header-button-prev-month", {
                        "calendar-header-button-viewMonthYear": isView === "viewMonthYear"
                    }) },
                    React__default.createElement(ArrowLeftIcon$1, null)),
                React__default.createElement(Button, { className: classnames("calendar-header-button-month", {
                        "calendar-header-button-month-selected": isView === "viewMonthYear"
                    }), onClick: toggleView },
                    React__default.createElement("span", { className: classnames({ "is-greyed": isDateInvalid }) },
                        currentMonth,
                        " ",
                        view.year)),
                React__default.createElement(IconButton, { onClick: goNextMonth, className: classnames("calendar-header-button-next-month", {
                        "calendar-header-button-viewMonthYear": isView === "viewMonthYear"
                    }) },
                    React__default.createElement(ArrowRightIcon$1, null))),
            React__default.createElement("main", { className: "relative" },
                isView === "viewDay" && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(DaysWeekHeader, { week: week }),
                    React__default.createElement(ViewMonthGrid, __assign({}, { weeks: weeks, setCurrentDate: setCurrentDate, range: range })))),
                isView === "viewMonthYear" && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(ViewByMonth, __assign({}, { currentDate: currentDate, monthsName: monthsName, setCurrentDate: setCurrentDate })),
                    React__default.createElement(ViewByYear, __assign({}, { currentDate: currentDate, setCurrentDate: setCurrentDate }))))),
            React__default.createElement("footer", { className: "carton-calendar-footer" },
                shortcuts && shortcuts.length > 0 && !isWide && (React__default.createElement(IconButton, { onClick: onShowShortcutsPanel },
                    React__default.createElement(MenuAlt1Icon$1, null))),
                React__default.createElement(Button, { onClick: today, size: "sm", appearance: "text", className: "carton-calendar-footer-button" }, lib.relative.today),
                React__default.createElement(IconButton, { onClick: onShowRelativeDatePanel },
                    React__default.createElement(DotsCircleHorizontalIcon$1, null)))),
        panel && (React__default.createElement("aside", { className: classnames("carton-calendar-panel right") },
            React__default.createElement(RelativeDate, { close: onShowRelativeDatePanel, lib: lib, relativeDate: lib.relativeDate, currentDate: defaultRelativeDate, setCurrentDate: setCurrentDate })))));
}
function DaysWeekHeader(_a) {
    var week = _a.week;
    var daysWeek = week.map(function (day) { return (React__default.createElement("li", { key: day.short, className: "calendar-grid-head-item " }, day.short)); });
    return React__default.createElement("ol", { className: "calendar-grid-header" }, daysWeek);
}
function ViewMonthGrid(_a) {
    var weeks = _a.weeks, setCurrentDate = _a.setCurrentDate;
    var DayItem = setDayItem(setCurrentDate);
    var viewMonthGrid = weeks.map(function (days, i) {
        return (React__default.createElement("li", { key: i, className: "calendar-grid-row" },
            React__default.createElement("ol", { className: "calendar-grid-row-inner" }, days.map(DayItem))));
    });
    return React__default.createElement("ol", { className: classnames("calendar-grid") }, viewMonthGrid);
}
function setDayItem(setCurrentDate) {
    return function DayItem(day) {
        var className = classnames("calendar-grid-item ", {
            "calendar-day-disabled": day.outofview,
            "calendar-day-selected ": day.selected,
            "calendar-day-weekend ": day.weekend
        });
        return (React__default.createElement("li", { key: day.key, className: className, onClick: setCurrentDate(day.date) },
            React__default.createElement("span", { className: "calendar-grid-item-inner-date" }, day.day),
            day.event && React__default.createElement("div", { className: "calendar-grid-item-inner-event" }, day.event)));
    };
}
function ViewByMonth(_a) {
    var currentDate = _a.currentDate, monthsName = _a.monthsName, setCurrentDate = _a.setCurrentDate;
    var months = monthsName.map(function (n, month) {
        var name = n.long;
        return (React__default.createElement("li", { key: name, className: classnames("calendar-grid-item-inner view-year-month", {
                "calendar-month-selected": currentDate.month === month
            }), onClick: setCurrentDate(__assign(__assign({}, currentDate), { month: month })) }, name));
    });
    return React__default.createElement("ol", { className: "calendar-view-by-month" }, months);
}
function ViewByYear(_a) {
    var currentDate = _a.currentDate, setCurrentDate = _a.setCurrentDate;
    var _b = __read(useState(round10(currentDate.year)), 2), decadeBase = _b[0], setBase = _b[1];
    useEffect(function () {
        setBase(round10(currentDate.year));
    }, [currentDate.year]);
    var decade = [];
    for (var i = 0; i <= 9; i++) {
        var year = decadeBase + i;
        decade.push(React__default.createElement("li", { key: year, className: classnames("calendar-grid-item-inner view-year-mounth", {
                "calendar-month-selected ": currentDate.year === year
            }), onClick: setCurrentDate(__assign(__assign({}, currentDate), { year: year })) }, year));
    }
    var goYear = function (val) { return function () { return setBase(function (d) { return d + val * 10; }); }; };
    return (React__default.createElement("div", { className: "calendar-view-by-year" },
        React__default.createElement("menu", { className: "calendar-view-by-year-menu" },
            React__default.createElement(IconButton, { onClick: goYear(-1), className: "icon-left" },
                React__default.createElement(ArrowLeftIcon$1, null)),
            React__default.createElement(IconButton, { onClick: goYear(1), className: "icon-right" },
                React__default.createElement(ArrowRightIcon$1, null))),
        React__default.createElement("ol", { className: "calendar-view-by-year-list" }, decade)));
}
function round10(value) {
    var v = value === null ? new Date().getFullYear() : value;
    return Math.floor(v / 10) * 10;
}

function Card(_a) {
    var title = _a.title, subTitle = _a.subTitle, actions = _a.actions, noBorderHeader = _a.noBorderHeader, children = _a.children, className = _a.className, classNameBody = _a.classNameBody;
    return (React__default.createElement("div", { className: classnames("card", className) },
        title && (React__default.createElement("header", { className: classnames("card-header", {
                "card-header-noborder": noBorderHeader
            }) },
            typeof title === "string" ? (React__default.createElement("h2", { className: "card-header-title" }, title)) : (React__default.createElement("div", { className: "card-header-title" }, title)),
            subTitle && typeof subTitle === "string" ? (React__default.createElement("p", { className: "card-header-subtitle" }, subTitle)) : (React__default.createElement("div", { className: "card-header-subtitle" }, subTitle)))),
        React__default.createElement("div", { className: classnames("card-body", classNameBody) }, children),
        actions.length > 0 && (React__default.createElement("footer", { className: "card-footer" }, actions.map(function (action, idx) { return (React__default.createElement("div", { key: idx }, action)); })))));
}
Card.defaultProps = {
    actions: [],
    noBorderHeader: false
};

var ConfigContext = React__default.createContext({
    locale: "en-US"
});
function useConfig() {
    return useContext(ConfigContext);
}
var ConfigProvider = ConfigContext.Provider;

// voir aussi : https://developer.mozilla.org/fr/docs/Web/API/Element/setPointerCapture
var Move = /** @class */ (function () {
    function Move(data) {
        this.e = data.e;
        this.id = data.id;
        this.precAngle = 0;
        this.seuilLimit = -90;
        this.origin = this._setAxis(data.ref);
        this.pointer = { x: 0, y: 0 };
        this.state = { type: null, theta: 0, angle: 0, seuil: false };
        // this.startAngle = data.startAngle - this.seuilLimit;
        this.startAngle = data.startAngle;
        console.log("startAngle", this.startAngle);
        this.onup = data.onup;
        this.ondown = data.ondown;
        this.onmove = data.onmove;
        this.up = this.up.bind(this);
        this.down = this.down.bind(this);
        this.move = this.move.bind(this);
        this.down();
    }
    Move.prototype._setAxis = function (ref) {
        var rect = ref.getBoundingClientRect();
        var x = rect.x + window.pageXOffset;
        var y = rect.y + window.pageYOffset;
        var middle = { x: x + rect.width / 2, y: y + rect.height / 2 };
        return middle;
    };
    Move.prototype.down = function () {
        var e = this.e;
        e.preventDefault();
        e.stopPropagation();
        document.addEventListener("pointermove", this.move);
        document.addEventListener("pointerup", this.up);
        rotate.down.call(this, e);
    };
    Move.prototype.move = function (e) {
        e.preventDefault();
        e.stopPropagation();
        rotate.move.call(this, e);
    };
    Move.prototype.up = function (e) {
        e.preventDefault();
        e.stopPropagation();
        document.removeEventListener("pointermove", this.move);
        document.removeEventListener("pointerup", this.up);
        var _a = this.state; _a.theta; var state = __rest(_a, ["theta"]);
        this.onup && this.onup(state);
    };
    Move.prototype.point = function (e) {
        var point = { x: 0, y: 0 };
        if (e.targetTouches) {
            point.x = e.targetTouches[0].clientX;
            point.y = e.targetTouches[0].clientY;
        }
        else {
            point.x = e.clientX;
            point.y = e.clientY;
        }
        return point;
    };
    Move.prototype.seuil = function (angle) {
        var flag = false;
        if (angle < 0 &&
            this.precAngle < 0 &&
            this.precAngle < this.seuilLimit &&
            angle >= this.seuilLimit)
            flag = true;
        if (angle < 0 &&
            this.precAngle < 0 &&
            this.precAngle > this.seuilLimit &&
            angle <= this.seuilLimit)
            flag = true;
        this.precAngle = angle;
        return flag;
    };
    return Move;
}());
var rotate = {
    down: function (e) {
        var point = this.point(e);
        this.pointer = {
            x: window.scrollX + point.x,
            y: window.scrollY + point.y
        };
        var newPointer = {
            x: this.pointer.x / -this.origin.x,
            y: this.pointer.y / -this.origin.y
        };
        this.distance = hypothenuse(newPointer.x, newPointer.y);
        this.ondown && this.ondown(this.id);
    },
    move: function (e) {
        var point = this.point(e);
        var absPointer = {
            x: window.scrollX + point.x,
            y: window.scrollY + point.y
        };
        var newPointer = {
            x: absPointer.x - this.origin.x,
            y: absPointer.y - this.origin.y
        };
        var theta = Math.atan2(newPointer.y, newPointer.x);
        var _angle = RADtoDEG(theta);
        // const minAngle = Math.abs(this.startAngle - _angle);
        // console.log(this.startAngle, _angle, minAngle, );
        var seuil = this.seuil(_angle);
        var angle = toFixed2(_angle < 0 ? (450 + _angle) % 360 : _angle + 90);
        this.pointer = newPointer;
        this.state = { type: this.id, theta: theta, angle: angle, seuil: seuil };
        this.onmove && this.onmove(this.state);
    }
};
function RADtoDEG(rad) {
    return (rad * 180) / Math.PI;
}
function DEGtoRAD(deg) {
    return (deg * Math.PI) / 180;
}
function hypothenuse(x, y) {
    return Math.sqrt(x * x + y * y);
}
function transformCoords(x, y, rotate, s) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    if (rotate === void 0) { rotate = 0; }
    if (s === void 0) { s = 1; }
    var scale = 1 / s;
    var distance = hypothenuse(x, y);
    var angle = Math.atan2(y, x);
    var rad = DEGtoRAD(rotate);
    var coords = {
        x: distance * Math.cos(angle - rad) * scale,
        y: distance * Math.sin(angle - rad) * scale,
        distance: distance,
        angle: angle
    };
    return coords;
}
function round$1(precision) {
    return function (value) {
        return Number(value.toFixed(precision));
    };
}
var toFixed2 = round$1(2);

var params = {
    hours: { segments: 12, handLength: 25, strokeWidth: 2 },
    minutes: { segments: 60, handLength: 33, strokeWidth: 1 },
    center: { x: 50, y: 50 }
};
function Clock(props) {
    var svgE = useRef(null);
    var time = props.viewTime;
    var isPm = time.pm ? 12 : 0;
    var hours = time.hours !== null ? time.hours.toString().padStart(2, "0") : "";
    var pmHours = time.hours !== null ? (time.hours - isPm).toString().padStart(2, "0") : "";
    var minutes = time.minutes !== null ? time.minutes.toString().padStart(2, "0") : "";
    return (React__default.createElement("div", { className: "clock" },
        React__default.createElement("svg", { ref: svgE, viewBox: "0 0 100 100", width: "100%", height: "100%" },
            React__default.createElement("circle", { cx: params.center.x, cy: params.center.y, r: 49, className: "clock-face" }),
            React__default.createElement(Minutes, null),
            React__default.createElement(Hours, null),
            React__default.createElement(Hand, { ref: svgE, id: "hours", value: time.hours - isPm, onChange: props.onChange, setCurrentTime: props.setCurrentTime }),
            React__default.createElement(Hand, { ref: svgE, id: "minutes", value: time.minutes, onChange: props.onChange, setCurrentTime: props.setCurrentTime }),
            React__default.createElement("circle", { cx: params.center.x, cy: params.center.y, r: 2, className: "clock-face" })),
        React__default.createElement("div", { className: "clock-time" },
            React__default.createElement("h3", null,
                hours,
                ":",
                minutes),
            React__default.createElement("h3", null,
                pmHours,
                ":",
                minutes,
                "\u00A0",
                React__default.createElement("span", null, time.pm ? "PM" : "AM")))));
}
var Hand = React__default.forwardRef(function (_a, svg) {
    var id = _a.id, value = _a.value, onChange = _a.onChange, setCurrentTime = _a.setCurrentTime;
    var p = params[id];
    var divide = 360 / p.segments;
    var _b = __read(useState(DEGtoRAD(value * divide - 90)), 2), angle = _b[0], setAngle = _b[1];
    useEffect(function () { return setAngle(DEGtoRAD(value * divide - 90)); }, [value, divide]);
    var lineEnd = {
        x: params.center.x + Math.cos(angle) * p.handLength,
        y: params.center.y + Math.sin(angle) * p.handLength
    };
    var circleCenter = {
        x: params.center.x + Math.cos(angle) * ((p.handLength * 2) / 3),
        y: params.center.y + Math.sin(angle) * ((p.handLength * 2) / 3)
    };
    var rotatehand = function (e) {
        return new Move({
            id: id,
            ref: svg.current,
            startAngle: RADtoDEG(angle),
            onmove: function (_a) {
                var type = _a.type, theta = _a.theta, seuil = _a.seuil, angle = _a.angle;
                setAngle(theta);
                setCurrentTime({
                    type: type,
                    seuil: seuil,
                    time: Math.floor(angle / divide) % p.segments
                });
            },
            onup: function (_a) {
                var type = _a.type, seuil = _a.seuil, angle = _a.angle;
                onChange({
                    type: type,
                    seuil: seuil,
                    time: Math.floor(angle / divide) % p.segments
                });
            },
            e: e
        });
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("line", { id: id, x1: params.center.x, y1: params.center.y, x2: lineEnd.x, y2: lineEnd.y, strokeWidth: p.strokeWidth, className: "clock-minutes" }),
        React__default.createElement("circle", { cx: circleCenter.x, cy: circleCenter.y, r: 4, onPointerDown: rotatehand, className: "clock-face", style: { strokeWidth: 0.5 } })));
});
function Hours() {
    var hours = Array.from({ length: 12 }, function (v, k) { return k; }).map(function (hour) {
        var point = transformCoords(38, 0, 450 - hour * 30);
        return (React__default.createElement("text", { key: hour, className: "clock-hours", x: params.center.x + point.x, y: params.center.y + point.y, textAnchor: "middle" },
            React__default.createElement("tspan", { dy: 3 }, hour)));
    });
    return React__default.createElement(React__default.Fragment, null, hours);
}
function Minutes() {
    var minutes = Array.from({ length: 60 }, function (v, k) { return k; }).map(function (mn) {
        var isFive = mn % 5 === 0;
        var strokeWidth = isFive ? 2 : 0.5;
        var posPoint1 = isFive ? 46.5 : 44;
        var posPoint2 = isFive ? 46.5 : 49;
        var point1 = transformCoords(posPoint1, 0, mn * 6);
        var point2 = transformCoords(posPoint2, 0, mn * 6);
        return (React__default.createElement("line", { key: mn, className: "clock-minutes", strokeWidth: strokeWidth, x1: params.center.x + point1.x, y1: params.center.y + point1.y, x2: params.center.x + point2.x, y2: params.center.y + point2.y }));
    });
    return React__default.createElement(React__default.Fragment, null, minutes);
}

var Keys;
(function (Keys) {
    Keys["Space"] = " ";
    Keys["Enter"] = "Enter";
    Keys["Escape"] = "Escape";
    Keys["Backspace"] = "Backspace";
    Keys["ArrowUp"] = "ArrowUp";
    Keys["ArrowDown"] = "ArrowDown";
    Keys["ArrowLeft"] = "ArrowLeft";
    Keys["ArrowRight"] = "ArrowRight";
    Keys["Tab"] = "Tab";
})(Keys || (Keys = {}));
var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["Backspace"] = 8] = "Backspace";
    KeyCodes[KeyCodes["Tab"] = 9] = "Tab";
    KeyCodes[KeyCodes["Enter"] = 13] = "Enter";
    KeyCodes[KeyCodes["Escape"] = 27] = "Escape";
    KeyCodes[KeyCodes["Space"] = 32] = "Space";
    KeyCodes[KeyCodes["ArrowLeft"] = 37] = "ArrowLeft";
    KeyCodes[KeyCodes["ArrowUp"] = 38] = "ArrowUp";
    KeyCodes[KeyCodes["ArrowRight"] = 39] = "ArrowRight";
    KeyCodes[KeyCodes["ArrowDown"] = 40] = "ArrowDown";
})(KeyCodes || (KeyCodes = {}));

var outputValue$2 = function (value) { return (value !== null ? value.toString().padStart(2, "0") : ""); };
var InputTime = React__default.forwardRef(function (_props, inputRef) {
    var validationState = _props.validationState, props = __rest(_props, ["validationState"]);
    var hasError = validationState === "invalid";
    var isLoading = validationState === "loading";
    var onResetTime = function () { return props.onChange({ type: "reset", time: null }); };
    return (React__default.createElement("div", { ref: inputRef, tabIndex: 0, className: classnames("calendar-input-wrapper", props.className, { "form-input-error": hasError }) },
        React__default.createElement(TimeInputGroup, __assign({}, props)),
        React__default.createElement(TrailingNode$3, __assign({}, { hasError: hasError, isLoading: isLoading })),
        React__default.createElement(IconButton, { onClick: onResetTime, className: "calendar-input-clear" },
            React__default.createElement(XCircleIcon$3, null)),
        React__default.createElement(IconButton, { onClick: props.onClock, className: classnames({ "calendar-icon-is-open": props.isOpen }) },
            React__default.createElement(ClockIcon$1, null))));
});
var TrailingNode$3 = function (_a) {
    var hasError = _a.hasError, isLoading = _a.isLoading;
    return (React__default.createElement("div", { className: "icon-input" },
        hasError && React__default.createElement(ExclamationCircleIcon$1, { className: "icon-exclamation" }),
        isLoading && React__default.createElement(LoadingIcon, null)));
};
var TimeInputGroup = function (props) {
    var refs = useRef(function () { return ({ hours: null, minutes: null }); });
    var onKeyPress = function (key) { return function (e) {
        e.stopPropagation();
        e.key === Keys.Enter && setTime(key)(e);
        switch (e.key) {
            case Keys.Enter:
            case Keys.Space:
                if (!props.isOpen) {
                    props.onClock();
                }
                break;
        }
    }; };
    var onFocus = function (type) { return function (e) {
        if (e.target.value === "")
            props.onChange({ type: type, time: 0, seuil: undefined, pm: false });
    }; };
    var setTime = function (type) { return function (e) {
        var value = Number(e.target.value);
        var pm = type === "hours" && value > 11;
        props.onChange({ type: type, time: value, seuil: undefined, pm: pm });
    }; };
    return (React__default.createElement("div", { className: "calendar-input-group" },
        React__default.createElement("input", { name: "hours", ref: refs["hours"], min: "0", max: "23", step: "1", type: "number", maxLength: 2, value: outputValue$2(props.viewTime.hours), className: classnames("calendar-input-value", {
                "calendar-input-invalid": props.isDateInvalid
            }), placeholder: "HH", onBlur: props.onBlur, onFocus: onFocus("hours"), onChange: setTime("hours"), onKeyPress: onKeyPress("hours") }),
        "\u2008:\u2008",
        React__default.createElement("input", { name: "minutes", ref: refs["minutes"], min: "0", max: "59", step: "1", type: "number", maxLength: 2, placeholder: "MM", value: outputValue$2(props.viewTime.minutes), className: classnames("calendar-input-value", {
                "calendar-input-invalid": props.isDateInvalid
            }), onBlur: props.onBlur, onFocus: onFocus("minutes"), onChange: setTime("minutes"), onKeyPress: onKeyPress("minutes") })));
};

var isBrowser$1 = typeof window !== "undefined" && typeof window.document !== "undefined";
function Portal$1(_a) {
    var children = _a.children, container = _a.container;
    if (!isBrowser$1)
        return null;
    return React__default.createElement(React__default.Fragment, null, createPortal(children, container || document.body));
}

var Stack = /** @class */ (function () {
    function Stack() {
        this.elements = new Set();
    }
    Stack.prototype.add = function (el) {
        this.elements.add(el);
    };
    Stack.prototype.delete = function (el) {
        this.elements.delete(el);
    };
    Object.defineProperty(Stack.prototype, "size", {
        get: function () {
            return this.elements.size;
        },
        enumerable: false,
        configurable: true
    });
    Stack.prototype.isLast = function (el) {
        if (this.elements.size === 1)
            return true;
        var asArray = __spreadArray([], __read(this.elements), false);
        if (el === asArray[asArray.length - 1])
            return true;
        return false;
    };
    Stack.prototype.contains = function (el) {
        var e_1, _a;
        try {
            for (var _b = __values(this.elements), _c = _b.next(); !_c.done; _c = _b.next()) {
                var container = _c.value;
                if (container.contains(el))
                    return true;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    return Stack;
}());
var stack = new Stack();
function StackElement(_a) {
    var children = _a.children, elRef = _a.elRef;
    useIsomorphicEffect(function () {
        var el = elRef.current;
        stack.add(el);
        return function () { return stack.delete(el); };
    }, [elRef]);
    return React__default.createElement(React__default.Fragment, null, children);
}

var focusableSelector = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
]
    .map(function (selector) { return "".concat(selector, ":not([tabindex='-1']):not([style*='display: none'])"); })
    .join(",");
var Focus;
(function (Focus) {
    /** Focus le premier élément non désactivé */
    Focus[Focus["First"] = 1] = "First";
    /** Focus l'élément précédent non désactivé */
    Focus[Focus["Previous"] = 2] = "Previous";
    /** Focus l'élément suivant non désactivé */
    Focus[Focus["Next"] = 4] = "Next";
    /** Focus le dernier élément non désactivé */
    Focus[Focus["Last"] = 8] = "Last";
    /** Fait demi-tour */
    Focus[Focus["WrapAround"] = 16] = "WrapAround";
    /** Empêcher le défilement des éléments focusable dans la vue */
    Focus[Focus["NoScroll"] = 32] = "NoScroll";
})(Focus || (Focus = {}));
var Direction;
(function (Direction) {
    Direction[Direction["Previous"] = -1] = "Previous";
    Direction[Direction["Next"] = 1] = "Next";
})(Direction || (Direction = {}));
var FocusResult;
(function (FocusResult) {
    FocusResult[FocusResult["Error"] = 0] = "Error";
    FocusResult[FocusResult["Overflow"] = 1] = "Overflow";
    FocusResult[FocusResult["Success"] = 2] = "Success";
    FocusResult[FocusResult["Underflow"] = 3] = "Underflow";
})(FocusResult || (FocusResult = {}));
function getFocusableElements(container) {
    if (container === void 0) { container = document.body; }
    if (container === null)
        return [];
    return Array.from(container.querySelectorAll(focusableSelector));
}
function focusElement(element) {
    element === null || element === void 0 ? void 0 : element.focus({ preventScroll: true });
}
function focusIn(container, focus) {
    var elements = getFocusableElements(container);
    var active = document.activeElement;
    var direction;
    if (focus & (Focus.First | Focus.Next))
        direction = Direction.Next;
    else if (focus & (Focus.Previous | Focus.Last))
        direction = Direction.Previous;
    var startIndex;
    if (focus & Focus.First)
        startIndex = 0;
    else if (focus & Focus.Previous)
        startIndex = Math.max(0, elements.indexOf(active)) - 1;
    else if (focus & Focus.Next)
        startIndex = Math.max(0, elements.indexOf(active)) + 1;
    else if (focus & Focus.Last)
        startIndex = elements.length - 1;
    var focusOptions = focus & Focus.NoScroll ? { preventScroll: true } : {};
    var offset = 0;
    var total = elements.length;
    var next = undefined;
    do {
        if (offset >= total || offset + total <= 0)
            return FocusResult.Error;
        var nextIdx = startIndex + offset;
        if (focus & Focus.WrapAround) {
            nextIdx = (nextIdx + total) % total;
        }
        else {
            if (nextIdx < 0)
                return FocusResult.Underflow;
            if (nextIdx >= total)
                return FocusResult.Overflow;
        }
        next = elements[nextIdx];
        next === null || next === void 0 ? void 0 : next.focus(focusOptions);
        offset += direction;
    } while (next !== document.activeElement);
    if (!next.hasAttribute("tabindex"))
        next.setAttribute("tabindex", "0");
    return FocusResult.Success;
}

function useFocusTrap(stackElement, enabled, disableFocusCheck, initialFocus) {
    if (enabled === void 0) { enabled = true; }
    if (disableFocusCheck === void 0) { disableFocusCheck = false; }
    var elementToRestoreFocusTo = useRef(typeof window !== "undefined" ? document.activeElement : null);
    var previousActiveElement = useRef(null);
    var mounted = useRef(false);
    // Gére le focus initial et la restoration du focus
    useEffect(function () {
        if (!enabled)
            return;
        if (!stack.isLast(stackElement.current))
            return;
        mounted.current = true;
        var activeElement = document.activeElement;
        if (initialFocus === null || initialFocus === void 0 ? void 0 : initialFocus.current) {
            focusElement(initialFocus.current);
        }
        else if (stackElement.current.contains(activeElement)) {
            previousActiveElement.current = activeElement;
            return; // Déjà focus dans le trap
        }
        else {
            // Focus le première élément focusable
            focusIn(stackElement.current, Focus.First);
        }
        previousActiveElement.current = document.activeElement;
        return function () {
            mounted.current = false;
            focusElement(elementToRestoreFocusTo.current);
            elementToRestoreFocusTo.current = null;
            previousActiveElement.current = null;
        };
    }, [enabled, initialFocus, stackElement]);
    //  Gère Tab & Shift+Tab
    useWindowEvent("keydown", function (e) {
        if (!enabled)
            return;
        if (e.key !== Keys.Tab)
            return;
        if (!document.activeElement)
            return;
        if (!stack.isLast(stackElement.current))
            return;
        e.preventDefault();
        var result = focusIn(stackElement.current, (e.shiftKey ? Focus.Previous : Focus.Next) | Focus.WrapAround);
        if (result === FocusResult.Success) {
            previousActiveElement.current = document.activeElement;
        }
    });
    // Gère le déplacement du focus par du js
    useWindowEvent("focus", function (e) {
        if (!enabled || disableFocusCheck)
            return;
        if (!stack.isLast(stackElement.current))
            return;
        var previous = previousActiveElement.current;
        if (!previous)
            return;
        if (!mounted.current)
            return;
        var toElement = e.target;
        if (toElement && toElement instanceof HTMLElement) {
            if (!stack.contains(toElement)) {
                e.preventDefault();
                e.stopPropagation();
                focusElement(previous);
            }
            else {
                previousActiveElement.current = toElement;
                focusElement(toElement);
            }
        }
        else {
            focusElement(previousActiveElement.current);
        }
    }, true);
}

function Tray(_a) {
    var isOpen = _a.isOpen, children = _a.children, onClose = _a.onClose, container = _a.container;
    var ref = useRef();
    return (React__default.createElement(Transition, { show: isOpen },
        React__default.createElement(Portal$1, { container: container },
            React__default.createElement("div", { className: "overlay" },
                React__default.createElement("div", { className: "overlay-wrapper" },
                    React__default.createElement(Transition.Child, { enter: "overlay-transition-enter", enterFrom: "overlay-transition-enter-from", enterTo: "overlay-transition-enter-to", leave: "overlay-transition-leave", leaveFrom: "overlay-transition-leave-from", leaveTo: "overlay-transition-leave-to", className: "overlay-background", "aria-hidden": "true" },
                        React__default.createElement("div", { onClick: onClose })),
                    React__default.createElement(Transition.Child, { enter: "tray-transition-enter", enterFrom: "tray-transition-enter-from", enterTo: "tray-transition-enter-to", leave: "tray-transition-leave", leaveFrom: "tray-transition-leave-from", leaveTo: "tray-transition-leave-to", className: "tray", role: "dialog", "aria-modal": "true", "aria-hidden": "false" },
                        React__default.createElement(InternalTray, { elRef: ref },
                            React__default.createElement("div", { ref: ref }, children))))))));
}
function InternalTray(_a) {
    var elRef = _a.elRef, children = _a.children;
    usePreventScroll(true);
    useFocusTrap(elRef);
    return React__default.createElement(StackElement, { elRef: elRef }, children);
}

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement$1(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$1(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement$1(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format$2(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format$2(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format$2(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle$1(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

function PopoverWrapper(_a) {
    var style = _a.style, onClose = _a.onClose, children = _a.children, targetRef = _a.targetRef, placement = _a.placement, transition = _a.transition, shouldCloseOnBlur = _a.shouldCloseOnBlur, disableFocusCheck = _a.disableFocusCheck, sameSize = _a.sameSize;
    var stackRef = useRef();
    var _b = __read(useState(null), 2), popperElement = _b[0], setPopperElement = _b[1];
    var modifiers = [
        { name: "flip" },
        { name: "preventOverflow" },
        {
            name: "offset",
            options: {
                offset: [0, 10]
            }
        },
        sameSize && sameWidth
    ].filter(Boolean);
    var _c = usePopper(targetRef.current, popperElement, {
        placement: placement,
        modifiers: modifiers
    }), styles = _c.styles, attributes = _c.attributes;
    var close = useCallback(function (e) {
        if (shouldCloseOnBlur) {
            onClose(e);
        }
    }, [shouldCloseOnBlur, onClose]);
    useWindowEvent("keydown", function (e) {
        if (e.key !== Keys.Escape)
            return;
        if (!stack.isLast(stackRef.current))
            return;
        close();
    });
    useWindowEvent("pointerdown", function (e) {
        if (!stack.isLast(stackRef.current))
            return;
        if (stackRef.current.contains(e.target))
            return;
        close(e);
    });
    useFocusTrap(stackRef, true, disableFocusCheck);
    return (React__default.createElement(StackElement, { elRef: stackRef },
        React__default.createElement("div", __assign({ ref: setPopperElement, style: __assign(__assign({}, style), styles.popper) }, attributes.popper, { className: "popover-wrapper" }),
            React__default.createElement(Transition.Child, __assign({}, transition, { className: "popover-wrapper-transition" }),
                React__default.createElement("div", { ref: stackRef, className: "popover-wrapper-transition-child" }, children)))));
}
PopoverWrapper.defaultProps = {
    shouldCloseOnBlur: true,
    transition: {
        enter: "popover-transition-enter",
        enterFrom: "popover-transition-enterFrom",
        enterTo: "popover-transition-enterTo",
        leave: "popover-transition-leave",
        leaveFrom: "popover-transition-leaveFrom",
        leaveTo: "popover-transition-leaveTo"
    }
};
var sameWidth = {
    name: "sameWidth",
    enabled: true,
    phase: "beforeWrite",
    requires: ["computeStyles"],
    fn: function (_a) {
        var state = _a.state;
        state.styles.popper.width = "".concat(state.rects.reference.width, "px");
    },
    effect: function (_a) {
        var state = _a.state;
        state.elements.popper.style.width = "".concat(state.elements.reference.offsetWidth, "px");
    }
};

function Popover(_a) {
    var style = _a.style, isOpen = _a.isOpen, onClose = _a.onClose, children = _a.children, placement = _a.placement, targetRef = _a.targetRef, transition = _a.transition, shouldCloseOnBlur = _a.shouldCloseOnBlur, disableFocusCheck = _a.disableFocusCheck, sameSize = _a.sameSize;
    return (React__default.createElement(Transition, { show: isOpen },
        React__default.createElement(Portal$1, null,
            React__default.createElement(PopoverWrapper, { onClose: onClose, style: style, targetRef: targetRef, placement: placement, transition: transition, shouldCloseOnBlur: shouldCloseOnBlur, disableFocusCheck: disableFocusCheck, sameSize: sameSize }, children))));
}
Popover.defaultProps = {
    placement: "auto"
};

var Outer = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var isWide = useMediaQuery("(min-width: 640px)", true);
    return isWide ? (React__default.createElement(Popover, __assign({}, __assign({}, props), { disableFocusCheck: true }), children)) : (React__default.createElement(Tray, { isOpen: props.isOpen, onClose: props.onClose, container: props.container }, children));
};

function nextFrame(fn) {
    requestAnimationFrame(function () { return requestAnimationFrame(fn); });
}

var timeNull = {
    hours: null,
    minutes: null,
    time: null
};
function reducer$1(state, action) {
    switch (action.type) {
        case "hours": {
            var pm = void 0;
            var afternoon = void 0;
            // selon l'origine de l'entrée : input ou clock
            if (action.seuil === undefined) {
                pm = action.pm;
                afternoon = 0;
            }
            else {
                pm = action.seuil ? !state.pm : state.pm;
                afternoon = 12 * (pm ? 1 : 0);
            }
            return __assign(__assign({}, state), { hours: Number(action.time) + afternoon, pm: pm });
        }
        case "minutes":
            return __assign(__assign({}, state), { minutes: Number(action.time) });
        case "reset":
            return { hours: action.time, minutes: action.time, seconds: action.time, pm: false };
        default:
            throw new Error();
    }
}
var getInitialTime$1 = function (value) {
    var hours = value ? Number(value.getHours()) : null;
    var minutes = value ? Number(value.getMinutes()) : null;
    var pm = hours > 11;
    return {
        hours: hours,
        minutes: minutes,
        pm: pm
    };
};
var outputValue$1 = function (value) { return (value !== null ? value.toString().padStart(2, "0") : ""); };
///// Timepicker
function ClockPicker(props) {
    if (!(props.value instanceof Date) && props.value) {
        var err = new Error("<ClockPicker/> value doit \u00EAtre une Date");
        if (Error.captureStackTrace)
            Error.captureStackTrace(err, ClockPicker);
        throw err;
    }
    var inputRef = useRef(null);
    var _a = __read(useReducer(reducer$1, getInitialTime$1(props.value)), 2), currentTime = _a[0], setCurrentTime = _a[1];
    var _b = __read(useState(false), 2), isOpen = _b[0], setOpen = _b[1];
    var toggleClock = function () { return setOpen(function (open) { return !open; }); };
    var closeClock = function (e) {
        if (typeof e === "undefined" && isOpen) {
            setOpen(false);
        }
        else if (e.target && e.target instanceof Node && !inputRef.current.contains(e.target)) {
            setOpen(false);
            nextFrame(function () { return inputRef.current.focus(); });
        }
        else
            e.target.focus();
        onChange();
    };
    var onChange = function () {
        var hours = outputValue$1(currentTime.hours);
        var minutes = outputValue$1(currentTime.minutes);
        var time = {
            hours: currentTime.hours,
            minutes: currentTime.minutes,
            time: "".concat(hours, ":").concat(minutes, ":00")
        };
        props.onChange(time === timeNull ? null : new Date(1970, 1, 2, time.hours, time.minutes));
    };
    var onChangeTime = function (value) {
        value && setCurrentTime(value);
        onChange();
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(InputTime, { ref: inputRef, onBlur: onChange, onClock: toggleClock, onChange: onChangeTime, isOpen: isOpen, viewTime: currentTime, validationState: props.validationState, isDateInvalid: props.validationState === "invalid" || false, className: props.className }),
        React__default.createElement(Outer, { isOpen: isOpen, placement: "bottom", onClose: closeClock, targetRef: inputRef, shouldCloseOnBlur: true, container: props.container },
            React__default.createElement(Clock, { viewTime: currentTime, onChange: onChange, setCurrentTime: setCurrentTime }))));
}

var Periods;
(function (Periods) {
    Periods[Periods["day"] = 0] = "day";
    Periods[Periods["month"] = 1] = "month";
    Periods[Periods["year"] = 2] = "year";
})(Periods || (Periods = {}));
var singlePlural;
(function (singlePlural) {
    singlePlural[singlePlural["single"] = 0] = "single";
    singlePlural[singlePlural["plural"] = 1] = "plural";
})(singlePlural || (singlePlural = {}));
var fromNow;
(function (fromNow) {
    fromNow["past"] = "past";
    fromNow["future"] = "future";
})(fromNow || (fromNow = {}));
var DEFAULT_LOCALE = "en-US";
var DEFAULT_MONTH_LENGTH = 31;
var WEEK = 7;
var SEP = ".";
var fromNowTerms = {
    past: -1,
    future: 1
};
var CalendarLib = /** @class */ (function () {
    function CalendarLib(locale, isSundayFirstDayOfWeek) {
        if (locale === void 0) { locale = DEFAULT_LOCALE; }
        if (isSundayFirstDayOfWeek === void 0) { isSundayFirstDayOfWeek = false; }
        this.nullDate = { year: null, month: null, day: null };
        this.relativeDate = { year: null, month: null, day: null, fromNow: 1 };
        this.cache = {
            monthLength: new Map(),
            weekDays: new Map(),
            yearMonths: new Map(),
            monthViewLists: new Map()
        };
        this.locale = locale;
        this.isSundayFirstDayOfWeek = isSundayFirstDayOfWeek;
        this.localePattern = createLocalePattern(locale);
        this.relative = setRelatives(locale) || setRelatives(DEFAULT_LOCALE);
    }
    CalendarLib.prototype.isDateInvalid = function (currentDate) {
        var _a = this.localePattern, format = _a.format, pattern = _a.pattern;
        return !pattern.test(format(currentDate));
    };
    CalendarLib.prototype.concatViewDate = function (date, keepDay) {
        if (keepDay === void 0) { keepDay = true; }
        var day = date.day && keepDay ? date.day.toString().padStart(2, "0") : "00";
        var month = date.month ? date.month.toString().padStart(2, "0") : "00";
        return Number([date.year, month, day].join(""));
    };
    CalendarLib.prototype.startEndDates = function (range, keepDay) {
        if (keepDay === void 0) { keepDay = true; }
        if (!range)
            return [null, null];
        return [
            this.concatViewDate(range.startDate, keepDay),
            this.concatViewDate(range.endDate, keepDay)
        ];
    };
    CalendarLib.prototype.isDate = function (viewDate, limit, options) {
        if (options === void 0) { options = {}; }
        var _a = options.test, test = _a === void 0 ? "before" : _a, _b = options.defaultResponse, defaultResponse = _b === void 0 ? false : _b, _c = options.keepDay, keepDay = _c === void 0 ? false : _c;
        if (!limit || this.isDateInvalid(limit) || this.isDateInvalid(viewDate))
            return defaultResponse;
        var current = this.concatViewDate(viewDate, keepDay);
        var reference = this.concatViewDate(limit, keepDay);
        var tests = {
            before: current <= reference,
            after: current >= reference
        };
        return tests[test];
    };
    CalendarLib.prototype.isSameViewDate = function (viewA, viewB) {
        if (!viewA || !viewB)
            return false;
        return viewA.year === viewB.year && viewA.month === viewB.month;
    };
    CalendarLib.prototype.isNullDate = function (date) {
        return !date || (!date.year && !date.month && !date.day);
    };
    CalendarLib.prototype.disableDaysOutOfRange = function (datesDisabled, days) {
        var _this = this;
        if (!datesDisabled)
            return days;
        return days.map(function (day) {
            var disabled = false;
            if (datesDisabled.before)
                disabled = _this.isDate(day.date, datesDisabled.before, { test: "before", keepDay: true });
            if (datesDisabled.after)
                disabled = _this.isDate(day.date, datesDisabled.after, { test: "after", keepDay: true });
            return disabled ? __assign(__assign({}, day), { disabled: true }) : day;
        });
    };
    // supprimer
    CalendarLib.prototype.isMonthYearinRange = function (_a, range) {
        var month = _a.month, year = _a.year;
        if (year < range.startDate.year || year > range.endDate.year)
            return false;
        if (month < range.startDate.month || month > range.endDate.month)
            return false;
        return true;
    };
    /** return list of mounths in range belong to the current year*/
    CalendarLib.prototype.rangeMonths = function (view, range) {
        var months = Array(12).fill(false);
        if (view.year < range.startDate.year || view.year > range.endDate.year)
            return months;
        var start = view.year === range.startDate.year ? range.startDate.month : 0;
        var end = view.year === range.endDate.year ? range.endDate.month : 11;
        for (var m = start; m <= end; m++)
            months[m] = true;
        return months;
    };
    CalendarLib.prototype.rangeYears = function (view, range) {
        var decade = Array(10).fill(false);
        if (Math.floor(view.year / 10) < Math.floor(range.startDate.year / 10) ||
            Math.floor(view.year / 10) > Math.floor(range.endDate.year / 10))
            return decade;
        var start = range.startDate.year % (Math.floor(range.startDate.year / 10) * 10);
        var end = range.endDate.year % (Math.floor(range.endDate.year / 10) * 10);
        for (var y = start; y <= end; y++)
            decade[y] = true;
        return decade;
    };
    CalendarLib.prototype.monthViewFromDate = function (_a) {
        var month = _a.month, year = _a.year;
        var _b = this.monthViewList(month, year), daysInPrevMonth = _b.daysInPrevMonth, daysInMonth = _b.daysInMonth, daysInNextMonth = _b.daysInNextMonth;
        var date = this.sequenceDate({ year: year, month: month });
        var prev = daysInPrevMonth.map(function (day) { return ({
            key: joinDate(__assign(__assign({}, date.prev), { day: day })),
            date: __assign(__assign({}, date.prev), { day: day }),
            day: day,
            outofview: true
        }); });
        var current = daysInMonth.map(function (day) {
            return {
                key: joinDate(__assign(__assign({}, date.current), { day: day })),
                date: __assign(__assign({}, date.current), { day: day }),
                day: day
            };
        });
        var next = daysInNextMonth.map(function (day) { return ({
            key: joinDate(__assign(__assign({}, date.next), { day: day })),
            date: __assign(__assign({}, date.next), { day: day }),
            day: day,
            outofview: true
        }); });
        return __spreadArray(__spreadArray(__spreadArray([], __read(prev), false), __read(current), false), __read(next), false);
    };
    // month [0-11] based
    CalendarLib.prototype.getFirstDayOfMonth = function (month, year) {
        var day = new Date(year, month, 1).getDay();
        var lag = this.isSundayFirstDayOfWeek ? 0 : 7;
        return day || lag;
    };
    // 28-29-30-31 ?
    CalendarLib.prototype.getMonthLength = function (month, year) {
        if (!year || !month)
            return DEFAULT_MONTH_LENGTH;
        var key = month + "-" + year;
        if (this.cache.monthLength.has(key))
            return this.cache.monthLength.get(key);
        var monthLength = month == 0 ? new Date(year - 1, 11, 0).getDate() : new Date(year, month + 1, 0).getDate();
        this.cache.monthLength.set(key, monthLength);
        return monthLength;
    };
    /**
     * calcule les dates à afficher pour la vue d'un mois
     *
     * @param month  mois [0-11]
     * @returns 3 tableaux avec les dates de la fin du mois précédent, le mois courant, les premières dates du mois suivant
     */
    CalendarLib.prototype.monthViewList = function (month, year) {
        var keyView = joinDate({ month: month, year: year });
        if (this.cache.yearMonths.has(keyView))
            return this.cache.yearMonths.get(keyView);
        var sliceDay = this.isSundayFirstDayOfWeek ? 0 : -1;
        var prevMonthLength = this.getMonthLength(month - 1, year);
        var firstDayInWeek = this.getFirstDayOfMonth(month, year);
        var daysInPrevMonth = range$1(prevMonthLength - (firstDayInWeek - 1 + sliceDay), prevMonthLength);
        var monthLength = this.getMonthLength(month, year);
        var daysInMonth = range$1(1, monthLength);
        var daysLengthUntilEndOfMonth = __spreadArray(__spreadArray([], __read(daysInPrevMonth), false), __read(daysInMonth), false).length;
        var weeksInMonth = Math.ceil(daysLengthUntilEndOfMonth / 7);
        var daysInNextMonth = range$1(1, weeksInMonth * 7 - daysLengthUntilEndOfMonth);
        this.cache.yearMonths.set(keyView, { daysInPrevMonth: daysInPrevMonth, daysInMonth: daysInMonth, daysInNextMonth: daysInNextMonth });
        return this.cache.yearMonths.get(keyView);
    };
    /**
     * regroupe les semaines en tableau
     * @param days - Tableau de dates
     */
    CalendarLib.prototype.groupInWeeks = function (days) {
        var weeks = __spreadArray([], __read(days), false);
        var res = new Array(Math.ceil(weeks.length / WEEK))
            .fill(null)
            .map(function () { return weeks.splice(0, WEEK); });
        var result = res.map(function (week) {
            var e_1, _a;
            var weekend = week.slice(-2);
            try {
                for (var weekend_1 = __values(weekend), weekend_1_1 = weekend_1.next(); !weekend_1_1.done; weekend_1_1 = weekend_1.next()) {
                    var day = weekend_1_1.value;
                    day.weekend = true;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (weekend_1_1 && !weekend_1_1.done && (_a = weekend_1.return)) _a.call(weekend_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return week;
        });
        return result;
    };
    // ajoute un flag selected aux dates sélectionnées
    CalendarLib.prototype.selectedDay = function (currentDay, monthView, property) {
        if (property === void 0) { property = { selected: true }; }
        var keyDay = (Array.isArray(currentDay) ? currentDay : [currentDay]).map(joinDate);
        return monthView.map(function (day) { return (keyDay.includes(day.key) ? __assign(__assign({}, day), property) : day); });
    };
    /**
   *
   * @param viewDate {ViewDate} ViewDate : year, month, day
   * @returns {SequenceDate} vues précedente, courante et suivante
   
    * @typedef {Object} SequenceDate
    * @property {Object} prev ViewDate
    * @property {Object} current ViewDate
    * @property {Object} next ViewDate
   */
    CalendarLib.prototype.sequenceDate = function (_a) {
        var year = _a.year, month = _a.month, _b = _a.day, day = _b === void 0 ? undefined : _b;
        var prevMonth = month == 0 ? 11 : month - 1;
        var prevYear = month == 0 ? year - 1 : year;
        var nextMonth = month == 11 ? 0 : month + 1;
        var nextYear = month == 11 ? year + 1 : year;
        return {
            prev: {
                month: prevMonth,
                year: prevYear
            },
            current: { month: month, year: year, day: day },
            next: {
                month: nextMonth,
                year: nextYear
            }
        };
    };
    /**
     * retourne les noms des mois dans leur forme courte à longue dans la langue donnée
     */
    CalendarLib.prototype.getMonthsName = function (locale) {
        if (locale === void 0) { locale = this.locale; }
        if (this.cache.yearMonths.has(locale))
            return this.cache.yearMonths.get(locale);
        var months = [];
        for (var d = 0; d <= 11; d++) {
            var date = new Date(1970, d);
            var long = date.toLocaleString(locale, { month: "long" });
            var short = date.toLocaleString(locale, { month: "short" });
            var narrow = date.toLocaleString(locale, { month: "narrow" });
            months.push({ long: long, short: short, narrow: narrow });
        }
        this.cache.yearMonths.set(locale, months);
        return months;
    };
    /**
     * retourne les noms des jours dans leur forme courte à longue dans la langue donnée
     */
    CalendarLib.prototype.getDaysName = function (locale) {
        if (locale === void 0) { locale = this.locale; }
        if (this.cache.weekDays.has(locale))
            return this.cache.weekDays.get(locale);
        var days = [];
        for (var d = 1; d <= 7; d++) {
            var date = new Date(1970, 2, d);
            var long = date.toLocaleString(locale, { weekday: "long" });
            var short = date.toLocaleString(locale, { weekday: "short" });
            var narrow = date.toLocaleString(locale, { weekday: "narrow" });
            days.push({ long: long, short: short, narrow: narrow });
        }
        if (!this.isSundayFirstDayOfWeek) {
            var sunday = days.shift();
            days.push(sunday);
        }
        this.cache.weekDays.set(locale, days);
        return days;
    };
    /**
     * renvoie un objet ViewDate à partir d'une date
     * attention, une valeur de year < 100 revoie l'année 19xx
     * @param {Date} date
     * @returns {ViewDate}
     */
    CalendarLib.prototype.keyedDate = function (date) {
        return { year: date.getFullYear(), month: date.getMonth(), day: date.getDate() };
    };
    CalendarLib.prototype.setValidate = function (key, value, currentDate) {
        var date = __assign({}, currentDate);
        date[key] = value === "" ? null : +value + (key === "month" ? -1 : 0);
        // formatter la valeur
        var max = {
            day: this.getMonthLength(date.month, date.year),
            month: 11,
            year: 2099
        };
        for (var k in date) {
            date[k] && (date[k] = Math.min(Math.floor(date[k]), max[k]));
        }
        return date;
    };
    CalendarLib.prototype.setRelativeDate = function (relativeDate, currentDate) {
        var _relativedate = __assign({}, currentDate);
        for (var period in _relativedate)
            _relativedate[period] = currentDate[period] + relativeDate[period] * relativeDate.fromNow;
        var year = _relativedate.year, month = _relativedate.month, day = _relativedate.day;
        var kDate = this.keyedDate(new Date(year, month, day));
        return kDate;
    };
    CalendarLib.prototype.setShortcuts = function (shorts, currentDate) {
        if (!shorts)
            return null;
        var shortcuts = [];
        for (var label in shorts) {
            var rDate = __assign({}, shorts[label]);
            typeof rDate.fromNow === "string" && (rDate.fromNow = fromNowTerms[rDate.fromNow]);
            shortcuts.push({ label: label, date: this.setRelativeDate(rDate, currentDate) });
        }
        return shortcuts;
    };
    return CalendarLib;
}());
// ============================================================
function createLocalePattern(entryLocale) {
    var e_2, _a;
    var locale = new Intl.DateTimeFormat(entryLocale).resolvedOptions().numberingSystem === "latn"
        ? entryLocale
        : DEFAULT_LOCALE;
    var formatter = new Intl.DateTimeFormat(locale, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
    var sampleDate = new Date(3456, 2, 1); //date de test =  y:3456, m:2, d:1
    var parts = formatter.formatToParts(sampleDate);
    // locales pour dd, mm, yyyy,
    var pattern = [];
    var model = { pattern: [], parts: [], literal: "", placeholder: {} };
    try {
        for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
            var _b = parts_1_1.value, type = _b.type, value = _b.value;
            switch (type) {
                case "day":
                    {
                        var plhd = "dd".slice(0, value.length);
                        var patt = "(\\d{1,2})";
                        pattern.push("(0[1-9]|[12][0-9]|3[01])");
                        model.pattern.push(patt);
                        model.parts.push(type);
                        model.placeholder[type] = plhd;
                    }
                    break;
                case "month":
                    {
                        var plhd = "mm".slice(0, value.length);
                        var patt = "(\\d{1,2})";
                        pattern.push("(0[1-9]|1[012])");
                        model.pattern.push(patt);
                        model.parts.push(type);
                        model.placeholder[type] = plhd;
                    }
                    break;
                case "year":
                    {
                        var plhd = "yyyy".slice(0, value.length);
                        var patt = "(\\d{1,4})";
                        pattern.push("(19|20\\d{2})");
                        model.pattern.push(patt);
                        model.parts.push(type);
                        model.placeholder[type] = plhd;
                    }
                    break;
                // présume qu'il y a un seul type de séparateur
                case "literal":
                    var literal = "\\" + value;
                    pattern.push(literal);
                    model.pattern.push(literal);
                    model.literal = literal;
                    break;
                default:
                    break;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    function format(_a) {
        var year = _a.year, month = _a.month, _b = _a.day, day = _b === void 0 ? null : _b;
        if (year === null || month === null || day === null)
            return null;
        return formatter.format(new Date(year, month, day));
    }
    return {
        parts: parts,
        model: model,
        format: format,
        pattern: new RegExp(pattern.join(""))
    };
}
// ============================================================
function setRelatives(locale) {
    var e_3, _a;
    var rtfauto = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
    var rtf = new Intl.RelativeTimeFormat(locale, { numeric: "always" });
    var dateTerms = {};
    try {
        for (var _b = __values(["day", "month", "year"]), _c = _b.next(); !_c.done; _c = _b.next()) {
            var period = _c.value;
            var single = findTerm(1, period);
            var plural = findTerm(10, period);
            dateTerms[period] = { single: single, plural: plural };
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
    var vueFromNow = findRelTerm(dateTerms["day"].single);
    // si locale n'est pas un script 'latin', fallback en 'en-EN'
    var relative = vueFromNow
        ? {
            format: rtf.format,
            today: rtfauto.format(0, "day"),
            dateTerms: dateTerms,
            vueFromNow: vueFromNow
        }
        : null;
    return relative;
    /*
    à ma connaissance, il n'y a pas de façon simple de retrouver les termes corrects pour jour, mois et années,
    sinon dans les expressions comme 'dans 1 jour' : 'dans' et 'jour' sont de type 'literal'.
    Présumer que le qualificatif vient toujours après le nombre
    */
    function findTerm(val, period) {
        var parts = rtf.formatToParts(val, period);
        var index = parts.findIndex(function (term) { return term.type === "integer"; });
        var part = parts[index + 1];
        return part.value;
    }
    // period = dateTerms[period].single
    function findRelTerm(period) {
        var refPeriod = "day";
        var future = rtf.formatToParts(1, refPeriod);
        var indexIn = future.findIndex(function (term) { return term.type === "literal" && term.value !== period; });
        var indexValueIn = future.findIndex(function (term) { return term.type === "integer"; });
        var past = rtf.formatToParts(-1, refPeriod);
        var indexAgo = past.findIndex(function (term) { return term.type === "literal" && term.value !== period; });
        var indexValueAgo = past.findIndex(function (term) { return term.type === "integer"; });
        var removePeriodFromValue = past[indexAgo].value.replace(period, "").trim();
        past[indexAgo].value = removePeriodFromValue;
        if (indexAgo === -1 || indexIn === -1)
            return null;
        return {
            past: {
                position: indexAgo < indexValueAgo ? "before" : "after",
                term: past[indexAgo].value,
                value: -1
            },
            future: {
                position: indexIn < indexValueIn ? "before" : "after",
                term: future[indexIn].value,
                value: 1
            }
        };
    }
}
function joinDate(_a) {
    var year = _a.year, month = _a.month, _b = _a.day, day = _b === void 0 ? undefined : _b;
    return [year, month, day].join(SEP);
}
// fournit un tableau d'entiers compris entre min et max
function range$1(min, max) {
    var arr = [];
    for (var i = min; i <= max; i++) {
        arr.push(i);
    }
    return arr;
}

var DEFAULT_YEAR = 2000;
var canIUseThisCalendar = Intl.RelativeTimeFormat;
var InputDate = React__default.forwardRef(function (_props, inputRef) {
    var validationState = _props.validationState, props = __rest(_props, ["validationState"]);
    var lib = props.lib;
    var onResetDate = function () {
        props.onChange(lib.nullDate);
    };
    var hasError = validationState === "invalid";
    var isLoading = validationState === "loading";
    return (React__default.createElement("div", { ref: inputRef, tabIndex: 0, className: classnames("calendar-input-wrapper", props.className, { "form-input-error": hasError }) },
        React__default.createElement(InputDateGroup, __assign({}, props)),
        React__default.createElement(TrailingNode$2, __assign({}, { hasError: hasError, isLoading: isLoading })),
        props.currentDate !== lib.nullDate && (React__default.createElement(IconButton, { onClick: onResetDate, className: "calendar-input-clear" },
            React__default.createElement(XCircleIcon$3, null))),
        canIUseThisCalendar && (React__default.createElement(IconButton, { onClick: props.onCalendar, className: classnames({ "calendar-icon-is-open": props.isOpen }) },
            React__default.createElement(CalendarIcon$1, null)))));
});
var TrailingNode$2 = function (_a) {
    var hasError = _a.hasError, isLoading = _a.isLoading;
    return (React__default.createElement("div", { className: "icon-input" },
        hasError && React__default.createElement(ExclamationCircleIcon$1, { className: "icon-exclamation" }),
        isLoading && React__default.createElement(LoadingIcon, null)));
};
var InputDateGroup = function (props) {
    var lib = props.lib;
    var refs = useRef(function () {
        var e_1, _a;
        var refs = {};
        try {
            for (var _b = __values(lib.localePattern.model.parts), _c = _b.next(); !_c.done; _c = _b.next()) {
                var part = _c.value;
                refs[part] = null;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return refs;
    });
    var onChange = function (key) { return function (e) {
        return valiDate(key, e.target.value);
    }; };
    var onKeyPress = function (key) { return function (e) {
        e.stopPropagation();
        e.key === Keys.Enter && onBlur(key)(e);
        switch (e.key) {
            case Keys.Escape:
                if (canIUseThisCalendar && props.isOpen) {
                    props.onCalendar();
                }
                break;
            case Keys.Enter:
            case Keys.Space:
                if (canIUseThisCalendar && !props.isOpen) {
                    props.onCalendar();
                }
                break;
        }
    }; };
    var onBlur = function (key) { return function (e) {
        var date = valiDate(key, e.target.value);
        props.onChange(date);
    }; };
    var onFocus = function (e) {
        // Démarre l'année à 2000 si vide
        if (e.target.name === "year" && e.target.value === "")
            props.onChange(__assign(__assign({}, props.currentDate), { year: DEFAULT_YEAR }));
    };
    // mois : [0-11] affiché [1-12]
    function valiDate(key, value) {
        var date = lib.setValidate(key, value, props.currentDate);
        props.onChange(date);
        return date;
    }
    var dateToShow = __assign({}, props.currentDate);
    dateToShow.month !== null && (dateToShow.month = dateToShow.month + 1);
    var InputsDate = lib.localePattern.parts.map(function (_a, i) {
        var type = _a.type, value = _a.value;
        var inputValue = dateToShow[type] ? dateToShow[type].toString().padStart(2, "0") : "";
        if (type === "literal") {
            return (React__default.createElement("span", { key: i, className: "calendar-input-literal" }, value));
        }
        else
            return (React__default.createElement("input", { key: type, name: type, ref: refs[type], min: "1", step: "1", type: "number", value: inputValue, placeholder: lib.localePattern.model.placeholder[type], maxLength: lib.localePattern.model.placeholder[type].length, className: classnames("calendar-input-value", type, {
                    "calendar-input-invalid": props.isDateInvalid
                }), onFocus: onFocus, onBlur: onBlur(type), onChange: onChange(type), onKeyPress: onKeyPress(type) }));
    });
    return React__default.createElement("div", { className: "calendar-input-group" }, InputsDate);
};

function DatePicker(props) {
    // if (!(props.value instanceof Date) && props.value) {
    //   const err = new Error(`<DatePicker/> value doit être une Date`);
    //   if (Error.captureStackTrace) Error.captureStackTrace(err, DatePicker);
    //   throw err;
    // }
    var locale = useConfig().locale;
    var defaultLocale = props.locale || locale;
    var lib = useMemo(function () { return new CalendarLib(defaultLocale, props.isSundayFirstDayOfWeek); }, [
        defaultLocale,
        props.isSundayFirstDayOfWeek
    ]);
    var intitialDate = props.value ? lib.keyedDate(new Date(props.value)) : lib.nullDate;
    var _a = props.view || lib.keyedDate(props.value ? new Date(props.value) : new Date()); _a.day; var currentView = __rest(_a, ["day"]);
    var inputRef = useRef(null);
    var _b = __read(useState(false), 2), isOpen = _b[0], setOpen = _b[1];
    var _c = __read(useState(intitialDate), 2), currentDate = _c[0], setCurrentDate = _c[1];
    var _d = __read(useState(currentView), 2), view = _d[0], setView = _d[1];
    var _e = __read(useState(currentDate === lib.nullDate), 2), isPristine = _e[0], setPristine = _e[1];
    var toggleCalendar = function () { return setOpen(function (open) { return !open; }); };
    var closeCalendar = function (e) {
        if (typeof e === "undefined" && isOpen) {
            setOpen(false);
        }
        else if (e.target instanceof Node && !inputRef.current.contains(e.target)) {
            setOpen(false);
        }
        else
            e.target.focus();
    };
    var setDate = function (date) {
        setCurrentDate(date);
        setPristine(false);
        var year = date.year, month = date.month, day = date.day;
        month !== null && year !== null && setView({ year: year, month: month });
        if (typeof props.onChange === "function" &&
            (!lib.isDateInvalid(date) || date === lib.nullDate)) {
            props.onChange(date === lib.nullDate ? null : new Date(year, month, day));
        }
    };
    var validBrakpoints = useBreakpoints$1();
    var isDateInvalid = lib.isDateInvalid(currentDate);
    var size = props.size || validBrakpoints[validBrakpoints.length - 1] || "sm";
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(InputDate, { ref: inputRef, currentDate: currentDate, onChange: setDate, onCalendar: toggleCalendar, isOpen: isOpen, className: props.className, validationState: props.validationState, isDateInvalid: isDateInvalid && (!isPristine || props.validationState === "invalid"), lib: lib }),
        React__default.createElement(Outer, { targetRef: inputRef, isOpen: isOpen, onClose: closeCalendar, shouldCloseOnBlur: true, placement: "bottom", container: props.container },
            React__default.createElement(Calendar, { view: view, currentDate: currentDate, selectDate: setDate, selectMonth: setView, isDateInvalid: isDateInvalid, size: size, lib: lib, shortcuts: props.shortcuts }))));
}
DatePicker.defaultProps = {
    locale: "en-US"
};
function useBreakpoints$1() {
    var sm = useMediaQuery("(min-width: 640px)", true);
    var md = useMediaQuery("(min-width: 768px)", true);
    return [sm && "sm", md && "md"].filter(Boolean);
}

var useInputDateState = function (_a) {
    var lib = _a.lib, value = _a.value, view = _a.view, onChange = _a.onChange;
    var intitialDate = value ? lib.keyedDate(value) : lib.nullDate;
    var _b = view || lib.keyedDate(value || new Date()); _b.day; var currentView = __rest(_b, ["day"]);
    var _c = __read(useState(currentView), 2), viewCalendar = _c[0], setView = _c[1];
    var _d = __read(useState(intitialDate), 2), currentDate = _d[0], setCurrentDate = _d[1];
    var _e = __read(useState(currentDate === lib.nullDate), 2), isPristine = _e[0], setPristine = _e[1];
    var setDate = function (date) {
        setCurrentDate(date);
        setPristine(false);
        var year = date.year, month = date.month, day = date.day;
        month !== null && year !== null && setView({ year: year, month: month });
        if (typeof onChange === "function" && (!lib.isDateInvalid(date) || date === lib.nullDate)) {
            onChange(date === lib.nullDate ? null : new Date(year, month, day));
        }
    };
    var isDateInvalid = lib.isDateInvalid(currentDate);
    return {
        setDate: setDate,
        setView: setView,
        isPristine: isPristine,
        currentDate: currentDate,
        viewCalendar: viewCalendar,
        isDateInvalid: isDateInvalid
    };
};
/*
setRangeDate
deux dates peuvent etre saisies dans
- startDate
- endDate
si une seule saisie startDate === endDate
toujours startDate <= endDate

si une nouvelle date est ajoutée:
newDate <= startDate ->  startDate = newDate
newDate >= endDate ->  endDate = newDate

*/

var useInputTimeState = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = __read(useReducer(reducer, getInitialTime(value)), 2), currentTime = _b[0], setCurrentTime = _b[1];
    var onChangeToDate = function () {
        var hours = outputValue(currentTime.hours);
        var minutes = outputValue(currentTime.minutes);
        var time = {
            hours: currentTime.hours,
            minutes: currentTime.minutes,
            time: "".concat(hours, ":").concat(minutes, ":00")
        };
        onChange(time === timeNull ? null : new Date(1970, 1, 2, time.hours, time.minutes));
    };
    var onChangeTime = function (value) {
        value && setCurrentTime(value);
        onChangeToDate();
    };
    return { currentTime: currentTime, setCurrentTime: setCurrentTime, onChangeTime: onChangeTime, onChangeToDate: onChangeToDate };
};
function reducer(state, action) {
    switch (action.type) {
        case "hours": {
            var pm = void 0;
            var afternoon = void 0;
            // selon l'origine de l'entrée : input ou clock
            if (action.seuil === undefined) {
                pm = action.pm;
                afternoon = 0;
            }
            else {
                pm = action.seuil ? !state.pm : state.pm;
                afternoon = 12 * (pm ? 1 : 0);
            }
            return __assign(__assign({}, state), { hours: Number(action.time) + afternoon, pm: pm });
        }
        case "minutes":
            return __assign(__assign({}, state), { minutes: Number(action.time) });
        case "reset":
            return { hours: action.time, minutes: action.time, seconds: action.time, pm: false };
        default:
            throw new Error();
    }
}
var getInitialTime = function (time) {
    var hours = time ? Number(time.getHours()) : null;
    var minutes = time ? Number(time.getMinutes()) : null;
    var pm = hours > 11;
    return {
        hours: hours,
        minutes: minutes,
        pm: pm
    };
};
function outputValue(value) {
    return value !== null ? value.toString().padStart(2, "0") : "";
}

function ShortCuts(_a) {
    var shortcutsDateTime = _a.shortcutsDateTime, setDate = _a.setDate, setTime = _a.setTime, lib = _a.lib, close = _a.close;
    var isWide = useMediaQuery("(min-width: 640px)", true);
    var ref = useRef();
    useInteractOutside(ref.current, close);
    return (React__default.createElement("ul", { ref: ref, className: "panel-shortcuts" },
        !isWide && (React__default.createElement(IconButton, { className: "calendar-panel-icon", onClick: close },
            React__default.createElement(XCircleIcon$3, null))),
        shortcutsDateTime.map(function (sh) { return (React__default.createElement("li", { key: sh.label, onClick: function () {
                if (typeof sh.onClick === "function") {
                    var data = sh.onClick();
                    var shouldWeClose = false;
                    if (data.date && data.date instanceof Date) {
                        setDate(lib.keyedDate(data.date));
                        shouldWeClose = true;
                    }
                    if (data.time) {
                        setTime({ type: "hours", time: data.time.hours, pm: data.time.hours > 11 });
                        setTime({ type: "minutes", time: data.time.minutes });
                        data.time.seconds && setTime({ type: "minutes", time: data.time.seconds });
                        shouldWeClose = true;
                    }
                    shouldWeClose && close();
                }
            }, className: "panel-shortcuts-item" }, sh.label)); })));
}

var DateTimePicker = function (props) {
    if (!(props.value instanceof Date) && props.value) {
        var err = new Error("<DateTimePicker/> value doit \u00EAtre une Date");
        if (Error.captureStackTrace)
            Error.captureStackTrace(err, DateTimePicker);
        throw err;
    }
    var locale = useConfig().locale;
    var defaultLocale = locale || props.locale;
    var inputRef = useRef(null);
    var lib = useMemo(function () { return new CalendarLib(defaultLocale, props.isSundayFirstDayOfWeek); }, [
        defaultLocale,
        props.isSundayFirstDayOfWeek
    ]);
    var hasError = props.validationState === "invalid";
    var isLoading = props.validationState === "loading";
    var _a = props.size, size = _a === void 0 ? "md" : _a;
    var _b = __read(useState(false), 2), isOpen = _b[0], setOpen = _b[1];
    var _c = __read(useState(true), 2), isCalendarShowed = _c[0], setCalendarShowed = _c[1];
    var _d = __read(useState(false), 2), shortcutsPanel = _d[0], setShortcutsPanel = _d[1];
    var isWide = useMediaQuery("(min-width: 640px)", true);
    var onShowShortcutsPanel = function () { return setShortcutsPanel(function (p) { return !p; }); };
    var toggleClock = function () {
        setCalendarShowed(false);
        setOpen(function (open) { return !open; });
    };
    var toggleCalendar = function () {
        setCalendarShowed(true);
        setOpen(function (open) { return !open; });
    };
    var closeCalendar = function (e) {
        if (typeof e === "undefined" && isOpen) {
            setOpen(false);
        }
        else if (e.target && e.target instanceof Node && !inputRef.current.contains(e.target)) {
            setOpen(false);
            nextFrame(function () { return inputRef.current.focus(); });
        }
        else
            e.target.focus();
        onChangeToDate();
    };
    var _e = useInputDateState({
        lib: lib,
        view: props.view,
        value: props.value,
        onChange: props.onChange
    }), setView = _e.setView, setDate = _e.setDate, isPristine = _e.isPristine, currentDate = _e.currentDate, viewCalendar = _e.viewCalendar, isDateInvalid = _e.isDateInvalid;
    var _f = useInputTimeState({
        value: props.value,
        onChange: props.onChange
    }), currentTime = _f.currentTime, setCurrentTime = _f.setCurrentTime, onChangeTime = _f.onChangeTime, onChangeToDate = _f.onChangeToDate;
    var onResetDate = function () {
        setDate(lib.nullDate);
        setCurrentTime({ type: "reset", time: null });
    };
    return (React__default.createElement("div", { ref: inputRef, tabIndex: 0, className: classnames("calendar-input-wrapper", props.className, { "form-input-error": hasError }) },
        React__default.createElement("div", { className: "calendar-input-group" },
            React__default.createElement(InputDateGroup, { currentDate: currentDate, onChange: setDate, onCalendar: toggleCalendar, isOpen: isOpen, isDateInvalid: isDateInvalid && (!isPristine || props.validationState === "invalid"), lib: lib }),
            "\u2003",
            React__default.createElement(TimeInputGroup, { onBlur: onChangeToDate, onClock: toggleClock, onChange: onChangeTime, isOpen: isOpen, viewTime: currentTime, isDateInvalid: false, className: props.className })),
        React__default.createElement(TrailingNode$1, __assign({}, { hasError: hasError, isLoading: isLoading })),
        React__default.createElement(IconButton, { onClick: onResetDate, className: "calendar-input-clear" },
            React__default.createElement(XCircleIcon$3, null)),
        React__default.createElement(IconButton, { onClick: toggleCalendar, className: classnames({ "calendar-icon-is-open": isOpen }) },
            React__default.createElement(CalendarIcon$1, null)),
        React__default.createElement(Outer, { targetRef: inputRef, isOpen: isOpen, onClose: closeCalendar, shouldCloseOnBlur: true, placement: "bottom", container: props.container },
            React__default.createElement("div", { className: "calendar-clock" },
                props.shortcuts && props.shortcuts.length > 0 && (isWide || shortcutsPanel) && (React__default.createElement("aside", { className: "calendar-clock-panel left" },
                    React__default.createElement(ShortCuts, { shortcutsDateTime: props.shortcuts, setDate: setDate, setTime: setCurrentTime, lib: lib, close: onShowShortcutsPanel }))),
                React__default.createElement("div", null,
                    props.shortcuts && props.shortcuts.length > 0 && !isWide && (React__default.createElement(IconButton, { className: "shortcuts", onClick: onShowShortcutsPanel },
                        React__default.createElement(MenuAlt1Icon$1, null))),
                    React__default.createElement("div", { className: classnames("calendar-clock-swiper-wrapper", {
                            wshortcuts: props.shortcuts && props.shortcuts.length > 0
                        }) },
                        React__default.createElement("div", { className: "calendar-clock-swiper" },
                            React__default.createElement(IconButton, { className: classnames({ selected: isCalendarShowed }), onClick: function () { return setCalendarShowed(true); } },
                                React__default.createElement(CalendarIcon$1, null)),
                            React__default.createElement(IconButton, { className: classnames({ selected: !isCalendarShowed }), onClick: function () { return setCalendarShowed(false); } },
                                React__default.createElement(ClockIcon$1, null)))),
                    React__default.createElement("div", { className: "calendar-clock-wrapper" },
                        React__default.createElement(Calendar, { view: viewCalendar, currentDate: currentDate, selectDate: setDate, selectMonth: setView, isDateInvalid: isDateInvalid, size: size, lib: lib }),
                        React__default.createElement("div", { className: "clock-wrapper", hidden: isCalendarShowed },
                            React__default.createElement(Clock, { viewTime: currentTime, onChange: onChangeToDate, setCurrentTime: setCurrentTime }))))))));
};
var TrailingNode$1 = function (_a) {
    var hasError = _a.hasError, isLoading = _a.isLoading;
    return (React__default.createElement("div", { className: "icon-input" },
        hasError && React__default.createElement(ExclamationCircleIcon$1, { className: "icon-exclamation" }),
        isLoading && React__default.createElement(LoadingIcon, null)));
};

var Drawer = React__default.forwardRef(function Drawer(_a, ref) {
    var _b;
    var isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, subTitle = _a.subTitle, footer = _a.footer, children = _a.children, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.direction, direction = _d === void 0 ? "right" : _d, contentClassName = _a.contentClassName, initialFocus = _a.initialFocus, _e = _a.shouldCloseOnBlur, shouldCloseOnBlur = _e === void 0 ? true : _e, _f = _a.shouldCloseOnEsc, shouldCloseOnEsc = _f === void 0 ? true : _f;
    var internelDrawerRef = useRef();
    var callbacksRef = useRef(new Map());
    // Gère le bouton Esc
    useWindowEvent("keydown", function (e) {
        if (!isOpen)
            return;
        if (!shouldCloseOnEsc)
            return;
        if (e.key !== Keys.Escape)
            return;
        if (!stack.isLast(internelDrawerRef.current))
            return;
        onClose();
    });
    useImperativeHandle(ref, function () { return ({
        registerCallback: function (id, cb) {
            callbacksRef.current.set(id, cb);
        },
        unregisterCallback: function (id) {
            callbacksRef.current.delete(id);
        },
        getCallback: function (id) {
            return callbacksRef.current.get(id);
        }
    }); });
    return (React__default.createElement(Transition, { show: isOpen },
        React__default.createElement(Portal$1, null,
            React__default.createElement("div", { className: "drawer-wrapper" },
                React__default.createElement("div", null,
                    React__default.createElement(Transition.Child, { enter: "drawer-overlay-transition", enterFrom: "drawer-overlay-transition-enter-from", enterTo: "drawer-overlay-transition-enter-to", leave: "drawer-overlay-transition", leaveFrom: "drawer-overlay-transition-leave-from", leaveTo: "drawer-overlay-transition-leave-to", className: "drawer-overlay", "aria-hidden": "true", onClick: function () {
                            shouldCloseOnBlur && onClose();
                        } }),
                    React__default.createElement("section", { className: classnames("drawer-container", {
                            "drawer-container-right": direction === "right",
                            "drawer-container-left": direction === "left"
                        }) },
                        React__default.createElement(Transition.Child, { enter: "drawer-transition", enterFrom: classnames({
                                "drawer-transition-enter-from-right": direction === "right",
                                "drawer-transition-enter-from-left": direction === "left"
                            }), enterTo: "drawer-transition-enter-to", leave: "drawer-transition", leaveFrom: "drawer-transition-leave-from", leaveTo: classnames({
                                "drawer-transition-leave-to-right": direction === "right",
                                "drawer-transition-leave-to-left": direction === "left"
                            }), className: classnames("drawer", {
                                "drawer-sm": size === "sm",
                                "drawer-md": size === "md",
                                "drawer-lg": size === "lg",
                                "drawer-xl": size === "xl",
                                "drawer-2xl": size === "2xl"
                            }) },
                            !title && (React__default.createElement(Transition.Child, { enter: "drawer-overlay-transition", enterFrom: "drawer-overlay-transition-enter-from", enterTo: "drawer-overlay-transition-enter-to", leave: "drawer-overlay-transition", leaveFrom: "drawer-overlay-transition-leave-from", leaveTo: "drawer-overlay-transition-leave-to", className: classnames("drawer-outer-close", {
                                    "drawer-outer-close-left": direction === "left",
                                    "drawer-outer-close-right": direction === "right"
                                }) },
                                React__default.createElement("button", { onClick: onClose, className: "drawer-outer-close-button" },
                                    React__default.createElement(XIcon$3, { className: "drawer-close-icon" })))),
                            React__default.createElement(InternalDrawer, { elRef: internelDrawerRef, initialFocus: initialFocus },
                                React__default.createElement("div", { ref: internelDrawerRef, className: "drawer-inner" },
                                    React__default.createElement("div", { className: "drawer-inner-wrapper" },
                                        title && (React__default.createElement("header", null,
                                            React__default.createElement("div", { className: "drawer-title-wrapper" },
                                                React__default.createElement("div", null,
                                                    React__default.createElement("h2", { className: "drawer-title" }, title),
                                                    subTitle && React__default.createElement("p", { className: "drawer-subtitle" }, subTitle)),
                                                React__default.createElement("div", { className: "drawer-inner-close" },
                                                    React__default.createElement(IconButton, { onClick: onClose, className: "drawer-inner-close-button" },
                                                        React__default.createElement(XIcon$3, null)))))),
                                        React__default.createElement("div", { className: classnames("drawer-content", (_b = {
                                                    "drawer-content-withtitle": title
                                                },
                                                _b[contentClassName] = contentClassName,
                                                _b)) }, children)),
                                    footer && React__default.createElement("footer", null, footer))))))))));
});
function InternalDrawer(_a) {
    var children = _a.children, elRef = _a.elRef, initialFocus = _a.initialFocus;
    var _b = __read(useState(false), 2), trapEnabled = _b[0], setTrap = _b[1];
    usePreventScroll(true);
    useFocusTrap(elRef, trapEnabled, false, initialFocus);
    useEffect(function () {
        // Délai le focus après l'animation du drawer
        setTimeout(function () { return setTrap(true); }, 701);
    }, []);
    return React__default.createElement(StackElement, { elRef: elRef }, children);
}

var useId$5 = typeof useId$8 === "function" ? useId$8 : useId$6;
var DropdownContext = React__default.createContext(null);
function Dropdown(_a) {
    var _b;
    var children = _a.children, defaultIsOpen = _a.defaultIsOpen, placement = _a.placement;
    var _c = __read(React__default.Children.toArray(children), 2), trigger = _c[0], menu = _c[1];
    var id = "carton-ui-dropdown-trigger-".concat(useId$5());
    var triggerRef = useRef();
    var menuRef = useRef();
    var isWide = useMediaQuery("(min-width: 640px)", true);
    var _d = __read(useState(defaultIsOpen), 2), isOpen = _d[0], setState = _d[1];
    var toggle = useCallback(function (e) {
        if (e)
            e.stopPropagation();
        setState(!isOpen);
        if (!isOpen) {
            // focus le menu à l'ouverture
            nextFrame(function () { var _a; return (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.focus(); });
        }
    }, [isOpen]);
    var close = useCallback(function (e) {
        var _a;
        if (e && ((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            return;
        }
        setState(false);
    }, []);
    var handleKeyDown = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.key === Keys.ArrowDown || e.key === Keys.Enter || e.key === Keys.Space) {
            toggle();
        }
    }, [toggle]);
    var child = React__default.cloneElement(menu, {
        ref: menuRef
    });
    return (React__default.createElement(React__default.Fragment, null,
        React__default.cloneElement(trigger, {
            id: id,
            "aria-haspopup": true,
            "aria-controls": (_b = menuRef.current) === null || _b === void 0 ? void 0 : _b.id,
            "aria-expanded": isOpen ? true : undefined,
            ref: triggerRef,
            tabIndex: 0,
            onClick: toggle,
            onKeyDown: handleKeyDown
        }),
        React__default.createElement(DropdownContext.Provider, { value: {
                close: close,
                isOpen: isOpen,
                triggerRef: triggerRef
            } }, isWide ? (React__default.createElement(Popover, { isOpen: isOpen, onClose: close, targetRef: triggerRef, placement: placement, shouldCloseOnBlur: true }, child)) : (React__default.createElement(Tray, { isOpen: isOpen, onClose: close }, child)))));
}
Dropdown.defaultProps = {
    defaultIsOpen: false,
    placement: "bottom-end"
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef$7=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef$7,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

function toArray$1(children) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ret = [];
  React__default.Children.forEach(children, function (child) {
    if ((child === undefined || child === null) && !option.keepEmpty) {
      return;
    }

    if (Array.isArray(child)) {
      ret = ret.concat(toArray$1(child));
    } else if (reactIs.isFragment(child) && child.props) {
      ret = ret.concat(toArray$1(child.props.children, option));
    } else {
      ret.push(child);
    }
  });
  return ret;
}

/* eslint-disable no-console */
var warned = {};
function warning$1(valid, message) {
  // Support uglify
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    console.error("Warning: ".concat(message));
  }
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning$1, valid, message);
}
/* eslint-enable */

var HOOK_MARK = 'RC_FORM_INTERNAL_HOOKS'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var warningFunc = function warningFunc() {
  warningOnce(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};

var Context = /*#__PURE__*/React.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldWarning: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function getInternalHooks() {
    warningFunc();
    return {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      setCallbacks: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc,
      getInitialValue: warningFunc
    };
  }
});

function toArray(value) {
  if (value === undefined || value === null) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var regenerator = runtime_1;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/* eslint no-console:0 */
var formatRegExp = /%[sdj%]/g;
var warning = function warning() {}; // don't print warning message when in production env or node runtime

if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && typeof document !== 'undefined') {
  warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING === 'undefined') {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}
function format$1(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var i = 0;
  var len = args.length;

  if (typeof template === 'function') {
    return template.apply(null, args);
  }

  if (typeof template === 'string') {
    var str = template.replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }

      if (i >= len) {
        return x;
      }

      switch (x) {
        case '%s':
          return String(args[i++]);

        case '%d':
          return Number(args[i++]);

        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }

          break;

        default:
          return x;
      }
    });
    return str;
  }

  return template;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }

  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }

  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }

  return false;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors || []);
    total++;

    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }

    var original = index;
    index = index + 1;

    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k] || []);
  });
  return ret;
}

var AsyncValidationError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(AsyncValidationError, _Error);

  function AsyncValidationError(errors, fields) {
    var _this;

    _this = _Error.call(this, 'Async Validation Error') || this;
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }

  return AsyncValidationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
function asyncMap(objArr, option, func, callback, source) {
  if (option.first) {
    var _pending = new Promise(function (resolve, reject) {
      var next = function next(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve(source);
      };

      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next);
    });

    _pending["catch"](function (e) {
      return e;
    });

    return _pending;
  }

  var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;

      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve(source);
      }
    };

    if (!objArrKeys.length) {
      callback(results);
      resolve(source);
    }

    objArrKeys.forEach(function (key) {
      var arr = objArr[key];

      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending["catch"](function (e) {
    return e;
  });
  return pending;
}

function isErrorObj(obj) {
  return !!(obj && obj.message !== undefined);
}

function getValue$1(value, path) {
  var v = value;

  for (var i = 0; i < path.length; i++) {
    if (v == undefined) {
      return v;
    }

    v = v[path[i]];
  }

  return v;
}

function complementError(rule, source) {
  return function (oe) {
    var fieldValue;

    if (rule.fullFields) {
      fieldValue = getValue$1(source, rule.fullFields);
    } else {
      fieldValue = source[oe.field || rule.fullField];
    }

    if (isErrorObj(oe)) {
      oe.field = oe.field || rule.fullField;
      oe.fieldValue = fieldValue;
      return oe;
    }

    return {
      message: typeof oe === 'function' ? oe() : oe,
      fieldValue: fieldValue,
      field: oe.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];

        if (typeof value === 'object' && typeof target[s] === 'object') {
          target[s] = _extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }

  return target;
}

var required$1 = function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type || rule.type))) {
    errors.push(format$1(options.messages.required, rule.fullField));
  }
};

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

var whitespace = function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(format$1(options.messages.whitespace, rule.fullField));
  }
};

// https://github.com/kevva/url-regex/blob/master/index.js
var urlReg;
var getUrlRegex = (function () {
  if (urlReg) {
    return urlReg;
  }

  var word = '[a-fA-F\\d:]';

  var b = function b(options) {
    return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : '';
  };

  var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
  var v6seg = '[a-fA-F\\d]{1,4}';
  var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, '').replace(/\n/g, '').trim(); // Pre-compile only the exact regexes because adding a global flag make regexes stateful

  var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
  var v4exact = new RegExp("^" + v4 + "$");
  var v6exact = new RegExp("^" + v6 + "$");

  var ip = function ip(options) {
    return options && options.exact ? v46Exact : new RegExp("(?:" + b(options) + v4 + b(options) + ")|(?:" + b(options) + v6 + b(options) + ")", 'g');
  };

  ip.v4 = function (options) {
    return options && options.exact ? v4exact : new RegExp("" + b(options) + v4 + b(options), 'g');
  };

  ip.v6 = function (options) {
    return options && options.exact ? v6exact : new RegExp("" + b(options) + v6 + b(options), 'g');
  };

  var protocol = "(?:(?:[a-z]+:)?//)";
  var auth = '(?:\\S+(?::\\S*)?@)?';
  var ipv4 = ip.v4().source;
  var ipv6 = ip.v6().source;
  var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
  var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
  var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
  var port = '(?::\\d{2,5})?';
  var path = '(?:[/?#][^\\s"]*)?';
  var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
  urlReg = new RegExp("(?:^" + regex + "$)", 'i');
  return urlReg;
});

/* eslint max-len:0 */

var pattern$2 = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  "float": function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }

    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }

    return typeof value === 'number';
  },
  object: function object(value) {
    return typeof value === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && value.length <= 320 && !!value.match(pattern$2.email);
  },
  url: function url(value) {
    return typeof value === 'string' && value.length <= 2048 && !!value.match(getUrlRegex());
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern$2.hex);
  }
};

var type$1 = function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    required$1(rule, value, source, errors, options);
    return;
  }

  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;

  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(format$1(options.messages.types[ruleType], rule.fullField, rule.type));
    } // straight typeof check

  } else if (ruleType && typeof value !== rule.type) {
    errors.push(format$1(options.messages.types[ruleType], rule.fullField, rule.type));
  }
};

var range = function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number'; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）

  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);

  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  } // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type


  if (!key) {
    return false;
  }

  if (arr) {
    val = value.length;
  }

  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }

  if (len) {
    if (val !== rule.len) {
      errors.push(format$1(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(format$1(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(format$1(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(format$1(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
};

var ENUM$1 = 'enum';

var enumerable$1 = function enumerable(rule, value, source, errors, options) {
  rule[ENUM$1] = Array.isArray(rule[ENUM$1]) ? rule[ENUM$1] : [];

  if (rule[ENUM$1].indexOf(value) === -1) {
    errors.push(format$1(options.messages[ENUM$1], rule.fullField, rule[ENUM$1].join(', ')));
  }
};

var pattern$1 = function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;

      if (!rule.pattern.test(value)) {
        errors.push(format$1(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);

      if (!_pattern.test(value)) {
        errors.push(format$1(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
};

var rules = {
  required: required$1,
  whitespace: whitespace,
  type: type$1,
  range: range,
  "enum": enumerable$1,
  pattern: pattern$1
};

var string = function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, 'string') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, 'string');

    if (!isEmptyValue(value, 'string')) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
      rules.pattern(rule, value, source, errors, options);

      if (rule.whitespace === true) {
        rules.whitespace(rule, value, source, errors, options);
      }
    }
  }

  callback(errors);
};

var method = function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var number = function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (value === '') {
      value = undefined;
    }

    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var _boolean = function _boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var regexp = function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value)) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var integer = function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var floatFn = function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var array = function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if ((value === undefined || value === null) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, 'array');

    if (value !== undefined && value !== null) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var object = function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var ENUM = 'enum';

var enumerable = function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules[ENUM](rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var pattern$3 = function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, 'string') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value, 'string')) {
      rules.pattern(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var date = function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field); // console.log('validate on %s value', value);

  if (validate) {
    if (isEmptyValue(value, 'date') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value, 'date')) {
      var dateObject;

      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }

      rules.type(rule, dateObject, source, errors, options);

      if (dateObject) {
        rules.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }

  callback(errors);
};

var required = function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value;
  rules.required(rule, value, source, errors, options, type);
  callback(errors);
};

var type = function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, ruleType);

    if (!isEmptyValue(value, ruleType)) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
};

var any = function any(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);
  }

  callback(errors);
};

var validators = {
  string: string,
  method: method,
  number: number,
  "boolean": _boolean,
  regexp: regexp,
  integer: integer,
  "float": floatFn,
  array: array,
  object: object,
  "enum": enumerable,
  pattern: pattern$3,
  date: date,
  url: type,
  hex: type,
  email: type,
  required: required,
  any: any
};

function newMessages() {
  return {
    "default": 'Validation error on field %s',
    required: '%s is required',
    "enum": '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      "boolean": '%s is not a %s',
      integer: '%s is not an %s',
      "float": '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */

var Schema = /*#__PURE__*/function () {
  // ========================= Static =========================
  // ======================== Instance ========================
  function Schema(descriptor) {
    this.rules = null;
    this._messages = messages;
    this.define(descriptor);
  }

  var _proto = Schema.prototype;

  _proto.define = function define(rules) {
    var _this = this;

    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }

    if (typeof rules !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }

    this.rules = {};
    Object.keys(rules).forEach(function (name) {
      var item = rules[name];
      _this.rules[name] = Array.isArray(item) ? item : [item];
    });
  };

  _proto.messages = function messages(_messages) {
    if (_messages) {
      this._messages = deepMerge(newMessages(), _messages);
    }

    return this._messages;
  };

  _proto.validate = function validate(source_, o, oc) {
    var _this2 = this;

    if (o === void 0) {
      o = {};
    }

    if (oc === void 0) {
      oc = function oc() {};
    }

    var source = source_;
    var options = o;
    var callback = oc;

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback(null, source);
      }

      return Promise.resolve(source);
    }

    function complete(results) {
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (var i = 0; i < results.length; i++) {
        add(results[i]);
      }

      if (!errors.length) {
        callback(null, source);
      } else {
        fields = convertFieldsError(errors);
        callback(errors, fields);
      }
    }

    if (options.messages) {
      var messages$1 = this.messages();

      if (messages$1 === messages) {
        messages$1 = newMessages();
      }

      deepMerge(messages$1, options.messages);
      options.messages = messages$1;
    } else {
      options.messages = this.messages();
    }

    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      var arr = _this2.rules[z];
      var value = source[z];
      arr.forEach(function (r) {
        var rule = r;

        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = _extends({}, source);
          }

          value = source[z] = rule.transform(value);
        }

        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        } // Fill validator. Skip if nothing need to validate


        rule.validator = _this2.getValidationMethod(rule);

        if (!rule.validator) {
          return;
        }

        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this2.getType(rule);
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return asyncMap(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (typeof rule.fields === 'object' || typeof rule.defaultField === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullField(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + "." + key,
          fullFields: rule.fullFields ? [].concat(rule.fullFields, [key]) : [key]
        });
      }

      function cb(e) {
        if (e === void 0) {
          e = [];
        }

        var errorList = Array.isArray(e) ? e : [e];

        if (!options.suppressWarning && errorList.length) {
          Schema.warning('async-validator:', errorList);
        }

        if (errorList.length && rule.message !== undefined) {
          errorList = [].concat(rule.message);
        } // Fill error info


        var filledErrors = errorList.map(complementError(rule, source));

        if (options.first && filledErrors.length) {
          errorFields[rule.field] = 1;
          return doIt(filledErrors);
        }

        if (!deep) {
          doIt(filledErrors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message !== undefined) {
              filledErrors = [].concat(rule.message).map(complementError(rule, source));
            } else if (options.error) {
              filledErrors = [options.error(rule, format$1(options.messages.required, rule.field))];
            }

            return doIt(filledErrors);
          }

          var fieldsSchema = {};

          if (rule.defaultField) {
            Object.keys(data.value).map(function (key) {
              fieldsSchema[key] = rule.defaultField;
            });
          }

          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          var paredFieldsSchema = {};
          Object.keys(fieldsSchema).forEach(function (field) {
            var fieldSchema = fieldsSchema[field];
            var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [fieldSchema];
            paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
          });
          var schema = new Schema(paredFieldsSchema);
          schema.messages(options.messages);

          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }

          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];

            if (filledErrors && filledErrors.length) {
              finalErrors.push.apply(finalErrors, filledErrors);
            }

            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }

            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res;

      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        try {
          res = rule.validator(rule, data.value, cb, data.source, options);
        } catch (error) {
          console.error == null ? void 0 : console.error(error); // rethrow to report error

          if (!options.suppressValidatorError) {
            setTimeout(function () {
              throw error;
            }, 0);
          }

          cb(error.message);
        }

        if (res === true) {
          cb();
        } else if (res === false) {
          cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }

      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    }, source);
  };

  _proto.getType = function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }

    if (typeof rule.validator !== 'function' && rule.type && !validators.hasOwnProperty(rule.type)) {
      throw new Error(format$1('Unknown rule type %s', rule.type));
    }

    return rule.type || 'string';
  };

  _proto.getValidationMethod = function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }

    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');

    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }

    if (keys.length === 1 && keys[0] === 'required') {
      return validators.required;
    }

    return validators[this.getType(rule)] || undefined;
  };

  return Schema;
}();

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }

  validators[type] = validator;
};

Schema.warning = warning;
Schema.messages = messages;
Schema.validators = validators;

var typeTemplate = "'${name}' is not a valid ${type}";
var defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: typeTemplate,
    method: typeTemplate,
    array: typeTemplate,
    object: typeTemplate,
    number: typeTemplate,
    date: typeTemplate,
    boolean: typeTemplate,
    integer: typeTemplate,
    float: typeTemplate,
    regexp: typeTemplate,
    email: typeTemplate,
    url: typeTemplate,
    hex: typeTemplate
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};

function get(entity, path) {
  var current = entity;

  for (var i = 0; i < path.length; i += 1) {
    if (current === null || current === undefined) {
      return undefined;
    }

    current = current[path[i]];
  }

  return current;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function internalSet(entity, paths, value, removeIfUndefined) {
  if (!paths.length) {
    return value;
  }

  var _paths = _toArray(paths),
      path = _paths[0],
      restPath = _paths.slice(1);

  var clone;

  if (!entity && typeof path === 'number') {
    clone = [];
  } else if (Array.isArray(entity)) {
    clone = _toConsumableArray(entity);
  } else {
    clone = _objectSpread2({}, entity);
  } // Delete prop if `removeIfUndefined` and value is undefined


  if (removeIfUndefined && value === undefined && restPath.length === 1) {
    delete clone[path][restPath[0]];
  } else {
    clone[path] = internalSet(clone[path], restPath, value, removeIfUndefined);
  }

  return clone;
}

function set(entity, paths, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  // Do nothing if `removeIfUndefined` and parent object not exist
  if (paths.length && removeIfUndefined && value === undefined && !get(entity, paths.slice(0, -1))) {
    return entity;
  }

  return internalSet(entity, paths, value, removeIfUndefined);
}

/**
 * Convert name to internal supported format.
 * This function should keep since we still thinking if need support like `a.b.c` format.
 * 'a' => ['a']
 * 123 => [123]
 * ['a', 123] => ['a', 123]
 */

function getNamePath(path) {
  return toArray(path);
}
function getValue(store, namePath) {
  var value = get(store, namePath);
  return value;
}
function setValue(store, namePath, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var newStore = set(store, namePath, value, removeIfUndefined);
  return newStore;
}
function cloneByNamePathList(store, namePathList) {
  var newStore = {};
  namePathList.forEach(function (namePath) {
    var value = getValue(store, namePath);
    newStore = setValue(newStore, namePath, value);
  });
  return newStore;
}
function containsNamePath(namePathList, namePath) {
  return namePathList && namePathList.some(function (path) {
    return matchNamePath(path, namePath);
  });
}

function isObject(obj) {
  return _typeof(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
/**
 * Copy values into store and return a new values object
 * ({ a: 1, b: { c: 2 } }, { a: 4, b: { d: 5 } }) => { a: 4, b: { c: 2, d: 5 } }
 */


function internalSetValues(store, values) {
  var newStore = Array.isArray(store) ? _toConsumableArray(store) : _objectSpread2({}, store);

  if (!values) {
    return newStore;
  }

  Object.keys(values).forEach(function (key) {
    var prevValue = newStore[key];
    var value = values[key]; // If both are object (but target is not array), we use recursion to set deep value

    var recursive = isObject(prevValue) && isObject(value);
    newStore[key] = recursive ? internalSetValues(prevValue, value || {}) : value;
  });
  return newStore;
}

function setValues(store) {
  for (var _len = arguments.length, restValues = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restValues[_key - 1] = arguments[_key];
  }

  return restValues.reduce(function (current, newStore) {
    return internalSetValues(current, newStore);
  }, store);
}
function matchNamePath(namePath, changedNamePath) {
  if (!namePath || !changedNamePath || namePath.length !== changedNamePath.length) {
    return false;
  }

  return namePath.every(function (nameUnit, i) {
    return changedNamePath[i] === nameUnit;
  });
}
function isSimilar(source, target) {
  if (source === target) {
    return true;
  }

  if (!source && target || source && !target) {
    return false;
  }

  if (!source || !target || _typeof(source) !== 'object' || _typeof(target) !== 'object') {
    return false;
  }

  var sourceKeys = Object.keys(source);
  var targetKeys = Object.keys(target);
  var keys = new Set([].concat(_toConsumableArray(sourceKeys), _toConsumableArray(targetKeys)));
  return _toConsumableArray(keys).every(function (key) {
    var sourceValue = source[key];
    var targetValue = target[key];

    if (typeof sourceValue === 'function' && typeof targetValue === 'function') {
      return true;
    }

    return sourceValue === targetValue;
  });
}
function defaultGetValueFromEvent(valuePropName) {
  var event = arguments.length <= 1 ? undefined : arguments[1];

  if (event && event.target && valuePropName in event.target) {
    return event.target[valuePropName];
  }

  return event;
}
/**
 * Moves an array item from one position in an array to another.
 *
 * Note: This is a pure function so a new array will be returned, instead
 * of altering the array argument.
 *
 * @param array         Array in which to move an item.         (required)
 * @param moveIndex     The index of the item to move.          (required)
 * @param toIndex       The index to move item at moveIndex to. (required)
 */

function move(array, moveIndex, toIndex) {
  var length = array.length;

  if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) {
    return array;
  }

  var item = array[moveIndex];
  var diff = moveIndex - toIndex;

  if (diff > 0) {
    // move left
    return [].concat(_toConsumableArray(array.slice(0, toIndex)), [item], _toConsumableArray(array.slice(toIndex, moveIndex)), _toConsumableArray(array.slice(moveIndex + 1, length)));
  }

  if (diff < 0) {
    // move right
    return [].concat(_toConsumableArray(array.slice(0, moveIndex)), _toConsumableArray(array.slice(moveIndex + 1, toIndex + 1)), [item], _toConsumableArray(array.slice(toIndex + 1, length)));
  }

  return array;
}

var AsyncValidator = Schema;
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */

function replaceMessage(template, kv) {
  return template.replace(/\$\{\w+\}/g, function (str) {
    var key = str.slice(2, -1);
    return kv[key];
  });
}

function validateRule(_x, _x2, _x3, _x4, _x5) {
  return _validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */


function _validateRule() {
  _validateRule = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(name, value, rule, options, messageVariables) {
    var cloneRule, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cloneRule = _objectSpread2({}, rule); // Bug of `async-validator`
            // https://github.com/react-component/field-form/issues/316
            // https://github.com/react-component/field-form/issues/313

            delete cloneRule.ruleIndex; // We should special handle array validate

            subRuleField = null;

            if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
              subRuleField = cloneRule.defaultField;
              delete cloneRule.defaultField;
            }

            validator = new AsyncValidator(_defineProperty({}, name, [cloneRule]));
            messages = setValues({}, defaultValidateMessages, options.validateMessages);
            validator.messages(messages);
            result = [];
            _context2.prev = 8;
            _context2.next = 11;
            return Promise.resolve(validator.validate(_defineProperty({}, name, value), _objectSpread2({}, options)));

          case 11:
            _context2.next = 16;
            break;

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](8);

            if (_context2.t0.errors) {
              result = _context2.t0.errors.map(function (_ref4, index) {
                var message = _ref4.message;
                return (// Wrap ReactNode with `key`

                  /*#__PURE__*/
                  React.isValidElement(message) ? /*#__PURE__*/React.cloneElement(message, {
                    key: "error_".concat(index)
                  }) : message
                );
              });
            } else {
              console.error(_context2.t0);
              result = [messages.default];
            }

          case 16:
            if (!(!result.length && subRuleField)) {
              _context2.next = 21;
              break;
            }

            _context2.next = 19;
            return Promise.all(value.map(function (subValue, i) {
              return validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
            }));

          case 19:
            subResults = _context2.sent;
            return _context2.abrupt("return", subResults.reduce(function (prev, errors) {
              return [].concat(_toConsumableArray(prev), _toConsumableArray(errors));
            }, []));

          case 21:
            // Replace message with variables
            kv = _objectSpread2(_objectSpread2({}, rule), {}, {
              name: name,
              enum: (rule.enum || []).join(', ')
            }, messageVariables);
            fillVariableResult = result.map(function (error) {
              if (typeof error === 'string') {
                return replaceMessage(error, kv);
              }

              return error;
            });
            return _context2.abrupt("return", fillVariableResult);

          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[8, 13]]);
  }));
  return _validateRule.apply(this, arguments);
}

function validateRules(namePath, value, rules, options, validateFirst, messageVariables) {
  var name = namePath.join('.'); // Fill rule with context

  var filledRules = rules.map(function (currentRule, ruleIndex) {
    var originValidatorFunc = currentRule.validator;

    var cloneRule = _objectSpread2(_objectSpread2({}, currentRule), {}, {
      ruleIndex: ruleIndex
    }); // Replace validator if needed


    if (originValidatorFunc) {
      cloneRule.validator = function (rule, val, callback) {
        var hasPromise = false; // Wrap callback only accept when promise not provided

        var wrappedCallback = function wrappedCallback() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          // Wait a tick to make sure return type is a promise
          Promise.resolve().then(function () {
            warningOnce(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');

            if (!hasPromise) {
              callback.apply(void 0, args);
            }
          });
        }; // Get promise


        var promise = originValidatorFunc(rule, val, wrappedCallback);
        hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
        /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */

        warningOnce(hasPromise, '`callback` is deprecated. Please return a promise instead.');

        if (hasPromise) {
          promise.then(function () {
            callback();
          }).catch(function (err) {
            callback(err || ' ');
          });
        }
      };
    }

    return cloneRule;
  }).sort(function (_ref, _ref2) {
    var w1 = _ref.warningOnly,
        i1 = _ref.ruleIndex;
    var w2 = _ref2.warningOnly,
        i2 = _ref2.ruleIndex;

    if (!!w1 === !!w2) {
      // Let keep origin order
      return i1 - i2;
    }

    if (w1) {
      return 1;
    }

    return -1;
  }); // Do validate rules

  var summaryPromise;

  if (validateFirst === true) {
    // >>>>> Validate by serialization
    summaryPromise = new Promise( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(resolve, reject) {
        var i, rule, errors;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < filledRules.length)) {
                  _context.next = 12;
                  break;
                }

                rule = filledRules[i];
                _context.next = 5;
                return validateRule(name, value, rule, options, messageVariables);

              case 5:
                errors = _context.sent;

                if (!errors.length) {
                  _context.next = 9;
                  break;
                }

                reject([{
                  errors: errors,
                  rule: rule
                }]);
                return _context.abrupt("return");

              case 9:
                i += 1;
                _context.next = 1;
                break;

              case 12:
                /* eslint-enable */
                resolve([]);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x6, _x7) {
        return _ref3.apply(this, arguments);
      };
    }());
  } else {
    // >>>>> Validate by parallel
    var rulePromises = filledRules.map(function (rule) {
      return validateRule(name, value, rule, options, messageVariables).then(function (errors) {
        return {
          errors: errors,
          rule: rule
        };
      });
    });
    summaryPromise = (validateFirst ? finishOnFirstFailed(rulePromises) : finishOnAllFailed(rulePromises)).then(function (errors) {
      // Always change to rejection for Field to catch
      return Promise.reject(errors);
    });
  } // Internal catch error to avoid console error log.


  summaryPromise.catch(function (e) {
    return e;
  });
  return summaryPromise;
}

function finishOnAllFailed(_x8) {
  return _finishOnAllFailed.apply(this, arguments);
}

function _finishOnAllFailed() {
  _finishOnAllFailed = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(rulePromises) {
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", Promise.all(rulePromises).then(function (errorsList) {
              var _ref5;

              var errors = (_ref5 = []).concat.apply(_ref5, _toConsumableArray(errorsList));

              return errors;
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _finishOnAllFailed.apply(this, arguments);
}

function finishOnFirstFailed(_x9) {
  return _finishOnFirstFailed.apply(this, arguments);
}

function _finishOnFirstFailed() {
  _finishOnFirstFailed = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(rulePromises) {
    var count;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            count = 0;
            return _context4.abrupt("return", new Promise(function (resolve) {
              rulePromises.forEach(function (promise) {
                promise.then(function (ruleError) {
                  if (ruleError.errors.length) {
                    resolve([ruleError]);
                  }

                  count += 1;

                  if (count === rulePromises.length) {
                    resolve([]);
                  }
                });
              });
            }));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _finishOnFirstFailed.apply(this, arguments);
}

var _excluded$2 = ["name"];
var EMPTY_ERRORS = [];

function requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
  if (typeof shouldUpdate === 'function') {
    return shouldUpdate(prev, next, 'source' in info ? {
      source: info.source
    } : {});
  }

  return prevValue !== nextValue;
} // We use Class instead of Hooks here since it will cost much code by using Hooks.


var Field = /*#__PURE__*/function (_React$Component) {
  _inherits(Field, _React$Component);

  var _super = _createSuper(Field);

  /**
   * Follow state should not management in State since it will async update by React.
   * This makes first render of form can not get correct state value.
   */

  /**
   * Mark when touched & validated. Currently only used for `dependencies`.
   * Note that we do not think field with `initialValue` is dirty
   * but this will be by `isFieldDirty` func.
   */
  // ============================== Subscriptions ==============================
  function Field(props) {
    var _this;

    _classCallCheck(this, Field);

    _this = _super.call(this, props); // Register on init

    _this.state = {
      resetCount: 0
    };
    _this.cancelRegisterFunc = null;
    _this.mounted = false;
    _this.touched = false;
    _this.dirty = false;
    _this.validatePromise = null;
    _this.prevValidating = void 0;
    _this.errors = EMPTY_ERRORS;
    _this.warnings = EMPTY_ERRORS;

    _this.cancelRegister = function () {
      var _this$props = _this.props,
          preserve = _this$props.preserve,
          isListField = _this$props.isListField,
          name = _this$props.name;

      if (_this.cancelRegisterFunc) {
        _this.cancelRegisterFunc(isListField, preserve, getNamePath(name));
      }

      _this.cancelRegisterFunc = null;
    };

    _this.getNamePath = function () {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          fieldContext = _this$props2.fieldContext;
      var _fieldContext$prefixN = fieldContext.prefixName,
          prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
      return name !== undefined ? [].concat(_toConsumableArray(prefixName), _toConsumableArray(name)) : [];
    };

    _this.getRules = function () {
      var _this$props3 = _this.props,
          _this$props3$rules = _this$props3.rules,
          rules = _this$props3$rules === void 0 ? [] : _this$props3$rules,
          fieldContext = _this$props3.fieldContext;
      return rules.map(function (rule) {
        if (typeof rule === 'function') {
          return rule(fieldContext);
        }

        return rule;
      });
    };

    _this.refresh = function () {
      if (!_this.mounted) return;
      /**
       * Clean up current node.
       */

      _this.setState(function (_ref) {
        var resetCount = _ref.resetCount;
        return {
          resetCount: resetCount + 1
        };
      });
    };

    _this.triggerMetaEvent = function (destroy) {
      var onMetaChange = _this.props.onMetaChange;
      onMetaChange === null || onMetaChange === void 0 ? void 0 : onMetaChange(_objectSpread2(_objectSpread2({}, _this.getMeta()), {}, {
        destroy: destroy
      }));
    };

    _this.onStoreChange = function (prevStore, namePathList, info) {
      var _this$props4 = _this.props,
          shouldUpdate = _this$props4.shouldUpdate,
          _this$props4$dependen = _this$props4.dependencies,
          dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen,
          onReset = _this$props4.onReset;
      var store = info.store;

      var namePath = _this.getNamePath();

      var prevValue = _this.getValue(prevStore);

      var curValue = _this.getValue(store);

      var namePathMatch = namePathList && containsNamePath(namePathList, namePath); // `setFieldsValue` is a quick access to update related status

      if (info.type === 'valueUpdate' && info.source === 'external' && prevValue !== curValue) {
        _this.touched = true;
        _this.dirty = true;
        _this.validatePromise = null;
        _this.errors = EMPTY_ERRORS;
        _this.warnings = EMPTY_ERRORS;

        _this.triggerMetaEvent();
      }

      switch (info.type) {
        case 'reset':
          if (!namePathList || namePathMatch) {
            // Clean up state
            _this.touched = false;
            _this.dirty = false;
            _this.validatePromise = null;
            _this.errors = EMPTY_ERRORS;
            _this.warnings = EMPTY_ERRORS;

            _this.triggerMetaEvent();

            onReset === null || onReset === void 0 ? void 0 : onReset();

            _this.refresh();

            return;
          }

          break;

        /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */

        case 'remove':
          {
            if (shouldUpdate) {
              _this.reRender();

              return;
            }

            break;
          }

        case 'setField':
          {
            if (namePathMatch) {
              var data = info.data;

              if ('touched' in data) {
                _this.touched = data.touched;
              }

              if ('validating' in data && !('originRCField' in data)) {
                _this.validatePromise = data.validating ? Promise.resolve([]) : null;
              }

              if ('errors' in data) {
                _this.errors = data.errors || EMPTY_ERRORS;
              }

              if ('warnings' in data) {
                _this.warnings = data.warnings || EMPTY_ERRORS;
              }

              _this.dirty = true;

              _this.triggerMetaEvent();

              _this.reRender();

              return;
            } // Handle update by `setField` with `shouldUpdate`


            if (shouldUpdate && !namePath.length && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
              _this.reRender();

              return;
            }

            break;
          }

        case 'dependenciesUpdate':
          {
            /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */
            var dependencyList = dependencies.map(getNamePath); // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
            // emitted earlier and they will work there
            // If set it may cause unnecessary twice rerendering

            if (dependencyList.some(function (dependency) {
              return containsNamePath(info.relatedFields, dependency);
            })) {
              _this.reRender();

              return;
            }

            break;
          }

        default:
          // 1. If `namePath` exists in `namePathList`, means it's related value and should update
          //      For example <List name="list"><Field name={['list', 0]}></List>
          //      If `namePathList` is [['list']] (List value update), Field should be updated
          //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
          // 2.
          //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
          //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
          //       is not provided
          //   2.2 If `shouldUpdate` provided, use customize logic to update the field
          //       else to check if value changed
          if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
            _this.reRender();

            return;
          }

          break;
      }

      if (shouldUpdate === true) {
        _this.reRender();
      }
    };

    _this.validateRules = function (options) {
      // We should fixed namePath & value to avoid developer change then by form function
      var namePath = _this.getNamePath();

      var currentValue = _this.getValue(); // Force change to async to avoid rule OOD under renderProps field


      var rootPromise = Promise.resolve().then(function () {
        if (!_this.mounted) {
          return [];
        }

        var _this$props5 = _this.props,
            _this$props5$validate = _this$props5.validateFirst,
            validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate,
            messageVariables = _this$props5.messageVariables;

        var _ref2 = options || {},
            triggerName = _ref2.triggerName;

        var filteredRules = _this.getRules();

        if (triggerName) {
          filteredRules = filteredRules.filter(function (rule) {
            var validateTrigger = rule.validateTrigger;

            if (!validateTrigger) {
              return true;
            }

            var triggerList = toArray(validateTrigger);
            return triggerList.includes(triggerName);
          });
        }

        var promise = validateRules(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
        promise.catch(function (e) {
          return e;
        }).then(function () {
          var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ERRORS;

          if (_this.validatePromise === rootPromise) {
            _this.validatePromise = null; // Get errors & warnings

            var nextErrors = [];
            var nextWarnings = [];
            ruleErrors.forEach(function (_ref3) {
              var warningOnly = _ref3.rule.warningOnly,
                  _ref3$errors = _ref3.errors,
                  errors = _ref3$errors === void 0 ? EMPTY_ERRORS : _ref3$errors;

              if (warningOnly) {
                nextWarnings.push.apply(nextWarnings, _toConsumableArray(errors));
              } else {
                nextErrors.push.apply(nextErrors, _toConsumableArray(errors));
              }
            });
            _this.errors = nextErrors;
            _this.warnings = nextWarnings;

            _this.triggerMetaEvent();

            _this.reRender();
          }
        });
        return promise;
      });
      _this.validatePromise = rootPromise;
      _this.dirty = true;
      _this.errors = EMPTY_ERRORS;
      _this.warnings = EMPTY_ERRORS;

      _this.triggerMetaEvent(); // Force trigger re-render since we need sync renderProps with new meta


      _this.reRender();

      return rootPromise;
    };

    _this.isFieldValidating = function () {
      return !!_this.validatePromise;
    };

    _this.isFieldTouched = function () {
      return _this.touched;
    };

    _this.isFieldDirty = function () {
      // Touched or validate or has initialValue
      if (_this.dirty || _this.props.initialValue !== undefined) {
        return true;
      } // Form set initialValue


      var fieldContext = _this.props.fieldContext;

      var _fieldContext$getInte = fieldContext.getInternalHooks(HOOK_MARK),
          getInitialValue = _fieldContext$getInte.getInitialValue;

      if (getInitialValue(_this.getNamePath()) !== undefined) {
        return true;
      }

      return false;
    };

    _this.getErrors = function () {
      return _this.errors;
    };

    _this.getWarnings = function () {
      return _this.warnings;
    };

    _this.isListField = function () {
      return _this.props.isListField;
    };

    _this.isList = function () {
      return _this.props.isList;
    };

    _this.isPreserve = function () {
      return _this.props.preserve;
    };

    _this.getMeta = function () {
      // Make error & validating in cache to save perf
      _this.prevValidating = _this.isFieldValidating();
      var meta = {
        touched: _this.isFieldTouched(),
        validating: _this.prevValidating,
        errors: _this.errors,
        warnings: _this.warnings,
        name: _this.getNamePath()
      };
      return meta;
    };

    _this.getOnlyChild = function (children) {
      // Support render props
      if (typeof children === 'function') {
        var meta = _this.getMeta();

        return _objectSpread2(_objectSpread2({}, _this.getOnlyChild(children(_this.getControlled(), meta, _this.props.fieldContext))), {}, {
          isFunction: true
        });
      } // Filed element only


      var childList = toArray$1(children);

      if (childList.length !== 1 || ! /*#__PURE__*/React.isValidElement(childList[0])) {
        return {
          child: childList,
          isFunction: false
        };
      }

      return {
        child: childList[0],
        isFunction: false
      };
    };

    _this.getValue = function (store) {
      var getFieldsValue = _this.props.fieldContext.getFieldsValue;

      var namePath = _this.getNamePath();

      return getValue(store || getFieldsValue(true), namePath);
    };

    _this.getControlled = function () {
      var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props6 = _this.props,
          trigger = _this$props6.trigger,
          validateTrigger = _this$props6.validateTrigger,
          getValueFromEvent = _this$props6.getValueFromEvent,
          normalize = _this$props6.normalize,
          valuePropName = _this$props6.valuePropName,
          getValueProps = _this$props6.getValueProps,
          fieldContext = _this$props6.fieldContext;
      var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;

      var namePath = _this.getNamePath();

      var getInternalHooks = fieldContext.getInternalHooks,
          getFieldsValue = fieldContext.getFieldsValue;

      var _getInternalHooks = getInternalHooks(HOOK_MARK),
          dispatch = _getInternalHooks.dispatch;

      var value = _this.getValue();

      var mergedGetValueProps = getValueProps || function (val) {
        return _defineProperty({}, valuePropName, val);
      }; // eslint-disable-next-line @typescript-eslint/no-explicit-any


      var originTriggerFunc = childProps[trigger];

      var control = _objectSpread2(_objectSpread2({}, childProps), mergedGetValueProps(value)); // Add trigger


      control[trigger] = function () {
        // Mark as touched
        _this.touched = true;
        _this.dirty = true;

        _this.triggerMetaEvent();

        var newValue;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (getValueFromEvent) {
          newValue = getValueFromEvent.apply(void 0, args);
        } else {
          newValue = defaultGetValueFromEvent.apply(void 0, [valuePropName].concat(args));
        }

        if (normalize) {
          newValue = normalize(newValue, value, getFieldsValue(true));
        }

        dispatch({
          type: 'updateValue',
          namePath: namePath,
          value: newValue
        });

        if (originTriggerFunc) {
          originTriggerFunc.apply(void 0, args);
        }
      }; // Add validateTrigger


      var validateTriggerList = toArray(mergedValidateTrigger || []);
      validateTriggerList.forEach(function (triggerName) {
        // Wrap additional function of component, so that we can get latest value from store
        var originTrigger = control[triggerName];

        control[triggerName] = function () {
          if (originTrigger) {
            originTrigger.apply(void 0, arguments);
          } // Always use latest rules


          var rules = _this.props.rules;

          if (rules && rules.length) {
            // We dispatch validate to root,
            // since it will update related data with other field with same name
            dispatch({
              type: 'validateField',
              namePath: namePath,
              triggerName: triggerName
            });
          }
        };
      });
      return control;
    };

    if (props.fieldContext) {
      var getInternalHooks = props.fieldContext.getInternalHooks;

      var _getInternalHooks2 = getInternalHooks(HOOK_MARK),
          initEntityValue = _getInternalHooks2.initEntityValue;

      initEntityValue(_assertThisInitialized(_this));
    }

    return _this;
  }

  _createClass(Field, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
          shouldUpdate = _this$props7.shouldUpdate,
          fieldContext = _this$props7.fieldContext;
      this.mounted = true; // Register on init

      if (fieldContext) {
        var getInternalHooks = fieldContext.getInternalHooks;

        var _getInternalHooks3 = getInternalHooks(HOOK_MARK),
            registerField = _getInternalHooks3.registerField;

        this.cancelRegisterFunc = registerField(this);
      } // One more render for component in case fields not ready


      if (shouldUpdate === true) {
        this.reRender();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRegister();
      this.triggerMetaEvent(true);
      this.mounted = false;
    }
  }, {
    key: "reRender",
    value: function reRender() {
      if (!this.mounted) return;
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var resetCount = this.state.resetCount;
      var children = this.props.children;

      var _this$getOnlyChild = this.getOnlyChild(children),
          child = _this$getOnlyChild.child,
          isFunction = _this$getOnlyChild.isFunction; // Not need to `cloneElement` since user can handle this in render function self


      var returnChildNode;

      if (isFunction) {
        returnChildNode = child;
      } else if ( /*#__PURE__*/React.isValidElement(child)) {
        returnChildNode = /*#__PURE__*/React.cloneElement(child, this.getControlled(child.props));
      } else {
        warningOnce(!child, '`children` of Field is not validate ReactElement.');
        returnChildNode = child;
      }

      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: resetCount
      }, returnChildNode);
    }
  }]);

  return Field;
}(React.Component);

Field.contextType = Context;
Field.defaultProps = {
  trigger: 'onChange',
  valuePropName: 'value'
};

function WrapperField(_ref5) {
  var name = _ref5.name,
      restProps = _objectWithoutProperties(_ref5, _excluded$2);

  var fieldContext = React.useContext(Context);
  var namePath = name !== undefined ? getNamePath(name) : undefined;
  var key = 'keep';

  if (!restProps.isListField) {
    key = "_".concat((namePath || []).join('_'));
  } // Warning if it's a directly list field.
  // We can still support multiple level field preserve.


  if (process.env.NODE_ENV !== 'production' && restProps.preserve === false && restProps.isListField && namePath.length <= 1) {
    warningOnce(false, '`preserve` should not apply on Form.List fields.');
  }

  return /*#__PURE__*/React.createElement(Field, _extends$1({
    key: key,
    name: namePath
  }, restProps, {
    fieldContext: fieldContext
  }));
}

var ListContext = /*#__PURE__*/React.createContext(null);

var List$1 = function List(_ref) {
  var name = _ref.name,
      initialValue = _ref.initialValue,
      children = _ref.children,
      rules = _ref.rules,
      validateTrigger = _ref.validateTrigger;
  var context = React.useContext(Context);
  var keyRef = React.useRef({
    keys: [],
    id: 0
  });
  var keyManager = keyRef.current;
  var prefixName = React.useMemo(function () {
    var parentPrefixName = getNamePath(context.prefixName) || [];
    return [].concat(_toConsumableArray(parentPrefixName), _toConsumableArray(getNamePath(name)));
  }, [context.prefixName, name]);
  var fieldContext = React.useMemo(function () {
    return _objectSpread2(_objectSpread2({}, context), {}, {
      prefixName: prefixName
    });
  }, [context, prefixName]); // List context

  var listContext = React.useMemo(function () {
    return {
      getKey: function getKey(namePath) {
        var len = prefixName.length;
        var pathName = namePath[len];
        return [keyManager.keys[pathName], namePath.slice(len + 1)];
      }
    };
  }, [prefixName]); // User should not pass `children` as other type.

  if (typeof children !== 'function') {
    warningOnce(false, 'Form.List only accepts function as children.');
    return null;
  }

  var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
    var source = _ref2.source;

    if (source === 'internal') {
      return false;
    }

    return prevValue !== nextValue;
  };

  return /*#__PURE__*/React.createElement(ListContext.Provider, {
    value: listContext
  }, /*#__PURE__*/React.createElement(Context.Provider, {
    value: fieldContext
  }, /*#__PURE__*/React.createElement(WrapperField, {
    name: [],
    shouldUpdate: shouldUpdate,
    rules: rules,
    validateTrigger: validateTrigger,
    initialValue: initialValue,
    isList: true
  }, function (_ref3, meta) {
    var _ref3$value = _ref3.value,
        value = _ref3$value === void 0 ? [] : _ref3$value,
        onChange = _ref3.onChange;
    var getFieldValue = context.getFieldValue;

    var getNewValue = function getNewValue() {
      var values = getFieldValue(prefixName || []);
      return values || [];
    };
    /**
     * Always get latest value in case user update fields by `form` api.
     */


    var operations = {
      add: function add(defaultValue, index) {
        // Mapping keys
        var newValue = getNewValue();

        if (index >= 0 && index <= newValue.length) {
          keyManager.keys = [].concat(_toConsumableArray(keyManager.keys.slice(0, index)), [keyManager.id], _toConsumableArray(keyManager.keys.slice(index)));
          onChange([].concat(_toConsumableArray(newValue.slice(0, index)), [defaultValue], _toConsumableArray(newValue.slice(index))));
        } else {
          if (process.env.NODE_ENV !== 'production' && (index < 0 || index > newValue.length)) {
            warningOnce(false, 'The second parameter of the add function should be a valid positive number.');
          }

          keyManager.keys = [].concat(_toConsumableArray(keyManager.keys), [keyManager.id]);
          onChange([].concat(_toConsumableArray(newValue), [defaultValue]));
        }

        keyManager.id += 1;
      },
      remove: function remove(index) {
        var newValue = getNewValue();
        var indexSet = new Set(Array.isArray(index) ? index : [index]);

        if (indexSet.size <= 0) {
          return;
        }

        keyManager.keys = keyManager.keys.filter(function (_, keysIndex) {
          return !indexSet.has(keysIndex);
        }); // Trigger store change

        onChange(newValue.filter(function (_, valueIndex) {
          return !indexSet.has(valueIndex);
        }));
      },
      move: function move$1(from, to) {
        if (from === to) {
          return;
        }

        var newValue = getNewValue(); // Do not handle out of range

        if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) {
          return;
        }

        keyManager.keys = move(keyManager.keys, from, to); // Trigger store change

        onChange(move(newValue, from, to));
      }
    };
    var listValue = value || [];

    if (!Array.isArray(listValue)) {
      listValue = [];

      if (process.env.NODE_ENV !== 'production') {
        warningOnce(false, "Current value of '".concat(prefixName.join(' > '), "' is not an array type."));
      }
    }

    return children(listValue.map(function (__, index) {
      var key = keyManager.keys[index];

      if (key === undefined) {
        keyManager.keys[index] = keyManager.id;
        key = keyManager.keys[index];
        keyManager.id += 1;
      }

      return {
        name: index,
        key: key,
        isListField: true
      };
    }), operations, meta);
  })));
};

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function allPromiseFinish(promiseList) {
  var hasError = false;
  var count = promiseList.length;
  var results = [];

  if (!promiseList.length) {
    return Promise.resolve([]);
  }

  return new Promise(function (resolve, reject) {
    promiseList.forEach(function (promise, index) {
      promise.catch(function (e) {
        hasError = true;
        return e;
      }).then(function (result) {
        count -= 1;
        results[index] = result;

        if (count > 0) {
          return;
        }

        if (hasError) {
          reject(results);
        }

        resolve(results);
      });
    });
  });
}

var SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */

function normalize(namePath) {
  return namePath.map(function (cell) {
    return "".concat(_typeof(cell), ":").concat(cell);
  }) // Magic split
  .join(SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */


var NameMap = /*#__PURE__*/function () {
  function NameMap() {
    _classCallCheck(this, NameMap);

    this.kvs = new Map();
  }

  _createClass(NameMap, [{
    key: "set",
    value: function set(key, value) {
      this.kvs.set(normalize(key), value);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.kvs.get(normalize(key));
    }
  }, {
    key: "update",
    value: function update(key, updater) {
      var origin = this.get(key);
      var next = updater(origin);

      if (!next) {
        this.delete(key);
      } else {
        this.set(key, next);
      }
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      this.kvs.delete(normalize(key));
    } // Since we only use this in test, let simply realize this

  }, {
    key: "map",
    value: function map(callback) {
      return _toConsumableArray(this.kvs.entries()).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        var cells = key.split(SPLIT);
        return callback({
          key: cells.map(function (cell) {
            var _cell$match = cell.match(/^([^:]*):(.*)$/),
                _cell$match2 = _slicedToArray(_cell$match, 3),
                type = _cell$match2[1],
                unit = _cell$match2[2];

            return type === 'number' ? Number(unit) : unit;
          }),
          value: value
        });
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {};
      this.map(function (_ref3) {
        var key = _ref3.key,
            value = _ref3.value;
        json[key.join('.')] = value;
        return null;
      });
      return json;
    }
  }]);

  return NameMap;
}();

var _excluded$1 = ["name", "errors"];
var FormStore = function FormStore(forceRootUpdate) {
  var _this = this;

  _classCallCheck(this, FormStore);

  this.formHooked = false;
  this.forceRootUpdate = void 0;
  this.subscribable = true;
  this.store = {};
  this.fieldEntities = [];
  this.initialValues = {};
  this.callbacks = {};
  this.validateMessages = null;
  this.preserve = null;
  this.lastValidatePromise = null;

  this.getForm = function () {
    return {
      getFieldValue: _this.getFieldValue,
      getFieldsValue: _this.getFieldsValue,
      getFieldError: _this.getFieldError,
      getFieldWarning: _this.getFieldWarning,
      getFieldsError: _this.getFieldsError,
      isFieldsTouched: _this.isFieldsTouched,
      isFieldTouched: _this.isFieldTouched,
      isFieldValidating: _this.isFieldValidating,
      isFieldsValidating: _this.isFieldsValidating,
      resetFields: _this.resetFields,
      setFields: _this.setFields,
      setFieldsValue: _this.setFieldsValue,
      validateFields: _this.validateFields,
      submit: _this.submit,
      getInternalHooks: _this.getInternalHooks
    };
  };

  this.getInternalHooks = function (key) {
    if (key === HOOK_MARK) {
      _this.formHooked = true;
      return {
        dispatch: _this.dispatch,
        initEntityValue: _this.initEntityValue,
        registerField: _this.registerField,
        useSubscribe: _this.useSubscribe,
        setInitialValues: _this.setInitialValues,
        setCallbacks: _this.setCallbacks,
        setValidateMessages: _this.setValidateMessages,
        getFields: _this.getFields,
        setPreserve: _this.setPreserve,
        getInitialValue: _this.getInitialValue
      };
    }

    warningOnce(false, '`getInternalHooks` is internal usage. Should not call directly.');
    return null;
  };

  this.useSubscribe = function (subscribable) {
    _this.subscribable = subscribable;
  };

  this.setInitialValues = function (initialValues, init) {
    _this.initialValues = initialValues || {};

    if (init) {
      _this.store = setValues({}, initialValues, _this.store);
    }
  };

  this.getInitialValue = function (namePath) {
    return getValue(_this.initialValues, namePath);
  };

  this.setCallbacks = function (callbacks) {
    _this.callbacks = callbacks;
  };

  this.setValidateMessages = function (validateMessages) {
    _this.validateMessages = validateMessages;
  };

  this.setPreserve = function (preserve) {
    _this.preserve = preserve;
  };

  this.timeoutId = null;

  this.warningUnhooked = function () {
    if (process.env.NODE_ENV !== 'production' && !_this.timeoutId && typeof window !== 'undefined') {
      _this.timeoutId = setTimeout(function () {
        _this.timeoutId = null;

        if (!_this.formHooked) {
          warningOnce(false, 'Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?');
        }
      });
    }
  };

  this.getFieldEntities = function () {
    var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!pure) {
      return _this.fieldEntities;
    }

    return _this.fieldEntities.filter(function (field) {
      return field.getNamePath().length;
    });
  };

  this.getFieldsMap = function () {
    var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cache = new NameMap();

    _this.getFieldEntities(pure).forEach(function (field) {
      var namePath = field.getNamePath();
      cache.set(namePath, field);
    });

    return cache;
  };

  this.getFieldEntitiesForNamePathList = function (nameList) {
    if (!nameList) {
      return _this.getFieldEntities(true);
    }

    var cache = _this.getFieldsMap(true);

    return nameList.map(function (name) {
      var namePath = getNamePath(name);
      return cache.get(namePath) || {
        INVALIDATE_NAME_PATH: getNamePath(name)
      };
    });
  };

  this.getFieldsValue = function (nameList, filterFunc) {
    _this.warningUnhooked();

    if (nameList === true && !filterFunc) {
      return _this.store;
    }

    var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(nameList) ? nameList : null);

    var filteredNameList = [];
    fieldEntities.forEach(function (entity) {
      var _entity$isListField;

      var namePath = 'INVALIDATE_NAME_PATH' in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath(); // Ignore when it's a list item and not specific the namePath,
      // since parent field is already take in count

      if (!nameList && ((_entity$isListField = entity.isListField) === null || _entity$isListField === void 0 ? void 0 : _entity$isListField.call(entity))) {
        return;
      }

      if (!filterFunc) {
        filteredNameList.push(namePath);
      } else {
        var meta = 'getMeta' in entity ? entity.getMeta() : null;

        if (filterFunc(meta)) {
          filteredNameList.push(namePath);
        }
      }
    });
    return cloneByNamePathList(_this.store, filteredNameList.map(getNamePath));
  };

  this.getFieldValue = function (name) {
    _this.warningUnhooked();

    var namePath = getNamePath(name);
    return getValue(_this.store, namePath);
  };

  this.getFieldsError = function (nameList) {
    _this.warningUnhooked();

    var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);

    return fieldEntities.map(function (entity, index) {
      if (entity && !('INVALIDATE_NAME_PATH' in entity)) {
        return {
          name: entity.getNamePath(),
          errors: entity.getErrors(),
          warnings: entity.getWarnings()
        };
      }

      return {
        name: getNamePath(nameList[index]),
        errors: [],
        warnings: []
      };
    });
  };

  this.getFieldError = function (name) {
    _this.warningUnhooked();

    var namePath = getNamePath(name);

    var fieldError = _this.getFieldsError([namePath])[0];

    return fieldError.errors;
  };

  this.getFieldWarning = function (name) {
    _this.warningUnhooked();

    var namePath = getNamePath(name);

    var fieldError = _this.getFieldsError([namePath])[0];

    return fieldError.warnings;
  };

  this.isFieldsTouched = function () {
    _this.warningUnhooked();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var arg0 = args[0],
        arg1 = args[1];
    var namePathList;
    var isAllFieldsTouched = false;

    if (args.length === 0) {
      namePathList = null;
    } else if (args.length === 1) {
      if (Array.isArray(arg0)) {
        namePathList = arg0.map(getNamePath);
        isAllFieldsTouched = false;
      } else {
        namePathList = null;
        isAllFieldsTouched = arg0;
      }
    } else {
      namePathList = arg0.map(getNamePath);
      isAllFieldsTouched = arg1;
    }

    var fieldEntities = _this.getFieldEntities(true);

    var isFieldTouched = function isFieldTouched(field) {
      return field.isFieldTouched();
    }; // ===== Will get fully compare when not config namePathList =====


    if (!namePathList) {
      return isAllFieldsTouched ? fieldEntities.every(isFieldTouched) : fieldEntities.some(isFieldTouched);
    } // Generate a nest tree for validate


    var map = new NameMap();
    namePathList.forEach(function (shortNamePath) {
      map.set(shortNamePath, []);
    });
    fieldEntities.forEach(function (field) {
      var fieldNamePath = field.getNamePath(); // Find matched entity and put into list

      namePathList.forEach(function (shortNamePath) {
        if (shortNamePath.every(function (nameUnit, i) {
          return fieldNamePath[i] === nameUnit;
        })) {
          map.update(shortNamePath, function (list) {
            return [].concat(_toConsumableArray(list), [field]);
          });
        }
      });
    }); // Check if NameMap value is touched

    var isNamePathListTouched = function isNamePathListTouched(entities) {
      return entities.some(isFieldTouched);
    };

    var namePathListEntities = map.map(function (_ref) {
      var value = _ref.value;
      return value;
    });
    return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
  };

  this.isFieldTouched = function (name) {
    _this.warningUnhooked();

    return _this.isFieldsTouched([name]);
  };

  this.isFieldsValidating = function (nameList) {
    _this.warningUnhooked();

    var fieldEntities = _this.getFieldEntities();

    if (!nameList) {
      return fieldEntities.some(function (testField) {
        return testField.isFieldValidating();
      });
    }

    var namePathList = nameList.map(getNamePath);
    return fieldEntities.some(function (testField) {
      var fieldNamePath = testField.getNamePath();
      return containsNamePath(namePathList, fieldNamePath) && testField.isFieldValidating();
    });
  };

  this.isFieldValidating = function (name) {
    _this.warningUnhooked();

    return _this.isFieldsValidating([name]);
  };

  this.resetWithFieldInitialValue = function () {
    var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // Create cache
    var cache = new NameMap();

    var fieldEntities = _this.getFieldEntities(true);

    fieldEntities.forEach(function (field) {
      var initialValue = field.props.initialValue;
      var namePath = field.getNamePath(); // Record only if has `initialValue`

      if (initialValue !== undefined) {
        var records = cache.get(namePath) || new Set();
        records.add({
          entity: field,
          value: initialValue
        });
        cache.set(namePath, records);
      }
    }); // Reset

    var resetWithFields = function resetWithFields(entities) {
      entities.forEach(function (field) {
        var initialValue = field.props.initialValue;

        if (initialValue !== undefined) {
          var namePath = field.getNamePath();

          var formInitialValue = _this.getInitialValue(namePath);

          if (formInitialValue !== undefined) {
            // Warning if conflict with form initialValues and do not modify value
            warningOnce(false, "Form already set 'initialValues' with path '".concat(namePath.join('.'), "'. Field can not overwrite it."));
          } else {
            var records = cache.get(namePath);

            if (records && records.size > 1) {
              // Warning if multiple field set `initialValue`and do not modify value
              warningOnce(false, "Multiple Field with path '".concat(namePath.join('.'), "' set 'initialValue'. Can not decide which one to pick."));
            } else if (records) {
              var originValue = _this.getFieldValue(namePath); // Set `initialValue`


              if (!info.skipExist || originValue === undefined) {
                _this.store = setValue(_this.store, namePath, _toConsumableArray(records)[0].value);
              }
            }
          }
        }
      });
    };

    var requiredFieldEntities;

    if (info.entities) {
      requiredFieldEntities = info.entities;
    } else if (info.namePathList) {
      requiredFieldEntities = [];
      info.namePathList.forEach(function (namePath) {
        var records = cache.get(namePath);

        if (records) {
          var _requiredFieldEntitie;

          (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, _toConsumableArray(_toConsumableArray(records).map(function (r) {
            return r.entity;
          })));
        }
      });
    } else {
      requiredFieldEntities = fieldEntities;
    }

    resetWithFields(requiredFieldEntities);
  };

  this.resetFields = function (nameList) {
    _this.warningUnhooked();

    var prevStore = _this.store;

    if (!nameList) {
      _this.store = setValues({}, _this.initialValues);

      _this.resetWithFieldInitialValue();

      _this.notifyObservers(prevStore, null, {
        type: 'reset'
      });

      return;
    } // Reset by `nameList`


    var namePathList = nameList.map(getNamePath);
    namePathList.forEach(function (namePath) {
      var initialValue = _this.getInitialValue(namePath);

      _this.store = setValue(_this.store, namePath, initialValue);
    });

    _this.resetWithFieldInitialValue({
      namePathList: namePathList
    });

    _this.notifyObservers(prevStore, namePathList, {
      type: 'reset'
    });
  };

  this.setFields = function (fields) {
    _this.warningUnhooked();

    var prevStore = _this.store;
    fields.forEach(function (fieldData) {
      var name = fieldData.name;
          fieldData.errors;
          var data = _objectWithoutProperties(fieldData, _excluded$1);

      var namePath = getNamePath(name); // Value

      if ('value' in data) {
        _this.store = setValue(_this.store, namePath, data.value);
      }

      _this.notifyObservers(prevStore, [namePath], {
        type: 'setField',
        data: fieldData
      });
    });
  };

  this.getFields = function () {
    var entities = _this.getFieldEntities(true);

    var fields = entities.map(function (field) {
      var namePath = field.getNamePath();
      var meta = field.getMeta();

      var fieldData = _objectSpread2(_objectSpread2({}, meta), {}, {
        name: namePath,
        value: _this.getFieldValue(namePath)
      });

      Object.defineProperty(fieldData, 'originRCField', {
        value: true
      });
      return fieldData;
    });
    return fields;
  };

  this.initEntityValue = function (entity) {
    var initialValue = entity.props.initialValue;

    if (initialValue !== undefined) {
      var namePath = entity.getNamePath();
      var prevValue = getValue(_this.store, namePath);

      if (prevValue === undefined) {
        _this.store = setValue(_this.store, namePath, initialValue);
      }
    }
  };

  this.registerField = function (entity) {
    _this.fieldEntities.push(entity); // Set initial values


    if (entity.props.initialValue !== undefined) {
      var prevStore = _this.store;

      _this.resetWithFieldInitialValue({
        entities: [entity],
        skipExist: true
      });

      _this.notifyObservers(prevStore, [entity.getNamePath()], {
        type: 'valueUpdate',
        source: 'internal'
      });
    } // un-register field callback


    return function (isListField, preserve) {
      var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      _this.fieldEntities = _this.fieldEntities.filter(function (item) {
        return item !== entity;
      }); // Clean up store value if not preserve

      var mergedPreserve = preserve !== undefined ? preserve : _this.preserve;

      if (mergedPreserve === false && (!isListField || subNamePath.length > 1)) {
        var namePath = entity.getNamePath();
        var defaultValue = isListField ? undefined : getValue(_this.initialValues, namePath);

        if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function (field) {
          return (// Only reset when no namePath exist
            !matchNamePath(field.getNamePath(), namePath)
          );
        })) {
          var _prevStore = _this.store;
          _this.store = setValue(_prevStore, namePath, defaultValue, true); // Notify that field is unmount

          _this.notifyObservers(_prevStore, [namePath], {
            type: 'remove'
          }); // Dependencies update


          _this.triggerDependenciesUpdate(_prevStore, namePath);
        }
      }
    };
  };

  this.dispatch = function (action) {
    switch (action.type) {
      case 'updateValue':
        {
          var namePath = action.namePath,
              value = action.value;

          _this.updateValue(namePath, value);

          break;
        }

      case 'validateField':
        {
          var _namePath = action.namePath,
              triggerName = action.triggerName;

          _this.validateFields([_namePath], {
            triggerName: triggerName
          });

          break;
        }

    }
  };

  this.notifyObservers = function (prevStore, namePathList, info) {
    if (_this.subscribable) {
      var mergedInfo = _objectSpread2(_objectSpread2({}, info), {}, {
        store: _this.getFieldsValue(true)
      });

      _this.getFieldEntities().forEach(function (_ref2) {
        var onStoreChange = _ref2.onStoreChange;
        onStoreChange(prevStore, namePathList, mergedInfo);
      });
    } else {
      _this.forceRootUpdate();
    }
  };

  this.triggerDependenciesUpdate = function (prevStore, namePath) {
    var childrenFields = _this.getDependencyChildrenFields(namePath);

    if (childrenFields.length) {
      _this.validateFields(childrenFields);
    }

    _this.notifyObservers(prevStore, childrenFields, {
      type: 'dependenciesUpdate',
      relatedFields: [namePath].concat(_toConsumableArray(childrenFields))
    });

    return childrenFields;
  };

  this.updateValue = function (name, value) {
    var namePath = getNamePath(name);
    var prevStore = _this.store;
    _this.store = setValue(_this.store, namePath, value);

    _this.notifyObservers(prevStore, [namePath], {
      type: 'valueUpdate',
      source: 'internal'
    }); // Dependencies update


    var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath); // trigger callback function


    var onValuesChange = _this.callbacks.onValuesChange;

    if (onValuesChange) {
      var changedValues = cloneByNamePathList(_this.store, [namePath]);
      onValuesChange(changedValues, _this.getFieldsValue());
    }

    _this.triggerOnFieldsChange([namePath].concat(_toConsumableArray(childrenFields)));
  };

  this.setFieldsValue = function (store) {
    _this.warningUnhooked();

    var prevStore = _this.store;

    if (store) {
      _this.store = setValues(_this.store, store);
    }

    _this.notifyObservers(prevStore, null, {
      type: 'valueUpdate',
      source: 'external'
    });
  };

  this.getDependencyChildrenFields = function (rootNamePath) {
    var children = new Set();
    var childrenFields = [];
    var dependencies2fields = new NameMap();
    /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */

    _this.getFieldEntities().forEach(function (field) {
      var dependencies = field.props.dependencies;
      (dependencies || []).forEach(function (dependency) {
        var dependencyNamePath = getNamePath(dependency);
        dependencies2fields.update(dependencyNamePath, function () {
          var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
          fields.add(field);
          return fields;
        });
      });
    });

    var fillChildren = function fillChildren(namePath) {
      var fields = dependencies2fields.get(namePath) || new Set();
      fields.forEach(function (field) {
        if (!children.has(field)) {
          children.add(field);
          var fieldNamePath = field.getNamePath();

          if (field.isFieldDirty() && fieldNamePath.length) {
            childrenFields.push(fieldNamePath);
            fillChildren(fieldNamePath);
          }
        }
      });
    };

    fillChildren(rootNamePath);
    return childrenFields;
  };

  this.triggerOnFieldsChange = function (namePathList, filedErrors) {
    var onFieldsChange = _this.callbacks.onFieldsChange;

    if (onFieldsChange) {
      var fields = _this.getFields();
      /**
       * Fill errors since `fields` may be replaced by controlled fields
       */


      if (filedErrors) {
        var cache = new NameMap();
        filedErrors.forEach(function (_ref3) {
          var name = _ref3.name,
              errors = _ref3.errors;
          cache.set(name, errors);
        });
        fields.forEach(function (field) {
          // eslint-disable-next-line no-param-reassign
          field.errors = cache.get(field.name) || field.errors;
        });
      }

      var changedFields = fields.filter(function (_ref4) {
        var fieldName = _ref4.name;
        return containsNamePath(namePathList, fieldName);
      });
      onFieldsChange(changedFields, fields);
    }
  };

  this.validateFields = function (nameList, options) {
    _this.warningUnhooked();

    var provideNameList = !!nameList;
    var namePathList = provideNameList ? nameList.map(getNamePath) : []; // Collect result in promise list

    var promiseList = [];

    _this.getFieldEntities(true).forEach(function (field) {
      // Add field if not provide `nameList`
      if (!provideNameList) {
        namePathList.push(field.getNamePath());
      }
      /**
       * Recursive validate if configured.
       * TODO: perf improvement @zombieJ
       */


      if ((options === null || options === void 0 ? void 0 : options.recursive) && provideNameList) {
        var namePath = field.getNamePath();

        if ( // nameList[i] === undefined 说明是以 nameList 开头的
        // ['name'] -> ['name','list']
        namePath.every(function (nameUnit, i) {
          return nameList[i] === nameUnit || nameList[i] === undefined;
        })) {
          namePathList.push(namePath);
        }
      } // Skip if without rule


      if (!field.props.rules || !field.props.rules.length) {
        return;
      }

      var fieldNamePath = field.getNamePath(); // Add field validate rule in to promise list

      if (!provideNameList || containsNamePath(namePathList, fieldNamePath)) {
        var promise = field.validateRules(_objectSpread2({
          validateMessages: _objectSpread2(_objectSpread2({}, defaultValidateMessages), _this.validateMessages)
        }, options)); // Wrap promise with field

        promiseList.push(promise.then(function () {
          return {
            name: fieldNamePath,
            errors: [],
            warnings: []
          };
        }).catch(function (ruleErrors) {
          var mergedErrors = [];
          var mergedWarnings = [];
          ruleErrors.forEach(function (_ref5) {
            var warningOnly = _ref5.rule.warningOnly,
                errors = _ref5.errors;

            if (warningOnly) {
              mergedWarnings.push.apply(mergedWarnings, _toConsumableArray(errors));
            } else {
              mergedErrors.push.apply(mergedErrors, _toConsumableArray(errors));
            }
          });

          if (mergedErrors.length) {
            return Promise.reject({
              name: fieldNamePath,
              errors: mergedErrors,
              warnings: mergedWarnings
            });
          }

          return {
            name: fieldNamePath,
            errors: mergedErrors,
            warnings: mergedWarnings
          };
        }));
      }
    });

    var summaryPromise = allPromiseFinish(promiseList);
    _this.lastValidatePromise = summaryPromise; // Notify fields with rule that validate has finished and need update

    summaryPromise.catch(function (results) {
      return results;
    }).then(function (results) {
      var resultNamePathList = results.map(function (_ref6) {
        var name = _ref6.name;
        return name;
      });

      _this.notifyObservers(_this.store, resultNamePathList, {
        type: 'validateFinish'
      });

      _this.triggerOnFieldsChange(resultNamePathList, results);
    });
    var returnPromise = summaryPromise.then(function () {
      if (_this.lastValidatePromise === summaryPromise) {
        return Promise.resolve(_this.getFieldsValue(namePathList));
      }

      return Promise.reject([]);
    }).catch(function (results) {
      var errorList = results.filter(function (result) {
        return result && result.errors.length;
      });
      return Promise.reject({
        values: _this.getFieldsValue(namePathList),
        errorFields: errorList,
        outOfDate: _this.lastValidatePromise !== summaryPromise
      });
    }); // Do not throw in console

    returnPromise.catch(function (e) {
      return e;
    });
    return returnPromise;
  };

  this.submit = function () {
    _this.warningUnhooked();

    _this.validateFields().then(function (values) {
      var onFinish = _this.callbacks.onFinish;

      if (onFinish) {
        try {
          onFinish(values);
        } catch (err) {
          // Should print error if user `onFinish` callback failed
          console.error(err);
        }
      }
    }).catch(function (e) {
      var onFinishFailed = _this.callbacks.onFinishFailed;

      if (onFinishFailed) {
        onFinishFailed(e);
      }
    });
  };

  this.forceRootUpdate = forceRootUpdate;
};

function useForm$1(form) {
  var formRef = React.useRef();

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      forceUpdate = _React$useState2[1];

  if (!formRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      // Create a new FormStore if not provided
      var forceReRender = function forceReRender() {
        forceUpdate({});
      };

      var formStore = new FormStore(forceReRender);
      formRef.current = formStore.getForm();
    }
  }

  return [formRef.current];
}

var FormContext = /*#__PURE__*/React.createContext({
  triggerFormChange: function triggerFormChange() {},
  triggerFormFinish: function triggerFormFinish() {},
  registerForm: function registerForm() {},
  unregisterForm: function unregisterForm() {}
});

var FormProvider = function FormProvider(_ref) {
  var validateMessages = _ref.validateMessages,
      onFormChange = _ref.onFormChange,
      onFormFinish = _ref.onFormFinish,
      children = _ref.children;
  var formContext = React.useContext(FormContext);
  var formsRef = React.useRef({});
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, formContext), {}, {
      validateMessages: _objectSpread2(_objectSpread2({}, formContext.validateMessages), validateMessages),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function triggerFormChange(name, changedFields) {
        if (onFormChange) {
          onFormChange(name, {
            changedFields: changedFields,
            forms: formsRef.current
          });
        }

        formContext.triggerFormChange(name, changedFields);
      },
      triggerFormFinish: function triggerFormFinish(name, values) {
        if (onFormFinish) {
          onFormFinish(name, {
            values: values,
            forms: formsRef.current
          });
        }

        formContext.triggerFormFinish(name, values);
      },
      registerForm: function registerForm(name, form) {
        if (name) {
          formsRef.current = _objectSpread2(_objectSpread2({}, formsRef.current), {}, _defineProperty({}, name, form));
        }

        formContext.registerForm(name, form);
      },
      unregisterForm: function unregisterForm(name) {
        var newForms = _objectSpread2({}, formsRef.current);

        delete newForms[name];
        formsRef.current = newForms;
        formContext.unregisterForm(name);
      }
    })
  }, children);
};

var _excluded = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"];

var Form$1 = function Form(_ref, ref) {
  var name = _ref.name,
      initialValues = _ref.initialValues,
      fields = _ref.fields,
      form = _ref.form,
      preserve = _ref.preserve,
      children = _ref.children,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'form' : _ref$component,
      validateMessages = _ref.validateMessages,
      _ref$validateTrigger = _ref.validateTrigger,
      validateTrigger = _ref$validateTrigger === void 0 ? 'onChange' : _ref$validateTrigger,
      onValuesChange = _ref.onValuesChange,
      _onFieldsChange = _ref.onFieldsChange,
      _onFinish = _ref.onFinish,
      onFinishFailed = _ref.onFinishFailed,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var formContext = React.useContext(FormContext); // We customize handle event since Context will makes all the consumer re-render:
  // https://reactjs.org/docs/context.html#contextprovider

  var _useForm = useForm$1(form),
      _useForm2 = _slicedToArray(_useForm, 1),
      formInstance = _useForm2[0];

  var _formInstance$getInte = formInstance.getInternalHooks(HOOK_MARK),
      useSubscribe = _formInstance$getInte.useSubscribe,
      setInitialValues = _formInstance$getInte.setInitialValues,
      setCallbacks = _formInstance$getInte.setCallbacks,
      setValidateMessages = _formInstance$getInte.setValidateMessages,
      setPreserve = _formInstance$getInte.setPreserve; // Pass ref with form instance


  React.useImperativeHandle(ref, function () {
    return formInstance;
  }); // Register form into Context

  React.useEffect(function () {
    formContext.registerForm(name, formInstance);
    return function () {
      formContext.unregisterForm(name);
    };
  }, [formContext, formInstance, name]); // Pass props to store

  setValidateMessages(_objectSpread2(_objectSpread2({}, formContext.validateMessages), validateMessages));
  setCallbacks({
    onValuesChange: onValuesChange,
    onFieldsChange: function onFieldsChange(changedFields) {
      formContext.triggerFormChange(name, changedFields);

      if (_onFieldsChange) {
        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }

        _onFieldsChange.apply(void 0, [changedFields].concat(rest));
      }
    },
    onFinish: function onFinish(values) {
      formContext.triggerFormFinish(name, values);

      if (_onFinish) {
        _onFinish(values);
      }
    },
    onFinishFailed: onFinishFailed
  });
  setPreserve(preserve); // Set initial value, init store value when first mount

  var mountRef = React.useRef(null);
  setInitialValues(initialValues, !mountRef.current);

  if (!mountRef.current) {
    mountRef.current = true;
  } // Prepare children by `children` type


  var childrenNode = children;
  var childrenRenderProps = typeof children === 'function';

  if (childrenRenderProps) {
    var values = formInstance.getFieldsValue(true);
    childrenNode = children(values, formInstance);
  } // Not use subscribe when using render props


  useSubscribe(!childrenRenderProps); // Listen if fields provided. We use ref to save prev data here to avoid additional render

  var prevFieldsRef = React.useRef();
  React.useEffect(function () {
    if (!isSimilar(prevFieldsRef.current || [], fields || [])) {
      formInstance.setFields(fields || []);
    }

    prevFieldsRef.current = fields;
  }, [fields, formInstance]);
  var formContextValue = React.useMemo(function () {
    return _objectSpread2(_objectSpread2({}, formInstance), {}, {
      validateTrigger: validateTrigger
    });
  }, [formInstance, validateTrigger]);
  var wrapperNode = /*#__PURE__*/React.createElement(Context.Provider, {
    value: formContextValue
  }, childrenNode);

  if (Component === false) {
    return wrapperNode;
  }

  return /*#__PURE__*/React.createElement(Component, _extends$1({}, restProps, {
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      formInstance.submit();
    },
    onReset: function onReset(event) {
      var _restProps$onReset;

      event.preventDefault();
      formInstance.resetFields();
      (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 ? void 0 : _restProps$onReset.call(restProps, event);
    }
  }), wrapperNode);
};

var InternalForm$1 = /*#__PURE__*/React.forwardRef(Form$1);
var RefForm = InternalForm$1;
RefForm.FormProvider = FormProvider;
RefForm.Field = WrapperField;
RefForm.List = List$1;
RefForm.useForm = useForm$1;

function FormLabel(_a) {
    var _b;
    var children = _a.children, className = _a.className, style = _a.style, withRequiredMark = _a.withRequiredMark, hint = _a.hint, props = __rest(_a, ["children", "className", "style", "withRequiredMark", "hint"]);
    var label = (React__default.createElement("label", __assign({}, props, { className: classnames("form-label", (_b = {
                "form-label-nohint": !hint
            },
            _b[className] = className,
            _b)), style: style }),
        children,
        " ",
        withRequiredMark && React__default.createElement(RequiredMark, null)));
    if (!hint)
        return label;
    return (React__default.createElement("div", { className: "form-label-withhint" },
        label,
        React__default.createElement("span", { className: "form-label-hint" }, hint)));
}
FormLabel.defaultProps = {
    withRequiredMark: false
};
var RequiredMark = function () { return React__default.createElement("span", { className: "required-mark" }, " *"); };

var useId$4 = typeof useId$8 === "function" ? useId$8 : useId$6;
function FormItem(_a) {
    var children = _a.children, label = _a.label, help = _a.help, hint = _a.hint, hideError = _a.hideError, _b = _a.inline, inline = _b === void 0 ? false : _b, props = __rest(_a, ["children", "label", "help", "hint", "hideError", "inline"]);
    var rules = props.rules;
    return (React__default.createElement(WrapperField, __assign({}, props), function (childProps, meta, context) {
        var isRequired = !!(rules &&
            rules.some(function (rule) {
                if (rule && typeof rule === "object" && rule.required) {
                    return true;
                }
                if (typeof rule === "function") {
                    var ruleEntity = rule(context);
                    return ruleEntity && ruleEntity.required;
                }
                return false;
            }));
        var validationState = meta.validating
            ? "loading"
            : meta.errors.length === 0
                ? "valid"
                : "invalid";
        var hasError = meta.errors.length > 0;
        var error = hasError ? meta.errors[meta.errors.length - 1] : null;
        return (React__default.createElement(FormInput, { hasError: hasError, error: !hideError ? error : undefined, validationState: validationState, isRequired: isRequired, childProps: childProps, label: label, hint: hint, help: help, inline: inline }, children));
    }));
}
var FormInput = function FormInput(_a) {
    var children = _a.children, label = _a.label, hint = _a.hint, help = _a.help, hasError = _a.hasError, error = _a.error, childProps = _a.childProps, validationState = _a.validationState, isRequired = _a.isRequired, inline = _a.inline;
    var inputId = "carton-ui-forminput-".concat(useId$4());
    var labelId = "carton-ui-formlabel-".concat(useId$4());
    var _b = __read(useDebouncedState(validationState === "loading", 250), 1), isLoading = _b[0];
    var labelNode = label ? (React__default.createElement(FormLabel, { withRequiredMark: isRequired, hint: hint, id: labelId, htmlFor: inputId }, label)) : null;
    var inputNode = (React__default.createElement(React__default.Fragment, null,
        React__default.cloneElement(children, __assign({ id: inputId, isLoading: isLoading, validationState: validationState, "aria-required": isRequired || undefined, "aria-errormessage": hasError ? error : undefined, "aria-invalid": validationState === "invalid" || undefined, "aria-labelledby": label ? labelId : undefined, "aria-label": label }, childProps)),
        ((hasError && !isLoading) || help !== undefined) && (React__default.createElement("p", { className: classnames("form-item-status", {
                "form-item-status-error": hasError
            }) }, error || help))));
    return (React__default.createElement("div", { className: classnames("form-item", {
            "form-item-inline": inline
        }) },
        inline ? React__default.createElement("div", null, labelNode) : labelNode,
        inline ? React__default.createElement("div", { className: "form-input-wrapper-inline" }, inputNode) : inputNode));
};
var Error$1 = function (_a) {
    var children = _a.children;
    return (React__default.createElement("p", { className: "form-item-status form-item-status-error" }, children));
};

function useForm(form) {
    var _a = __read(useForm$1(form), 1), instance = _a[0];
    return instance;
}
function InternalForm(_a, ref) {
    var children = _a.children, onSubmit = _a.onSubmit, onSubmitFailed = _a.onSubmitFailed, props = __rest(_a, ["children", "onSubmit", "onSubmitFailed"]);
    return (React__default.createElement(RefForm, __assign({ ref: ref, onFinish: onSubmit, onFinishFailed: onSubmitFailed }, props), children));
}
var ForwardedForm = React__default.forwardRef(InternalForm);
var Form = ForwardedForm;
Form.Item = FormItem;
Form.useForm = useForm;
Form.List = RefForm.List;
Form.Field = RefForm.Field;
Form.Provider = RefForm.FormProvider;
Form.RequiredMark = RequiredMark;
Form.Label = FormLabel;
Form.Error = Error$1;

function InternalInputPassword(_a, ref) {
    var validationState = _a.validationState, props = __rest(_a, ["validationState"]);
    var _b = __read(useState(false), 2), showPassword = _b[0], setShowPassword = _b[1];
    var toggleType = useCallback(function () { return setShowPassword(!showPassword); }, [showPassword]);
    var iconProps = {
        onClick: toggleType,
        className: "form-input-password-addon"
    };
    return (React__default.createElement(Input$1, __assign({ type: showPassword ? "text" : "password", keepTrailingIconWithError: true, trailingIcon: !showPassword ? React__default.createElement(EyeIcon$1, __assign({}, iconProps)) : React__default.createElement(EyeOffIcon$1, __assign({}, iconProps)), validationState: validationState, ref: ref }, props)));
}
var InputPassword = React__default.forwardRef(InternalInputPassword);

function CheckCircleIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef$6 = React.forwardRef(CheckCircleIcon);
var CheckCircleIcon$1 = ForwardRef$6;

function CheckIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 13l4 4L19 7"
  }));
}

const ForwardRef$5 = React.forwardRef(CheckIcon);
var CheckIcon$1 = ForwardRef$5;

function ExclamationIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
  }));
}

const ForwardRef$4 = React.forwardRef(ExclamationIcon);
var ExclamationIcon$1 = ForwardRef$4;

function ExternalLinkIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
  }));
}

const ForwardRef$3 = React.forwardRef(ExternalLinkIcon);
var ExternalLinkIcon$1 = ForwardRef$3;

function InformationCircleIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef$2 = React.forwardRef(InformationCircleIcon);
var InformationCircleIcon$1 = ForwardRef$2;

function XCircleIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef$1 = React.forwardRef(XCircleIcon);
var XCircleIcon$1 = ForwardRef$1;

function XIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 18L18 6M6 6l12 12"
  }));
}

const ForwardRef = React.forwardRef(XIcon);
var XIcon$1 = ForwardRef;

function Link(_a) {
    var children = _a.children, target = _a.target, props = __rest(_a, ["children", "target"]);
    return (React__default.createElement("a", __assign({ className: "link" }, props, { target: target }),
        children,
        target === "_blank" && React__default.createElement(ExternalLinkIcon$1, { className: "link-icon" })));
}

function InternalList(props) {
    var _a;
    var children = props.children, style = props.style, className = props.className;
    return (React__default.createElement("div", { className: classnames("list", (_a = {},
            _a[className] = className,
            _a)), style: style },
        React__default.createElement("ul", null, React__default.Children.count(children) > 0
            ? React__default.Children.map(children, function (child, idx) {
                if (React__default.isValidElement(child)) {
                    return React__default.cloneElement(child, { key: idx });
                }
            })
            : null)));
}
var ListItem = function (_a) {
    var _b;
    var className = _a.className, style = _a.style, onClick = _a.onClick, children = _a.children;
    if (!children)
        return null;
    return (React__default.createElement("li", { className: classnames("list-item", (_b = {},
            _b[className] = className,
            _b["list-item-clickable"] = onClick !== undefined,
            _b)), onClick: onClick, style: style },
        React__default.createElement("div", { className: "list-item-wrapper" },
            React__default.createElement("div", { className: "list-item-content" }, children),
            onClick !== undefined && (React__default.createElement("div", { className: "list-item-icon" },
                React__default.createElement(ChevronRightIcon$1, null))))));
};
var List = InternalList;
List.Item = ListItem;
ListItem.displayName = "List.Item";

function matchReducer(actionType, reducers, state, action) {
    if (reducers[actionType]) {
        var returnValue = reducers[actionType];
        return returnValue(state, action);
    }
    var error = new Error("Aucun handler pour \"".concat(actionType, "\". Handlers disponibles: ").concat(Object.keys(reducers)
        .map(function (key) { return "\"".concat(key, "\""); })
        .join(", "), "."));
    if (Error.captureStackTrace)
        Error.captureStackTrace(error, matchReducer);
    throw error;
}

var _a$2;
var useId$3 = typeof useId$8 === "function" ? useId$8 : useId$6;
var ActionTypes$1;
(function (ActionTypes) {
    ActionTypes[ActionTypes["RegisterItem"] = 0] = "RegisterItem";
    ActionTypes[ActionTypes["UnregisterItem"] = 1] = "UnregisterItem";
    ActionTypes[ActionTypes["SetActiveItem"] = 2] = "SetActiveItem";
    ActionTypes[ActionTypes["SetNextItemActive"] = 3] = "SetNextItemActive";
    ActionTypes[ActionTypes["SetPreviousItemActive"] = 4] = "SetPreviousItemActive";
    ActionTypes[ActionTypes["ClearActiveItem"] = 5] = "ClearActiveItem";
    ActionTypes[ActionTypes["RegisterSection"] = 6] = "RegisterSection";
    ActionTypes[ActionTypes["UnregisterSection"] = 7] = "UnregisterSection";
})(ActionTypes$1 || (ActionTypes$1 = {}));
var reducers$2 = (_a$2 = {},
    _a$2[ActionTypes$1.SetNextItemActive] = function (state) {
        var _a;
        var activeIndex = (_a = state.activeItemIndex) !== null && _a !== void 0 ? _a : -1;
        var activeItemIndex = state.items.findIndex(function (item, idx) {
            if (idx <= activeIndex)
                return false;
            return !item.ref.current.isDisabled;
        });
        if (activeItemIndex == -1) {
            activeItemIndex = state.items.findIndex(function (item) { return !item.ref.current.isDisabled; });
        }
        return __assign(__assign({}, state), { activeItemIndex: activeItemIndex === -1 ? null : activeItemIndex });
    },
    _a$2[ActionTypes$1.SetPreviousItemActive] = function (state) {
        var _a;
        var activeIndex = (_a = state.activeItemIndex) !== null && _a !== void 0 ? _a : -1;
        var activeItemIndex = state.activeItemIndex;
        var reversed = state.items.slice().reverse();
        var idx = reversed.findIndex(function (item, idx, all) {
            if (activeIndex !== -1 && all.length - idx - 1 >= activeIndex)
                return false;
            return !item.ref.current.isDisabled;
        });
        if (idx === -1) {
            idx = reversed.findIndex(function (item) { return !item.ref.current.isDisabled; });
        }
        activeItemIndex = state.items.length - 1 - idx;
        return __assign(__assign({}, state), { activeItemIndex: activeItemIndex === -1 ? null : activeItemIndex });
    },
    _a$2[ActionTypes$1.SetActiveItem] = function (state, action) { return (__assign(__assign({}, state), { activeItemIndex: state.items.findIndex(function (item) { return item.id === action.id; }) })); },
    _a$2[ActionTypes$1.ClearActiveItem] = function (state) { return (__assign(__assign({}, state), { activeItemIndex: null })); },
    _a$2[ActionTypes$1.RegisterItem] = function (state, action) { return (__assign(__assign({}, state), { items: __spreadArray(__spreadArray([], __read(state.items), false), [{ id: action.id, ref: action.ref }], false) })); },
    _a$2[ActionTypes$1.UnregisterItem] = function (state, action) {
        var nextItems = state.items.slice();
        var currentActiveItem = state.activeItemIndex !== null ? nextItems[state.activeItemIndex] : null;
        var idx = nextItems.findIndex(function (a) { return a.id === action.id; });
        if (idx !== -1)
            nextItems.splice(idx, 1);
        var activeItemIndex;
        if (idx === state.activeItemIndex)
            activeItemIndex = null;
        else if (currentActiveItem === null)
            activeItemIndex = null;
        else
            activeItemIndex = nextItems.indexOf(currentActiveItem);
        return __assign(__assign({}, state), { items: nextItems, activeItemIndex: activeItemIndex });
    },
    _a$2[ActionTypes$1.RegisterSection] = function (state, action) {
        var newSections = new Set(state.sections);
        newSections.add(action.id);
        return __assign(__assign({}, state), { sections: newSections });
    },
    _a$2[ActionTypes$1.UnregisterSection] = function (state, action) {
        var newSections = new Set(state.sections);
        newSections.delete(action.id);
        return __assign(__assign({}, state), { sections: newSections });
    },
    _a$2);
function stateReducer$2(state, action) {
    return matchReducer(action.type, reducers$2, state, action);
}
var MenuContext = React__default.createContext(null);
function InternalMenu(_a, ref) {
    var _b;
    var _c;
    var className = _a.className, style = _a.style, children = _a.children, onAction = _a.onAction;
    var id = "carton-ui-menu-".concat(useId$3());
    var dropdownContext = useContext(DropdownContext);
    var reducerObj = useReducer(stateReducer$2, {
        activeItemIndex: null,
        items: [],
        sections: new Set(),
        onAction: onAction
    });
    var _d = __read(reducerObj, 2), state = _d[0], dispatch = _d[1];
    var handleBlur = function () {
        dispatch({ type: ActionTypes$1.ClearActiveItem });
    };
    var handleKeyDown = function (e) {
        var _a;
        e.preventDefault();
        if (e.key === Keys.Tab || e.keyCode === KeyCodes.Tab) {
            return;
        }
        else if (e.key === Keys.ArrowDown || e.keyCode === KeyCodes.ArrowDown) {
            dispatch({ type: ActionTypes$1.SetNextItemActive });
        }
        else if (e.key === Keys.ArrowUp || e.keyCode === KeyCodes.ArrowUp) {
            dispatch({ type: ActionTypes$1.SetPreviousItemActive });
        }
        else if (e.key === Keys.Enter ||
            e.key === Keys.Space ||
            e.keyCode === KeyCodes.Enter ||
            e.keyCode === KeyCodes.Enter) {
            dispatch({ type: ActionTypes$1.ClearActiveItem });
            if (state.activeItemIndex !== null) {
                var id_1 = state.items[state.activeItemIndex].id;
                (_a = document.getElementById(id_1)) === null || _a === void 0 ? void 0 : _a.click();
            }
            // Ferme le dropdown si le menu fait partie d'un DropdownContext
            // Focus le trigger du dropdown
            dropdownContext === null || dropdownContext === void 0 ? void 0 : dropdownContext.close();
        }
        else if (e.key === Keys.Escape || e.keyCode === KeyCodes.Escape) {
            dropdownContext === null || dropdownContext === void 0 ? void 0 : dropdownContext.close();
        }
    };
    return (React__default.createElement("ul", { id: id, ref: ref, role: "menu", className: classnames("menu", (_b = {},
            _b[className] = className,
            _b)), style: style, tabIndex: state.activeItemIndex === null ? 0 : -1, "aria-activedescendant": state.activeItemIndex === null ? undefined : (_c = state.items[state.activeItemIndex]) === null || _c === void 0 ? void 0 : _c.id, onKeyDown: handleKeyDown, onBlur: handleBlur },
        React__default.createElement(MenuContext.Provider, { value: reducerObj }, children)));
}
var MenuItem = function MenuItem(_a) {
    var _b;
    var children = _a.children, isDisabled = _a.isDisabled, value = _a.value, style = _a.style, className = _a.className, icon = _a.icon;
    var id = "carton-ui-menuitem-".concat(useId$3());
    var _c = __read(useContext(MenuContext), 2), state = _c[0], dispatch = _c[1];
    var dropdownContext = useContext(DropdownContext);
    var ref = useRef({ isDisabled: isDisabled });
    var active = state.activeItemIndex !== null ? state.items[state.activeItemIndex].id === id : false;
    useIsomorphicEffect(function () {
        ref.current.isDisabled = isDisabled;
    }, [ref, isDisabled]);
    useIsomorphicEffect(function () {
        dispatch({ type: ActionTypes$1.RegisterItem, id: id, ref: ref });
        return function () { return dispatch({ type: ActionTypes$1.UnregisterItem, id: id }); };
    }, [id, isDisabled]);
    var handleClick = function (e) {
        e.stopPropagation();
        if (isDisabled)
            return e.preventDefault();
        dropdownContext === null || dropdownContext === void 0 ? void 0 : dropdownContext.close();
        if (typeof state.onAction === "function")
            state.onAction(value);
    };
    var handleFocus = function () {
        if (isDisabled)
            return dispatch({ type: ActionTypes$1.ClearActiveItem });
        dispatch({ type: ActionTypes$1.SetActiveItem, id: id });
    };
    var handlePointerMove = function () {
        if (isDisabled)
            return;
        if (active)
            return;
        dispatch({ type: ActionTypes$1.SetActiveItem, id: id });
    };
    var handlePointerLeave = function () {
        if (isDisabled)
            return;
        if (!active)
            return;
        dispatch({ type: ActionTypes$1.ClearActiveItem });
    };
    return (React__default.createElement("li", { id: id, role: "menuitem", "aria-disabled": isDisabled, className: classnames("menuitem", (_b = {
                "menuitem-disabled": isDisabled,
                "menuitem-active": active
            },
            _b[className] = className,
            _b)), tabIndex: active ? 0 : -1, onClick: handleClick, onFocus: handleFocus, onPointerMove: handlePointerMove, onPointerLeave: handlePointerLeave, style: style },
        icon && React__default.createElement("div", { className: "menuitem-icon" }, icon),
        " ",
        children));
};
var MenuSection = function MenuSection(_a) {
    var label = _a.label, children = _a.children, props = __rest(_a, ["label", "children"]);
    var id = "carton-ui-menusection-".concat(useId$3());
    var _b = __read(useContext(MenuContext), 2), state = _b[0], dispatch = _b[1];
    useIsomorphicEffect(function () {
        dispatch({ type: ActionTypes$1.RegisterSection, id: id });
        return function () { return dispatch({ type: ActionTypes$1.UnregisterSection, id: id }); };
    }, [id]);
    var sections = __spreadArray([], __read(state.sections), false);
    return (React__default.createElement(React__default.Fragment, null,
        sections[0] !== id && React__default.createElement("li", { role: "separator", "aria-orientation": "horizontal" }),
        React__default.createElement("li", { role: "presentation" },
            label && (React__default.createElement("h3", { id: id, "aria-hidden": "true" }, label)),
            React__default.createElement("ul", { role: "group", "aria-labelledby": label ? id : undefined, "aria-label": props["aria-label"] }, children))));
};
var Menu = React__default.forwardRef(InternalMenu);
Menu.Item = MenuItem;
Menu.Section = MenuSection;
Menu.displayName = "Menu";
MenuItem.displayName = "Menu.Item";
MenuSection.displayName = "Menu.Section";

function Modal(_a) {
    var _b;
    var isOpen = _a.isOpen, onClose = _a.onClose, _c = _a.hideCloseButton, hideCloseButton = _c === void 0 ? false : _c, _d = _a.shouldCloseOnBlur, shouldCloseOnBlur = _d === void 0 ? true : _d, _e = _a.shouldCloseOnEsc, shouldCloseOnEsc = _e === void 0 ? true : _e, container = _a.container, className = _a.className, children = _a.children, cardProps = __rest(_a, ["isOpen", "onClose", "hideCloseButton", "shouldCloseOnBlur", "shouldCloseOnEsc", "container", "className", "children"]);
    return (React__default.createElement(Transition.Root, { show: isOpen },
        React__default.createElement(Portal$1, { container: container },
            React__default.createElement("div", { className: "overlay" },
                React__default.createElement("div", { className: "overlay-wrapper" },
                    React__default.createElement(Transition.Child, { enter: "overlay-transition-enter", enterFrom: "overlay-transition-enter-from", enterTo: "overlay-transition-enter-to", leave: "overlay-transition-leave", leaveFrom: "overlay-transition-leave-from", leaveTo: "overlay-transition-leave-to", className: "overlay-background", "aria-hidden": "true" },
                        React__default.createElement("div", { onClick: function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                if (shouldCloseOnBlur) {
                                    onClose();
                                }
                            } })),
                    React__default.createElement("span", { className: "modal-vertical-spacer", "aria-hidden": "true" }, "\u200B"),
                    React__default.createElement(Transition.Child, { enter: "modal-transition-enter", enterFrom: "modal-transition-enter-from", enterTo: "modal-transition-enter-to", leave: "modal-transition-leave", leaveFrom: "modal-transition-leave-from", leaveTo: "modal-transition-leave-to", className: classnames("modal", (_b = {},
                            _b[className] = className,
                            _b)), role: "dialog", "aria-modal": "true", "aria-hidden": "false" },
                        React__default.createElement(InternalModal, __assign({}, cardProps, { hideCloseButton: hideCloseButton, shouldCloseOnEsc: shouldCloseOnEsc, onClose: onClose, isOpen: isOpen }), children)))))));
}
function InternalModal(_a) {
    var hideCloseButton = _a.hideCloseButton, onClose = _a.onClose, children = _a.children, shouldCloseOnEsc = _a.shouldCloseOnEsc, isOpen = _a.isOpen, cardProps = __rest(_a, ["hideCloseButton", "onClose", "children", "shouldCloseOnEsc", "isOpen"]);
    var ref = useRef();
    usePreventScroll(true);
    useFocusTrap(ref, true);
    var closeEsc = useCallback(function () {
        shouldCloseOnEsc && onClose();
    }, [shouldCloseOnEsc, onClose]);
    // Gère le bouton Esc
    useWindowEvent("keydown", function (e) {
        if (!isOpen)
            return;
        if (e.key !== Keys.Escape)
            return;
        if (!stack.isLast(ref.current))
            return;
        closeEsc();
    });
    return (React__default.createElement(StackElement, { elRef: ref },
        React__default.createElement("div", { ref: ref },
            !hideCloseButton && (React__default.createElement(IconButton, { className: "modal-close-icon", onClick: function (e) {
                    e.stopPropagation();
                    onClose();
                } },
                React__default.createElement(XIcon$3, null))),
            React__default.createElement(Card, __assign({}, cardProps), children))));
}

var intentIconsMap = {
    danger: (React__default.createElement(XCircleIcon$1, { className: "notification-icon notification-icon-danger", stroke: "currentColor" })),
    success: (React__default.createElement(CheckCircleIcon$1, { className: "notification-icon notification-icon-success", stroke: "currentColor" })),
    warning: (React__default.createElement(ExclamationIcon$1, { className: "notification-icon notification-icon-warning", stroke: "currentColor" })),
    info: (React__default.createElement(InformationCircleIcon$1, { className: "notification-icon notification-icon-info", stroke: "currentColor" }))
};
function Notification(_a) {
    var isOpen = _a.isOpen, title = _a.title, description = _a.description, closable = _a.closable, intent = _a.intent, duration = _a.duration, close = _a.close;
    var clear = useTimeout(duration === Infinity ? function () { return void 0; } : close, duration === Infinity ? 0 : duration * 1000).clear;
    var onClose = useCallback(function () {
        clear();
        close();
    }, [clear, close]);
    return (React__default.createElement(Transition, { show: isOpen, appear: true, enter: "transform ease-out duration-300 transition", enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2", enterTo: "translate-y-0 opacity-100 sm:translate-x-0", leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", className: "notification" },
        React__default.createElement("div", { className: "notification-wrapper" },
            React__default.createElement("div", { className: "notification-inner" },
                React__default.createElement("div", { className: "notification-container" },
                    intent && React__default.createElement("div", { className: "notification-icon-wrapper" }, intentIconsMap[intent]),
                    React__default.createElement("div", { className: "notification-content" },
                        React__default.createElement("p", { className: "notification-title" },
                            " ",
                            title),
                        typeof description === "string" ? (React__default.createElement("p", { className: "notification-description" }, description)) : (React__default.createElement("div", { className: "notification-description" }, description))),
                    closable && (React__default.createElement("div", { className: "notification-close", style: { marginTop: "0.1rem" } },
                        React__default.createElement("button", { onClick: onClose, className: "notification-close-btn" },
                            React__default.createElement(XIcon$1, { fill: "currentColor" })))))))));
}
Notification.defaultProps = {
    closable: true,
    duration: 5
};

var hasCustomId = function (notification) { return Object.hasOwnProperty.call(notification, "id"); };
function NotificationManager(_a) {
    var bindClose = _a.bindClose, bindNotify = _a.bindNotify;
    var _b = __read(useReducer(function (state, action) {
        switch (action.type) {
            case "hide": {
                var notification = state.notifications.find(function (n) { return n.id === action.id; });
                if (notification) {
                    notification.isOpen = false;
                }
                return __assign(__assign({}, state), { notifications: state.notifications.slice() });
            }
            case "remove": {
                var notifications = state.notifications.filter(function (n) { return !String(n.id).startsWith(action.id); });
                return __assign(__assign({}, state), { notifications: notifications });
            }
            case "add": {
                var uniqueId = state.idCounter;
                var id_1 = hasCustomId(action.notification)
                    ? "".concat(action.notification.id, "-").concat(uniqueId)
                    : String(uniqueId);
                var newNotification = __assign(__assign({ isOpen: true, close: function () {
                        if (typeof action.notification.close === "function") {
                            action.notification.close();
                        }
                        close(id_1);
                    } }, action.notification), { id: id_1 });
                return __assign(__assign({}, state), { idCounter: state.idCounter + 1, notifications: __spreadArray(__spreadArray([], __read(state.notifications), false), [newNotification], false) });
            }
            default:
                return state;
        }
    }, { idCounter: 0, notifications: [] }), 2), state = _b[0], dispatch = _b[1];
    var notify = useCallback(function (notification) {
        if (hasCustomId(notification)) {
            dispatch({ type: "remove", id: notification.id });
        }
        dispatch({ type: "add", notification: notification });
    }, []);
    var close = useCallback(function (id) {
        dispatch({ type: "hide", id: id });
        setTimeout(function () {
            nextFrame(function () {
                dispatch({ type: "remove", id: id });
            });
        }, 100);
    }, []);
    useLayoutEffect(function () {
        bindClose(close);
        bindNotify(notify);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notify, close]);
    return (React__default.createElement("div", { className: "notifier" }, state.notifications.map(function (_a) {
        var id = _a.id, props = __rest(_a, ["id"]);
        return (React__default.createElement(Notification, __assign({ key: id }, props)));
    })));
}

var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
var Notifier = /** @class */ (function () {
    function Notifier() {
        var _this = this;
        this.bindNotify = function (handler) {
            _this.notify = handler;
        };
        this.bindClose = function (handler) {
            _this.close = handler;
        };
        this.success = function (title, settings) {
            if (settings === void 0) { settings = {}; }
            _this.notify(__assign({ title: title, intent: "success" }, settings));
        };
        this.warning = function (title, settings) {
            if (settings === void 0) { settings = {}; }
            _this.notify(__assign({ title: title, intent: "warning" }, settings));
        };
        this.danger = function (title, settings) {
            if (settings === void 0) { settings = {}; }
            _this.notify(__assign({ title: title, intent: "danger" }, settings));
        };
        this.info = function (title, settings) {
            if (settings === void 0) { settings = {}; }
            _this.notify(__assign({ title: title, intent: "info" }, settings));
        };
        if (!isBrowser)
            return;
        var container = document.createElement("div");
        container.id = "carton-ui-notifications";
        document.body.appendChild(container);
        ReactDOM__default.render(React__default.createElement(NotificationManager, { bindClose: this.bindClose, bindNotify: this.bindNotify }), container);
    }
    return Notifier;
}());

var notifier = new Notifier();

var PageButton = React__default.memo(React__default.forwardRef(function PageButton(_a, ref) {
    var _b;
    var children = _a.children, isActive = _a.isActive, onClick = _a.onClick, className = _a.className;
    return (React__default.createElement("span", { className: classnames("pagination-btn", (_b = {
                "pagination-btn-active": isActive
            },
            _b[className] = className,
            _b)), ref: ref, onClick: onClick, tabIndex: 0 }, children));
}));

function NavButton(_a) {
    var _b;
    var isDisabled = _a.isDisabled, children = _a.children, className = _a.className, onClick = _a.onClick, props = __rest(_a, ["isDisabled", "children", "className", "onClick"]);
    return (React__default.createElement("span", __assign({ "aria-disabled": isDisabled, className: classnames("pagination-btn pagination-nav-btn", (_b = {
                "pagination-nav-btn-disabled": isDisabled
            },
            _b[className] = true,
            _b)) }, props, { onClick: onClick, tabIndex: 0 }), children));
}
var PreviousButton = React__default.memo(function PreviousButton(_a) {
    var isDisabled = _a.isDisabled, onClick = _a.onClick;
    return (React__default.createElement(NavButton, { isDisabled: isDisabled, className: "pagination-nav-btn-left", "aria-label": "Pr\u00E9c\u00E9dent", "aria-disabled": isDisabled, onClick: onClick },
        React__default.createElement(ChevronLeftIcon$1, null)));
});
var NextButton = React__default.memo(function NextButton(_a) {
    var isDisabled = _a.isDisabled, onClick = _a.onClick;
    return (React__default.createElement(NavButton, { isDisabled: isDisabled, className: "pagination-nav-btn-right", "aria-label": "Suivant", "aria-disabled": isDisabled, onClick: onClick },
        React__default.createElement(ChevronRightIcon$1, null)));
});

var JumperButton = React__default.memo(function JumperButton(_a) {
    var onClick = _a.onClick, direction = _a.direction;
    var _b = __read(useState(false), 2), hovered = _b[0], setHovered = _b[1];
    var ref = useRef();
    useEffect(function () {
        var node = ref.current;
        var handlerIn = function () { return setHovered(true); };
        var handlerOut = function () { return setHovered(false); };
        node.addEventListener("pointerover", handlerIn);
        node.addEventListener("pointerout", handlerOut);
        return function () {
            node.removeEventListener("pointerover", handlerIn);
            node.removeEventListener("pointerout", handlerOut);
        };
    }, []);
    var icon = null;
    if (direction === "left") {
        icon = React__default.createElement(ChevronDoubleLeftIcon$1, null);
    }
    else if (direction === "right") {
        icon = React__default.createElement(ChevronDoubleRightIcon$1, null);
    }
    return (React__default.createElement(PageButton, { ref: ref, isActive: false, onClick: onClick, className: "jumper-btn" }, hovered ? icon : React__default.createElement(DotsHorizontalIcon$1, null)));
});

function QuickJumper(_a) {
    var goto = _a.goto, totalPages = _a.totalPages;
    var onChange = useDebouncedCallback(function (v) {
        goto(Number(v));
    }, [goto], 250);
    return React__default.createElement(Input$1, { type: "number", inputMode: "numeric", min: 1, max: totalPages, onChange: onChange });
}

var SelectTrigger = React__default.forwardRef(function SelectTrigger(_a, ref) {
    var _b;
    var children = _a.children, onClick = _a.onClick, className = _a.className, hasError = _a.hasError, isLoading = _a.isLoading, props = __rest(_a, ["children", "onClick", "className", "hasError", "isLoading"]);
    var handleKeyDown = function (e) {
        switch (true) {
            case e.key === Keys.ArrowDown:
            case e.keyCode === KeyCodes.ArrowDown:
                onClick();
                break;
        }
    };
    return (React__default.createElement("button", __assign({ ref: ref, className: classnames("form-select-trigger", (_b = {
                "form-select-trigger-error": hasError
            },
            _b[className] = className,
            _b)), onClick: onClick, onKeyDown: handleKeyDown, type: "button" }, props),
        children,
        (hasError || isLoading) && (React__default.createElement("div", { className: "form-select-trigger-status-icon" }, isLoading ? (React__default.createElement(LoadingIcon, null)) : (React__default.createElement(ExclamationCircleIcon$1, { className: "form-select-trigger-status-icon-error" })))),
        React__default.createElement("span", { className: "form-select-trigger-icon" },
            React__default.createElement("svg", { viewBox: "0 0 20 20", fill: "none", stroke: "currentColor" },
                React__default.createElement("path", { d: "M7 7l3-3 3 3m0 6l-3 3-3-3", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })))));
});

var useId$2 = typeof useId$8 === "function" ? useId$8 : useId$6;
function SelectOption(_a) {
    var children = _a.children, isDisabled = _a.isDisabled, value = _a.value;
    var id = "carton-ui-select-item-".concat(useId$2());
    var _b = __read(useSelectContext(), 2), state = _b[0], dispatch = _b[1];
    var ref = useRef({ isDisabled: isDisabled });
    var isActive = state.activeItemIndex !== null ? state.items[state.activeItemIndex].id === id : false;
    var isSelected = false;
    if (state.selectPropName) {
        if (state.value && state.value !== null) {
            isSelected = Array.isArray(state.value)
                ? state.value.some(function (v) { return v[state.selectPropName] === value[state.selectPropName]; })
                : state.value[state.selectPropName] === value[state.selectPropName];
        }
    }
    else {
        isSelected = Array.isArray(state.value) ? state.value.includes(value) : state.value === value;
    }
    useIsomorphicEffect(function () {
        ref.current.isDisabled = isDisabled;
    }, [ref, isDisabled]);
    useIsomorphicEffect(function () {
        dispatch({ type: ActionTypes.RegisterItem, id: id, ref: ref, value: value });
        return function () { return dispatch({ type: ActionTypes.UnregisterItem, id: id }); };
    }, [id, isDisabled]);
    var handlePointerMove = function () {
        if (isDisabled)
            return;
        if (isActive)
            return;
        dispatch({ type: ActionTypes.SetActiveItem, id: id });
    };
    var handlePointerLeave = function () {
        if (isDisabled)
            return;
        if (!isActive)
            return;
        dispatch({ type: ActionTypes.ClearActiveItem });
    };
    var handleClick = function (e) {
        if (isDisabled)
            return e.preventDefault();
        dispatch({ type: ActionTypes.Select, value: value });
        if (state.selectionMode === "single") {
            dispatch({ type: ActionTypes.Close });
            nextFrame(function () { var _a, _b; return (_b = (_a = state.triggerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus(); });
        }
    };
    return (React__default.createElement("li", { id: id, role: "option", "aria-disabled": isDisabled, "aria-selected": isSelected, tabIndex: isActive ? 0 : -1, className: classnames("form-select-option", {
            "form-select-option-disabled": isDisabled,
            "form-select-option-selected": isSelected,
            "form-select-option-active": isActive
        }), onPointerMove: handlePointerMove, onPointerLeave: handlePointerLeave, onClick: handleClick },
        typeof children === "string" ? (React__default.createElement("span", { className: "form-select-option-txt" }, children)) : (children),
        isSelected && (React__default.createElement("span", { className: "form-select-option-checked" },
            React__default.createElement(CheckIcon$1, null)))));
}
SelectOption.defaultProps = {
    isDisabled: false
};

var _a$1;
var useId$1 = typeof useId$8 === "function" ? useId$8 : useId$6;
var ActionTypes;
(function (ActionTypes) {
    ActionTypes[ActionTypes["Open"] = 0] = "Open";
    ActionTypes[ActionTypes["Close"] = 1] = "Close";
    ActionTypes[ActionTypes["RegisterItem"] = 2] = "RegisterItem";
    ActionTypes[ActionTypes["UnregisterItem"] = 3] = "UnregisterItem";
    ActionTypes[ActionTypes["SetActiveItem"] = 4] = "SetActiveItem";
    ActionTypes[ActionTypes["SetNextItemActive"] = 5] = "SetNextItemActive";
    ActionTypes[ActionTypes["SetPreviousItemActive"] = 6] = "SetPreviousItemActive";
    ActionTypes[ActionTypes["ClearActiveItem"] = 7] = "ClearActiveItem";
    ActionTypes[ActionTypes["SyncProps"] = 8] = "SyncProps";
    ActionTypes[ActionTypes["SetTextValues"] = 9] = "SetTextValues";
    ActionTypes[ActionTypes["Select"] = 10] = "Select";
})(ActionTypes || (ActionTypes = {}));
var reducers$1 = (_a$1 = {},
    _a$1[ActionTypes.SyncProps] = function (state, action) { return (__assign(__assign({}, state), action.props)); },
    _a$1[ActionTypes.SetTextValues] = function (state, action) { return (__assign(__assign({}, state), { textValues: action.values })); },
    _a$1[ActionTypes.Open] = function (state) { return (__assign(__assign({}, state), { isOpen: true })); },
    _a$1[ActionTypes.Close] = function (state) { return (__assign(__assign({}, state), { isOpen: false, activeItemIndex: null })); },
    _a$1[ActionTypes.Select] = function (state, action) {
        var value = state.value;
        if (state.selectionMode === "single") {
            value = action.value;
            if (state.selectPropName) {
                if (state.value && state.value !== null) {
                    if (state.value[state.selectPropName] === action.value[state.selectPropName]) {
                        value = null;
                    }
                }
            }
            else {
                if (state.value === action.value)
                    value = null;
            }
        }
        else if (state.selectionMode === "multiple") {
            var s_1 = new Set(value);
            if (state.selectPropName) {
                var hasBeenDeleted_1 = false;
                s_1.forEach(function (a) {
                    if (a[state.selectPropName] === action.value[state.selectPropName]) {
                        s_1.delete(a);
                        hasBeenDeleted_1 = true;
                    }
                });
                if (!hasBeenDeleted_1)
                    s_1.add(action.value);
            }
            else {
                if (s_1.has(action.value))
                    s_1.delete(action.value);
                else
                    s_1.add(action.value);
            }
            value = __spreadArray([], __read(s_1), false);
        }
        return __assign(__assign({}, state), { value: value });
    },
    _a$1[ActionTypes.ClearActiveItem] = function (state) { return (__assign(__assign({}, state), { activeItemIndex: null })); },
    _a$1[ActionTypes.SetActiveItem] = function (state, action) { return (__assign(__assign({}, state), { activeItemIndex: state.items.findIndex(function (item) { return item.id === action.id; }) })); },
    _a$1[ActionTypes.SetNextItemActive] = function (state) {
        var _a;
        var activeIndex = (_a = state.activeItemIndex) !== null && _a !== void 0 ? _a : -1;
        var activeItemIndex = state.items.findIndex(function (item, idx) {
            if (idx <= activeIndex)
                return false;
            return !item.ref.current.isDisabled;
        });
        if (activeItemIndex == -1) {
            activeItemIndex = state.items.findIndex(function (item) { return !item.ref.current.isDisabled; });
        }
        return __assign(__assign({}, state), { activeItemIndex: activeItemIndex === -1 ? null : activeItemIndex });
    },
    _a$1[ActionTypes.SetPreviousItemActive] = function (state) {
        var _a;
        var activeIndex = (_a = state.activeItemIndex) !== null && _a !== void 0 ? _a : -1;
        var activeItemIndex = state.activeItemIndex;
        var reversed = state.items.slice().reverse();
        var idx = reversed.findIndex(function (item, idx, all) {
            if (activeIndex !== -1 && all.length - idx - 1 >= activeIndex)
                return false;
            return !item.ref.current.isDisabled;
        });
        if (idx === -1) {
            idx = reversed.findIndex(function (item) { return !item.ref.current.isDisabled; });
        }
        activeItemIndex = state.items.length - 1 - idx;
        return __assign(__assign({}, state), { activeItemIndex: activeItemIndex === -1 ? null : activeItemIndex });
    },
    _a$1[ActionTypes.RegisterItem] = function (state, action) { return (__assign(__assign({}, state), { items: __spreadArray(__spreadArray([], __read(state.items), false), [{ id: action.id, ref: action.ref, value: action.value }], false) })); },
    _a$1[ActionTypes.UnregisterItem] = function (state, action) {
        var nextItems = state.items.slice();
        var currentActiveItem = state.activeItemIndex !== null ? nextItems[state.activeItemIndex] : null;
        var idx = nextItems.findIndex(function (a) { return a.id === action.id; });
        if (idx !== -1)
            nextItems.splice(idx, 1);
        var activeItemIndex;
        if (idx === state.activeItemIndex)
            activeItemIndex = null;
        else if (currentActiveItem === null)
            activeItemIndex = null;
        else
            activeItemIndex = nextItems.indexOf(currentActiveItem);
        return __assign(__assign({}, state), { items: nextItems, activeItemIndex: activeItemIndex });
    },
    _a$1);
function stateReducer$1(state, action) {
    return matchReducer(action.type, reducers$1, state, action);
}
var SelectContext = React__default.createContext(null);
function InternalSelect(props) {
    var _a, _b, _c;
    var defaultOpen = props.defaultOpen, children = props.children, value = props.value, onChange = props.onChange, _d = props.selectionMode, selectionMode = _d === void 0 ? "single" : _d, className = props.className, classNameContainer = props.classNameContainer, style = props.style, validationState = props.validationState, selectPropName = props.selectPropName, isLoading = props.isLoading, _e = props.messages, messages = _e === void 0 ? {} : _e;
    (_a = messages.select) !== null && _a !== void 0 ? _a : (messages.select = "Sélectionner...");
    (_b = messages.itemsSelected) !== null && _b !== void 0 ? _b : (messages.itemsSelected = "{count} sélectionnés");
    var _f = props.placeholder, placeholder = _f === void 0 ? messages.select : _f;
    var triggerRef = useRef();
    var listRef = useRef();
    var reducerObject = useReducer(stateReducer$1, {
        isOpen: defaultOpen,
        triggerRef: triggerRef,
        items: [],
        value: value,
        textValues: {},
        activeItemIndex: null,
        selectionMode: selectionMode,
        selectPropName: selectPropName
    });
    var _g = __read(reducerObject, 2), state = _g[0], dispatch = _g[1];
    useEffect(function () {
        dispatch({ type: ActionTypes.SyncProps, props: { value: value, selectionMode: selectionMode, selectPropName: selectPropName } });
    }, [dispatch, selectionMode, selectPropName, value]);
    useEffectSkipFirstRender(function () {
        if (typeof onChange === "function") {
            onChange(state.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.value]);
    var toggle = useCallback(function () {
        if (state.isOpen)
            dispatch({ type: ActionTypes.Close });
        else
            dispatch({ type: ActionTypes.Open });
    }, [dispatch, state.isOpen]);
    var selectedText = useMemo(function () {
        if (state.value) {
            if (Array.isArray(state.value)) {
                if (state.value.length > 1)
                    return messages.itemsSelected.replace("{count}", String(state.value.length));
                else if (state.value.length === 1)
                    return state.textValues[textValueKey(state.value[0], selectPropName)];
                return placeholder;
            }
            return state.textValues[textValueKey(state.value, selectPropName)];
        }
        return placeholder;
    }, [state.value, state.textValues, placeholder, messages.itemsSelected]);
    var textValues = useMemo(function () {
        var textValues = {};
        React__default.Children.forEach(children, function (child) {
            if (child.type !== SelectOption) {
                var err = new Error("Les enfants d'un <".concat(Select.displayName, "/> doivent \u00EAtre des <").concat(SelectOption.name, "/>"));
                if (Error.captureStackTrace)
                    Error.captureStackTrace(err, InternalSelect);
                throw err;
            }
            if (typeof child.props.children === "string") {
                textValues[textValueKey(child.props.value, selectPropName)] = child.props.children;
            }
            else if (child.props.label) {
                textValues[textValueKey(child.props.value, selectPropName)] = child.props.label;
            }
            else {
                var err = new Error("Si le contenu d'un <".concat(SelectOption.name, "/> n'est pas une string vous devez renseigner le prop 'label'"));
                if (Error.captureStackTrace)
                    Error.captureStackTrace(err, InternalSelect);
                throw err;
            }
        });
        return textValues;
    }, [children]);
    useEffect(function () {
        dispatch({ type: ActionTypes.SetTextValues, values: textValues });
    }, [textValues, dispatch]);
    return (React__default.createElement("div", { className: classNameContainer },
        React__default.createElement(SelectTrigger, { ref: triggerRef, onClick: toggle, className: className, style: style, hasError: validationState === "invalid", isLoading: isLoading, "aria-haspopup": "listbox", "aria-label": props["aria-label"], "aria-expanded": state.isOpen ? true : undefined, "aria-controls": state.isOpen ? (_c = listRef.current) === null || _c === void 0 ? void 0 : _c.id : undefined, "aria-required": props["aria-required"], "aria-invalid": props["aria-invalid"], "aria-errormessage": props["aria-errormessage"] }, selectedText),
        React__default.createElement(SelectContext.Provider, { value: reducerObject },
            React__default.createElement(SelectList, { ref: listRef, triggerRef: triggerRef }, children))));
}
var Select = InternalSelect;
Select.Option = SelectOption;
Select.displayName = "Select";
Select.defaultProps = {
    defaultOpen: false,
    selectionMode: "single"
};
var SelectList = React__default.forwardRef(function SelectList(_a, ref) {
    var children = _a.children, triggerRef = _a.triggerRef;
    var _b = __read(useContext(SelectContext), 2), state = _b[0], dispatch = _b[1];
    var id = "carton-ui-select-list-".concat(useId$1());
    var isWide = useMediaQuery("(min-width: 640px)", true);
    useIsomorphicEffect(function () {
        if (state.isOpen) {
            nextFrame(function () {
                var _a;
                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
    }, [state.isOpen]);
    var close = useCallback(function (e) {
        var _a;
        if (e && ((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            return;
        }
        dispatch({ type: ActionTypes.Close });
    }, [dispatch, triggerRef]);
    var handleBlur = useCallback(function () {
        dispatch({ type: ActionTypes.ClearActiveItem });
    }, [dispatch]);
    var handleKeyDown = useCallback(function (e) {
        var _a;
        switch (e.key) {
            case Keys.ArrowDown:
                e.preventDefault();
                dispatch({ type: ActionTypes.SetNextItemActive });
                break;
            case Keys.ArrowUp:
                e.preventDefault();
                dispatch({ type: ActionTypes.SetPreviousItemActive });
                break;
            case Keys.Enter:
            case Keys.Space:
                e.preventDefault();
                dispatch({ type: ActionTypes.ClearActiveItem });
                if (state.activeItemIndex !== null) {
                    var id_1 = state.items[state.activeItemIndex].id;
                    (_a = document.getElementById(id_1)) === null || _a === void 0 ? void 0 : _a.click();
                }
                break;
        }
    }, [dispatch, state.activeItemIndex, state.items]);
    var child = (React__default.createElement("ul", { id: id, role: "listbox", tabIndex: state.activeItemIndex === null ? 0 : -1, ref: ref, className: "form-select-list", onKeyDown: handleKeyDown, onBlur: handleBlur }, children));
    if (!isWide) {
        return (React__default.createElement(Tray, { isOpen: state.isOpen, onClose: close }, child));
    }
    return (React__default.createElement(Popover, { targetRef: triggerRef, placement: "bottom-end", isOpen: state.isOpen, onClose: close, sameSize: true, shouldCloseOnBlur: true, transition: {
            enter: "",
            enterFrom: "",
            enterTo: "",
            leave: "select-popover-transition-leave",
            leaveFrom: "select-popover-transition-leaveFrom",
            leaveTo: "select-popover-transition-leaveTo"
        } }, child));
});
function useSelectContext() {
    var context = useContext(SelectContext);
    if (context === null) {
        var err = new Error("useSelectContext est utilis\u00E9 hors du composant <".concat(Select.name, " />"));
        if (Error.captureStackTrace)
            Error.captureStackTrace(err, useSelectContext);
        throw err;
    }
    return context;
}
function useEffectSkipFirstRender(cb, deps) {
    var ref = useRef(false);
    useEffect(function () {
        if (ref.current)
            cb();
        else
            ref.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
function textValueKey(value, selectPropName) {
    if (typeof value === "string" || typeof value === "number")
        return value;
    else if (typeof value === "boolean")
        return String(value);
    else if (typeof value === "object") {
        return selectPropName ? value[selectPropName].toString() : value.toString();
    }
}

var MAX_PAGES_TO_DISPLAY = 7; // Première page + 5 pages suivantes + dernière page
var PAGE_BUFFER_SIZE = 2; // Nombre de pages autour de la page courante
function Pagination(_a) {
    var _b;
    var total = _a.total, pageSize = _a.pageSize, pageSizeOptions = _a.pageSizeOptions, defaultPageSize = _a.defaultPageSize, current = _a.current, defaultCurrent = _a.defaultCurrent, hideOnSinglePage = _a.hideOnSinglePage, showTotal = _a.showTotal, showQuickJumper = _a.showQuickJumper, showSizeChanger = _a.showSizeChanger, onChange = _a.onChange, onChangeSize = _a.onChangeSize, _c = _a.messages, messages = _c === void 0 ? {} : _c;
    var _d = __read(useControlledState(current, defaultCurrent, onChange), 2), internalCurrent = _d[0], internalOnChange = _d[1];
    var _e = __read(useControlledState(pageSize, defaultPageSize, onChangeSize), 2), internalPageSize = _e[0], internalOnChangeSize = _e[1];
    (_b = messages.pageSize) !== null && _b !== void 0 ? _b : (messages.pageSize = "{size} / page");
    var allPages = calculatePage(internalPageSize, total);
    var handleSizeChange = useCallback(function (value) {
        var newSize = Number(value);
        internalOnChangeSize(newSize);
        var pages = calculatePage(newSize, total);
        if (internalCurrent > pages) {
            internalOnChange(pages);
        }
    }, [internalOnChangeSize, internalOnChange, internalCurrent, total]);
    var isWide = useMediaQuery("(min-width: 640px)", true);
    var hasPrev = internalCurrent > 1;
    var hasNext = internalCurrent < allPages;
    var prev = useCallback(function () {
        if (hasPrev) {
            internalOnChange(function (c) { return c - 1; });
        }
    }, [hasPrev, internalOnChange]);
    var next = useCallback(function () {
        if (hasNext) {
            internalOnChange(function (c) { return c + 1; });
        }
    }, [hasNext, internalOnChange]);
    var jumpPreviousFn = useCallback(function () {
        var p = Math.max(1, internalCurrent - 5);
        internalOnChange(clamp$1(p, 1, allPages));
    }, [internalCurrent, internalOnChange, allPages]);
    var jumpNextFn = useCallback(function () {
        var p = Math.min(allPages, internalCurrent + 5);
        internalOnChange(clamp$1(p, 1, allPages));
    }, [allPages, internalCurrent, internalOnChange]);
    var goto = useCallback(function (i) {
        internalOnChange(clamp$1(i, 1, allPages));
    }, [allPages, internalOnChange]);
    var shouldDisplayQuickJumper = useMemo(function () {
        if (total <= internalPageSize) {
            return false;
        }
        return showQuickJumper;
    }, [internalPageSize, showQuickJumper, total]);
    var pages = useMemo(function () {
        var r = [];
        if (allPages <= MAX_PAGES_TO_DISPLAY) {
            var _loop_1 = function (i) {
                var isActive = internalCurrent === i;
                r.push(React__default.createElement(PageButton, { key: i, isActive: isActive, onClick: function () {
                        internalOnChange(i);
                    } }, i));
            };
            for (var i = 1; i <= allPages; i++) {
                _loop_1(i);
            }
        }
        else {
            /**
             * Le buffer à une taille de 5 pages.
             * La page courante est toujours le millieu du buffer (entouré de 2 pages à gauche et à droite)
             */
            var firstPageButton = (React__default.createElement(PageButton, { key: 1, isActive: false, onClick: function () { return internalOnChange(1); } }, "1"));
            var lastPageButton = (React__default.createElement(PageButton, { key: allPages, isActive: false, onClick: function () { return internalOnChange(allPages); } }, allPages));
            var jumpPrevious = (React__default.createElement(JumperButton, { direction: "left", key: "jump-previous", onClick: jumpPreviousFn }));
            var jumpNext = React__default.createElement(JumperButton, { key: "jump-next", direction: "right", onClick: jumpNextFn });
            // Page à l'extrémité gauche du buffer
            var left = Math.max(1, internalCurrent - PAGE_BUFFER_SIZE);
            // Page à l'extrémité droite du buffer
            var right = Math.min(internalCurrent + PAGE_BUFFER_SIZE, allPages);
            // Dans le cas où le buffer arrive au début de la pagination, soit un seul icône ... à droite
            if (internalCurrent - 1 <= PAGE_BUFFER_SIZE) {
                right = 1 + PAGE_BUFFER_SIZE * 2;
            }
            // Dans le cas où le buffer arrive à la fin de la pagination, soit un seul icône ... à gauche
            if (allPages - internalCurrent <= PAGE_BUFFER_SIZE) {
                left = allPages - PAGE_BUFFER_SIZE * 2;
            }
            var _loop_2 = function (i) {
                var isActive = internalCurrent === i;
                r.push(React__default.createElement(PageButton, { key: i, isActive: isActive, onClick: function () { return internalOnChange(i); } }, i));
            };
            // Les pages du buffer
            for (var i = left; i <= right; i++) {
                _loop_2(i);
            }
            // Ajoute l'icône ... à gauche
            if (internalCurrent - 1 >= PAGE_BUFFER_SIZE * 2 && internalCurrent !== 1 + 2) {
                r.unshift(jumpPrevious);
            }
            // Ajoute l'icône ... à droite
            if (allPages - internalCurrent >= PAGE_BUFFER_SIZE * 2 && internalCurrent !== allPages - 2) {
                r.push(jumpNext);
            }
            // Enlève la première page car déjà présente
            if (left !== 1) {
                r.unshift(firstPageButton);
            }
            // Enlève la dernière page car déjà présente
            if (right !== allPages) {
                r.push(lastPageButton);
            }
        }
        return r;
    }, [allPages, internalCurrent, internalOnChange, jumpNextFn, jumpPreviousFn]);
    // Cache la pagination quand une seule page
    if (hideOnSinglePage && total <= internalPageSize && !showSizeChanger) {
        return null;
    }
    var totalText = null;
    if (showTotal) {
        totalText = showTotal(total, [
            total === 0 ? 0 : (internalCurrent - 1) * internalPageSize + 1,
            internalCurrent * internalPageSize > total ? total : internalCurrent * internalPageSize
        ]);
    }
    return (React__default.createElement("div", { className: "pagination-wrapper" },
        totalText,
        isWide && (React__default.createElement("nav", { className: "pagination" },
            React__default.createElement(PreviousButton, { isDisabled: !hasPrev, onClick: prev }),
            pages,
            React__default.createElement(NextButton, { isDisabled: !hasNext, onClick: next }))),
        (shouldDisplayQuickJumper || showSizeChanger) && (React__default.createElement("div", { className: "pagination-tools" },
            shouldDisplayQuickJumper && React__default.createElement(QuickJumper, { goto: goto, totalPages: allPages }),
            showSizeChanger && (React__default.createElement(Select, { value: String(internalPageSize), onChange: handleSizeChange, className: "pagination-size-changer" }, pageSizeOptions.map(function (size) { return (React__default.createElement(Select.Option, { key: size, value: String(size), label: "".concat(size, " / page") }, messages.pageSize.replace("{size}", String(size)))); }))))),
        !isWide && (React__default.createElement("div", { className: "pagination-mobile" },
            React__default.createElement(Button.Group, null,
                React__default.createElement(Button, { isDisabled: !hasPrev, onClick: prev, icon: React__default.createElement(ChevronLeftIcon$1, null) }),
                React__default.createElement(Button, { isDisabled: !hasNext, onClick: next, icon: React__default.createElement(ChevronRightIcon$1, null) }))))));
}
Pagination.defaultProps = {
    total: 0,
    defaultCurrent: 1,
    defaultPageSize: 10,
    pageSizeOptions: [10, 20, 50, 100],
    hideOnSinglePage: true,
    showQuickJumper: false,
    showSizeChanger: false
};
/**
 * Helpers
 */
var calculatePage = function (pageSize, total) { return Math.floor((total - 1) / pageSize) + 1; };
var clamp$1 = function (value, min, max) { return Math.min(Math.max(min, value), max); };

var pinDefaults = {
    forceUpperCase: true,
    allowClear: true
};
function Pin(props) {
    var forceUpperCase = (props.forceUpperCase === undefined && pinDefaults.forceUpperCase) || props.forceUpperCase;
    var allowClear = (props.allowClear === undefined && pinDefaults.allowClear) || props.allowClear;
    var hasClearIcon = allowClear && props.value !== "";
    var hasError = props.validationState === "invalid";
    var values = (props.value || "").padEnd(props.length, " ").split("");
    var trailingNode = useMemo(function () {
        var clear = function () { return props.onChange(null); };
        return (React__default.createElement(React__default.Fragment, null,
            hasError && React__default.createElement(ExclamationCircleIcon$1, { className: "carton-pin-icon-invalid" }),
            hasClearIcon && React__default.createElement(XCircleIcon$3, { className: "carton-pin-icon-clear", onClick: clear })));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasError, hasClearIcon, props.onChange]);
    var onSelect = function (e) {
        var target = e.target;
        target.select();
    };
    var onChange = function (index) { return function (e) {
        e.preventDefault();
        var _values = __spreadArray([], __read(values), false);
        var _val = e.target.value.match(/[a-zA-Z0-9]/) ? e.target.value : " ";
        _values[index] = forceUpperCase ? _val.toLocaleUpperCase() : _val;
        e.target.blur();
        var next = (e.target.nextSibling || e.target.parentElement.firstChild);
        next.focus();
        next.select();
        props.onChange(_values.slice(0, props.length).join(""));
    }; };
    return (React__default.createElement("div", { className: "carton-pin" },
        React__default.createElement("div", { className: "carton-pin-inner" }, values.map(function (value, index) { return (React__default.createElement("input", { type: "text", maxLength: 1, tabIndex: index + 1, key: "key-".concat(index), value: value, onChange: onChange(index), className: classnames("carton-pin-item", props.size ? "pin-".concat(props.size) : "pin-sm", {
                "carton-pin-item-invalid": hasError
            }), onClick: onSelect })); })),
        React__default.createElement("div", { className: "carton-pin-icon-trailing" }, trailingNode)));
}

var _a;
var StateActionTypes;
(function (StateActionTypes) {
    StateActionTypes[StateActionTypes["ChangePageSize"] = 0] = "ChangePageSize";
    StateActionTypes[StateActionTypes["ChangePage"] = 1] = "ChangePage";
    StateActionTypes[StateActionTypes["SortField"] = 2] = "SortField";
    StateActionTypes[StateActionTypes["Select"] = 3] = "Select";
    StateActionTypes[StateActionTypes["UnSelect"] = 4] = "UnSelect";
    StateActionTypes[StateActionTypes["SelectMany"] = 5] = "SelectMany";
    StateActionTypes[StateActionTypes["UnSelectMany"] = 6] = "UnSelectMany";
    StateActionTypes[StateActionTypes["ExpandRow"] = 7] = "ExpandRow";
    StateActionTypes[StateActionTypes["CloseRow"] = 8] = "CloseRow";
})(StateActionTypes || (StateActionTypes = {}));
var reducers = (_a = {},
    _a[StateActionTypes.ChangePage] = function (state, action) { return (__assign(__assign({}, state), { page: __assign(__assign({}, state.page), { current: action.page }) })); },
    _a[StateActionTypes.ChangePageSize] = function (state, action) { return (__assign(__assign({}, state), { page: __assign(__assign({}, state.page), { size: action.size }) })); },
    _a[StateActionTypes.SortField] = function (state, action) {
        var fields = !state.sort.multiple ? {} : __assign({}, state.sort.fields);
        if (!action.direction && action.field in fields)
            delete fields[action.field];
        else
            fields[action.field] = action.direction;
        return __assign(__assign({}, state), { sort: __assign(__assign({}, state.sort), { fields: fields }) });
    },
    _a[StateActionTypes.Select] = function (state, action) {
        var selected = state.selection.mode === "single" ? [] : state.selection.selected.slice(0);
        selected.push(action.id);
        return __assign(__assign({}, state), { selection: __assign(__assign({}, state.selection), { selected: selected }) });
    },
    _a[StateActionTypes.UnSelect] = function (state, action) {
        var selected = [];
        if (state.selection.mode === "multiple") {
            selected = state.selection.selected.slice(0);
            var index = selected.indexOf(action.id);
            if (index !== -1) {
                selected.splice(index, 1);
            }
        }
        return __assign(__assign({}, state), { selection: __assign(__assign({}, state.selection), { selected: selected }) });
    },
    _a[StateActionTypes.SelectMany] = function (state, action) {
        var selected = state.selection.selected.concat(action.ids);
        var dedupped = new Set(__spreadArray([], __read(selected), false));
        return __assign(__assign({}, state), { selection: __assign(__assign({}, state.selection), { selected: Array.from(dedupped) }) });
    },
    _a[StateActionTypes.UnSelectMany] = function (state, action) {
        var e_1, _a;
        var selected = new Set(__spreadArray([], __read(state.selection.selected), false));
        try {
            for (var _b = __values(action.ids), _c = _b.next(); !_c.done; _c = _b.next()) {
                var id = _c.value;
                selected.delete(id);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return __assign(__assign({}, state), { selection: __assign(__assign({}, state.selection), { selected: Array.from(selected) }) });
    },
    _a[StateActionTypes.ExpandRow] = function (state, action) {
        var expanded = state.expanded.slice(0);
        expanded.push(action.id);
        return __assign(__assign({}, state), { expanded: expanded });
    },
    _a[StateActionTypes.CloseRow] = function (state, action) {
        var expanded = new Set(__spreadArray([], __read(state.expanded), false));
        expanded.delete(action.id);
        return __assign(__assign({}, state), { expanded: Array.from(expanded) });
    },
    _a);
function stateReducer(state, action) {
    return matchReducer(action.type, reducers, state, action);
}
var TableContext = React__default.createContext(null);

function TooltipContent(_a) {
    var id = _a.id, placement = _a.placement, targetRef = _a.targetRef, children = _a.children;
    var _b = __read(useState(null), 2), popperElement = _b[0], setPopperElement = _b[1];
    var _c = __read(useState(null), 2), arrowElement = _c[0], setArrowElement = _c[1];
    var _d = usePopper(targetRef.current, popperElement, {
        placement: placement,
        modifiers: [
            { name: "flip" },
            {
                name: "offset",
                options: {
                    offset: [0, 10]
                }
            },
            { name: "arrow", options: { element: arrowElement, padding: 5 } }
        ]
    }), styles = _d.styles, attributes = _d.attributes;
    return (React__default.createElement("div", __assign({ className: "tooltip", ref: setPopperElement, style: styles.popper }, attributes.popper),
        React__default.createElement(Transition.Child, { enter: "tooltip-transition-enter", enterFrom: "tooltip-transition-enterFrom", enterTo: "tooltip-transition-enterTo", leave: "tooltip-transition-leave", leaveFrom: "tooltip-transition-leaveFrom", leaveTo: "tooltip-transition-leaveTo" },
            React__default.createElement("div", { className: "tooltip-inner", role: "tooltip", id: id },
                children,
                React__default.createElement("div", { className: "tooltip-arrow", ref: setArrowElement, style: styles.arrow })))));
}

var useId = typeof useId$8 === "function" ? useId$8 : useId$6;
function Tooltip(_a) {
    var title = _a.title, container = _a.container, children = _a.children, placement = _a.placement;
    var _b = __read(useState(false), 2), isVisible = _b[0], setVisible = _b[1];
    var show = useCallback(function () { return setVisible(true); }, []);
    var hide = useCallback(function () { return setVisible(false); }, []);
    var id = "carton-ui-tooltip-".concat(useId());
    var targetRef = useRef();
    try {
        React__default.Children.only(children);
    }
    catch (error) {
        var err = new Error("Un <Tooltip /> accepte seulement un enfant");
        if (Error.captureStackTrace)
            Error.captureStackTrace(err, Tooltip);
        throw err;
    }
    var child;
    if (React__default.isValidElement(children))
        child = children;
    else
        child = React__default.createElement("span", null, children);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.cloneElement(child, {
            "aria-describedby": isVisible ? id : undefined,
            ref: targetRef,
            onFocus: show,
            onBlur: hide,
            onPointerEnter: show,
            onPointerLeave: hide
        }),
        React__default.createElement(Portal$1, { container: container },
            React__default.createElement(Transition, { show: isVisible },
                React__default.createElement(TooltipContent, { id: id, targetRef: targetRef, placement: placement }, title)))));
}
Tooltip.defaultProps = {
    placement: "top"
};

function TableCellActions(_a) {
    var actions = _a.actions, row = _a.row;
    return (React__default.createElement("td", { className: "table-cell table-cell-actions" },
        React__default.createElement("div", null, actions.map(function (action, idx) {
            if (isIconAction(action)) {
                return (React__default.createElement(Tooltip, { key: idx, title: action.name },
                    React__default.createElement(Button, __assign({ onClick: function (ev) {
                            ev.stopPropagation();
                            action.onClick(row);
                        }, icon: action.icon, size: "xs" }, action.buttonProps))));
            }
            else if (isMenuAction(action)) {
                return (React__default.createElement("div", { key: idx },
                    React__default.createElement(TableMenuAction, { action: action, row: row })));
            }
            return null;
        }))));
}
function TableMenuAction(_a) {
    var action = _a.action, row = _a.row;
    var onClickHandler = useMemo(function () {
        var map = new Map();
        action.menu.forEach(function (menuItem, idx) {
            map.set(idx, menuItem.onClick);
        });
        return map;
    }, [action.menu]);
    function handleAction(key) {
        var functionFromKey = onClickHandler.get(key);
        if (typeof functionFromKey === "function") {
            functionFromKey(row);
        }
    }
    return (React__default.createElement(Dropdown, null,
        React__default.createElement(IconButton, null,
            React__default.createElement(DotsVerticalIcon$1, null)),
        React__default.createElement(Menu, { onAction: handleAction }, action.menu.map(function (item, idx) { return (React__default.createElement(Menu.Item, { key: idx, value: idx, icon: item.icon }, item.name)); }))));
}
function isMenuAction(action) {
    return action.menu !== undefined;
}
function isIconAction(action) {
    return action.icon !== undefined;
}

function TableLoadingBar() {
    return (React__default.createElement("div", { className: "table-loadingbar" },
        React__default.createElement("div", null)));
}

function InternalTable(props, ref) {
    var _a, _b;
    var _c;
    var columns = props.columns, data = props.data, _d = props.striped, striped = _d === void 0 ? true : _d, _e = props.layout, layout = _e === void 0 ? "fixed" : _e, _f = props.rowId, rowId = _f === void 0 ? "id" : _f, actions = props.actions, getRowProps = props.getRowProps, _g = props.isLoading, isLoading = _g === void 0 ? false : _g, onChange = props.onChange, pagination = props.pagination, sorting = props.sorting, selection = props.selection, isSelectable = props.isSelectable, expandable = props.expandable, _h = props.messages, messages = _h === void 0 ? {} : _h, className = props.className;
    var hasActions = (actions === null || actions === void 0 ? void 0 : actions.length) > 0;
    var isExpandable = typeof expandable !== "undefined";
    var _j = __read(useReducer(stateReducer, {
        page: pagination && { current: pagination.current, size: pagination.pageSize },
        sort: sorting && { fields: sorting.fields || {}, multiple: sorting.multiple || false },
        selection: isSelectable && {
            mode: (selection === null || selection === void 0 ? void 0 : selection.mode) || "multiple",
            selected: (selection === null || selection === void 0 ? void 0 : selection.initialSelected) || []
        },
        expanded: isExpandable && []
    }), 2), state = _j[0], dispatch = _j[1];
    var validBreakpoints = useBreakpoints();
    var filteredColumns = useMemo(function () {
        return columns.filter(function (col) {
            if (!col.breakpoint || validBreakpoints.length === 0)
                return true;
            return validBreakpoints.includes(col.breakpoint);
        });
    }, [columns, validBreakpoints]);
    useEffect(function () {
        if (typeof onChange === "function")
            onChange(state);
    }, [state, onChange]);
    var onChangePage = useCallback(function (current) {
        dispatch({ type: StateActionTypes.ChangePage, page: current });
    }, []);
    var onChangeSize = useCallback(function (size) {
        dispatch({ type: StateActionTypes.ChangePageSize, size: size });
    }, []);
    var rowIDs = useMemo(function () { return data.map(function (d, idx) { return d[rowId] || idx; }); }, [rowId, data]);
    useImperativeHandle(ref, function () { return ({
        select: function (ids) {
            dispatch({ type: StateActionTypes.SelectMany, ids: ids });
        },
        unselect: function (ids) {
            dispatch({ type: StateActionTypes.UnSelectMany, ids: ids });
        },
        changePage: function (page) {
            dispatch({ type: StateActionTypes.ChangePage, page: page });
        },
        changePageSize: function (pageSize) {
            dispatch({ type: StateActionTypes.ChangePageSize, size: pageSize });
        }
    }); });
    useEffect(function () {
        if (pagination) {
            dispatch({ type: StateActionTypes.ChangePage, page: pagination === null || pagination === void 0 ? void 0 : pagination.current });
            dispatch({ type: StateActionTypes.ChangePageSize, size: pagination === null || pagination === void 0 ? void 0 : pagination.pageSize });
        }
    }, [pagination]);
    var colspan = columns.length;
    if (hasActions)
        colspan++;
    if (isSelectable)
        colspan++;
    if (isExpandable)
        colspan++;
    return (React__default.createElement(TableContext.Provider, { value: {
            reducer: [state, dispatch],
            columns: filteredColumns,
            rowIDs: rowIDs,
            disabled: (selection === null || selection === void 0 ? void 0 : selection.disabled) || []
        } },
        React__default.createElement("div", null,
            React__default.createElement(TableMobileHeaderActions, { selectLabel: messages.selectAll || "Sélectionner tout", sortLabel: messages.sort || "Trier" }),
            React__default.createElement("div", { className: classnames("table-wrapper", (_a = {},
                    _a[className] = className !== undefined,
                    _a)) },
                isLoading && React__default.createElement(TableLoadingBar, null),
                React__default.createElement("table", { className: classnames("table", (_b = {
                            "table-striped": striped && !isExpandable
                        },
                        _b["table-layout-".concat(layout)] = true,
                        _b["table-hasactions"] = hasActions,
                        _b["table-isselectable"] = isSelectable,
                        _b["table-isexpandable"] = isExpandable,
                        _b)) },
                    React__default.createElement("thead", null,
                        React__default.createElement(TableHeader, { hasActions: (actions === null || actions === void 0 ? void 0 : actions.length) > 0, hasExpandleRows: isExpandable, actionsColumnName: messages.actionsColumn || "Actions" })),
                    React__default.createElement("tbody", null, data.length > 0 ? (data.map(function (row, idx) { return (React__default.createElement(TableRow, { key: idx, id: row[rowId] || idx, index: idx, row: row, actions: actions, getRowProps: getRowProps, expandedRowRender: isExpandable ? expandable.render : undefined, isRowExpandable: isExpandable ? expandable.isRowExpandable : undefined })); })) : (React__default.createElement("tr", null,
                        React__default.createElement("td", { colSpan: colspan, className: "table-cell" },
                            React__default.createElement("div", { className: "table-cell-empty" }, messages.empty || "Aucune donnée")))))),
                pagination && (React__default.createElement("div", { className: "table-pagination" },
                    React__default.createElement(Pagination, { showSizeChanger: (_c = pagination.showSizeChanger) !== null && _c !== void 0 ? _c : true, showQuickJumper: pagination.showQuickJumper, showTotal: pagination.showTotal, current: state.page.current, pageSize: state.page.size, pageSizeOptions: pagination.pageSizeOptions, total: pagination.total, onChange: onChangePage, onChangeSize: onChangeSize, hideOnSinglePage: false })))))));
}
var Table = React__default.forwardRef(InternalTable);
/**
 * @returns [sm, md, lg, xl]
 */
function useBreakpoints() {
    var sm = useMediaQuery("(min-width: 640px)", true);
    var md = useMediaQuery("(min-width: 768px)", true);
    var lg = useMediaQuery("(min-width: 1024px)", true);
    var xl = useMediaQuery("(min-width: 1280px)", true);
    return [sm && "sm", md && "md", lg && "lg", xl && "xl"].filter(Boolean);
}
function TableHeader(_a) {
    var hasActions = _a.hasActions, hasExpandleRows = _a.hasExpandleRows, actionsColumnName = _a.actionsColumnName;
    var _b = useContext(TableContext), _c = __read(_b.reducer, 2), state = _c[0], dispatch = _c[1], columns = _b.columns;
    return (React__default.createElement("tr", null,
        state.selection && (React__default.createElement("th", { className: "table-header-checkbox" },
            React__default.createElement(TableHeaderSelectionCheckBox, null))),
        columns.map(function (column) {
            var styleObj = resolveWidthAsStyle(column.width);
            var sortDirection = state.sort ? state.sort.fields[column.field] : undefined;
            return (React__default.createElement("th", { key: column.field, className: classnames({
                    "table-header-sortable": column.sortable,
                    "table-header-sorted": sortDirection
                }), scope: "col", style: styleObj, onClick: function () {
                    if (!column.sortable)
                        return;
                    dispatch({
                        type: StateActionTypes.SortField,
                        field: column.field,
                        direction: getNextSortDirection(sortDirection)
                    });
                } },
                React__default.createElement("div", null,
                    column.name,
                    column.sortable && (React__default.createElement("div", { className: "table-header-sorticon" },
                        React__default.createElement(ChevronUpIcon$1, { className: classnames({ "table-header-sorticon-active": sortDirection === "asc" }) }),
                        React__default.createElement(ChevronDownIcon$1, { className: classnames({ "table-header-sorticon-active": sortDirection === "desc" }) }))))));
        }),
        hasActions && (React__default.createElement("th", { scope: "col", className: "table-header-actions" }, actionsColumnName)),
        hasExpandleRows && React__default.createElement("th", { scope: "col", className: "table-header-expandable" })));
}
function TableMobileHeaderActions(_a) {
    var selectLabel = _a.selectLabel, sortLabel = _a.sortLabel;
    var isModile = useMediaQuery("(max-width: 640px)", true);
    var _b = __read(useContext(TableContext).reducer, 1), state = _b[0];
    if (!isModile || (!state.selection && !state.sort))
        return null;
    return (React__default.createElement("div", { className: "table-mobileheader" },
        state.selection && (React__default.createElement(TableHeaderSelectionCheckBox, null, selectLabel)),
        state.sort && React__default.createElement(TableMobileHeaderSorting, null, sortLabel)));
}
function TableMobileHeaderSorting(_a) {
    var children = _a.children;
    var _b = __read(useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useContext(TableContext), columns = _c.columns, _d = __read(_c.reducer, 2), state = _d[0], dispatch = _d[1];
    var close = useCallback(function () { return setIsOpen(false); }, []);
    var open = useCallback(function () { return setIsOpen(true); }, []);
    return (React__default.createElement("div", null,
        React__default.createElement(Button, { appearance: "ghost", icon: React__default.createElement(ChevronDownIcon$1, null), iconPos: "right", onClick: open }, children),
        React__default.createElement(Tray, { isOpen: isOpen, onClose: close },
            React__default.createElement("ul", { className: "table-sorting-tray" }, columns.map(function (col) {
                var sortDirection = state.sort ? state.sort.fields[col.field] : undefined;
                return (React__default.createElement("li", { key: col.field, onClick: function () {
                        if (!col.sortable)
                            return;
                        dispatch({
                            type: StateActionTypes.SortField,
                            field: col.field,
                            direction: getNextSortDirection(sortDirection)
                        });
                    } },
                    React__default.createElement("div", { className: "table-header-sorticon" },
                        sortDirection === "asc" && React__default.createElement(ArrowUpIcon$1, null),
                        sortDirection === "desc" && React__default.createElement(ArrowDownIcon$1, null)),
                    col.name));
            })))));
}
var TableHeaderSelectionCheckBox = React__default.memo(function TableHeaderSelectionCheckBox(_a) {
    var _b;
    var children = _a.children;
    var _c = useContext(TableContext), _d = __read(_c.reducer, 2), state = _d[0], dispatch = _d[1], rowIDs = _c.rowIDs, disabled = _c.disabled;
    var selectable = useMemo(function () {
        if (!state.selection)
            return [];
        if (disabled.length > 0)
            return rowIDs.filter(function (id) { return !disabled.includes(id); });
        return rowIDs;
    }, [disabled, rowIDs, state.selection]);
    var status = useMemo(function () {
        var e_1, _a;
        var status;
        var allSelected = true;
        if (selectable.length > 0) {
            try {
                for (var selectable_1 = __values(selectable), selectable_1_1 = selectable_1.next(); !selectable_1_1.done; selectable_1_1 = selectable_1.next()) {
                    var id = selectable_1_1.value;
                    if (!state.selection.selected.includes(id))
                        allSelected = false;
                    else {
                        if (status === "indeterminate" && !allSelected)
                            break;
                        status = "indeterminate";
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (selectable_1_1 && !selectable_1_1.done && (_a = selectable_1.return)) _a.call(selectable_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        else
            allSelected = false;
        if (allSelected)
            status = "checked";
        return status;
    }, [selectable, (_b = state.selection) === null || _b === void 0 ? void 0 : _b.selected]);
    if (!state.selection)
        return null;
    return (React__default.createElement("div", null, state.selection.mode === "multiple" && (React__default.createElement(Checkbox, { isIndeterminate: status === "indeterminate", checked: status === "checked", onChange: function (checked) {
            dispatch({
                type: checked ? StateActionTypes.SelectMany : StateActionTypes.UnSelectMany,
                ids: selectable
            });
        } }, children))));
});
function TableRow(_a) {
    var _b;
    var id = _a.id, row = _a.row, index = _a.index, actions = _a.actions, getRowProps = _a.getRowProps, isRowExpandable = _a.isRowExpandable, expandedRowRender = _a.expandedRowRender;
    var rowProps = typeof getRowProps === "function" ? getRowProps(row) : {};
    var _c = useContext(TableContext), _d = __read(_c.reducer, 2), state = _d[0], dispatch = _d[1], columns = _c.columns, disabled = _c.disabled;
    var isSelected = (_b = state.selection) === null || _b === void 0 ? void 0 : _b.selected.includes(id);
    var isDisabled = disabled.includes(id) || false;
    var hasActions = (actions === null || actions === void 0 ? void 0 : actions.length) > 0;
    var isExpandable = typeof expandedRowRender !== "undefined";
    if (typeof isRowExpandable === "function") {
        isExpandable = isRowExpandable(row);
    }
    var isExpanded = isExpandable && state.expanded.includes(id);
    var rowLength = useMemo(function () {
        var n = columns.length;
        if (hasActions)
            n++;
        if (isExpandable)
            n++;
        if (state.selection)
            n++;
        return n;
    }, [columns.length, hasActions, isExpandable, state.selection]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("tr", __assign({}, rowProps, { className: classnames(rowProps.className, {
                "table-row-selected": isSelected,
                "table-has-expanded": isExpanded
            }) }),
            state.selection && (React__default.createElement("td", { className: "table-cell-checkbox" },
                React__default.createElement("div", null, !isDisabled && (React__default.createElement(Checkbox, { checked: isSelected, onChange: function (checked) {
                        if (checked)
                            dispatch({ type: StateActionTypes.Select, id: id });
                        else
                            dispatch({ type: StateActionTypes.UnSelect, id: id });
                    } }))))),
            columns.map(function (column, idx) { return (React__default.createElement(TableCell, { key: idx, rowId: id, column: column, row: row, idx: index })); }),
            hasActions && React__default.createElement(TableCellActions, { row: row, actions: actions }),
            typeof expandedRowRender !== "undefined" && (React__default.createElement("td", { className: "table-cell table-cell-expander" }, isExpandable && (React__default.createElement(IconButton, { onClick: function () {
                    dispatch({
                        type: isExpanded ? StateActionTypes.CloseRow : StateActionTypes.ExpandRow,
                        id: id
                    });
                } }, isExpanded ? React__default.createElement(ChevronUpIcon$1, null) : React__default.createElement(ChevronDownIcon$1, null)))))),
        isExpanded && (React__default.createElement("tr", { className: "table-expanded-row" },
            React__default.createElement("td", { colSpan: rowLength }, expandedRowRender(row))))));
}
function TableCell(_a) {
    var _b, _c, _d, _e;
    var column = _a.column, row = _a.row, rowId = _a.rowId, idx = _a.idx;
    var value = row[column.field];
    var isMobile = "(max-width: 640px)";
    var _f = __read(useContext(TableContext).reducer, 1), state = _f[0];
    var styleObj = {};
    var children = value;
    if (typeof ((_b = column.mobileOptions) === null || _b === void 0 ? void 0 : _b.render) === "function" && isMobile)
        children = column.mobileOptions.render(row);
    else if (typeof column.render === "function")
        children = column.render(value, row, idx);
    else if (column.truncateText)
        children = React__default.createElement("span", null, value);
    return (React__default.createElement("td", { key: "".concat(rowId, "_").concat(column.field), className: classnames("table-cell", {
            "cell-breakword": column.truncateText
                ? false
                : column.breakword === undefined
                    ? true
                    : column.breakword,
            "cell-truncate": column.truncateText,
            "cell-hidden": ((_c = column.mobileOptions) === null || _c === void 0 ? void 0 : _c.show) === false,
            "cell-mobile-full": (_d = column.mobileOptions) === null || _d === void 0 ? void 0 : _d.fullWidth,
            "cell-sorted": state.sort && column.field in state.sort.fields
        }), style: styleObj },
        ((_e = column.mobileOptions) === null || _e === void 0 ? void 0 : _e.header) !== false && (React__default.createElement("div", { className: "table-cell-mobileheader" }, column.name)),
        React__default.createElement("div", { className: "table-cell-content" }, children)));
}
function resolveWidthAsStyle(widthValue) {
    if (!widthValue)
        return;
    var width;
    if (widthValue) {
        if (typeof widthValue === "number")
            width = "".concat(widthValue, "px");
        else
            width = widthValue;
    }
    return { width: width };
}
function getNextSortDirection(sortDirection) {
    var direction;
    if (sortDirection === "asc") {
        direction = "desc";
    }
    else if (sortDirection === "desc") {
        direction = undefined;
    }
    else {
        direction = "asc";
    }
    return direction;
}

var ValueContext = React__default.createContext(null);
function InternalTabs(props) {
    var children = props.children, style = props.style, className = props.className, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, keepAlive = props.keepAlive;
    var isWide = useMediaQuery("(min-width: 640px)", true);
    if (typeof window === undefined)
        isWide = true;
    if (React__default.Children.count(children) === 0) {
        var err = new Error("<Tabs/> ne doit pas \u00EAtre vide");
        if (Error.captureStackTrace)
            Error.captureStackTrace(err, InternalTabs);
        throw err;
    }
    var firstItem = React__default.Children.toArray(children)[0];
    var _a = __read(useControlledState(value, defaultValue || firstItem.props.value, onChange), 2), internalValue = _a[0], internalOnChange = _a[1];
    useEffect(function () {
        var activeItem = React__default.Children.toArray(children).find(function (child) { return child.props.value === internalValue; });
        if (!activeItem) {
            internalOnChange(firstItem.props.value);
        }
    }, [children, internalValue, internalOnChange, firstItem]);
    var renderPanels = useMemo(function () {
        var render = false;
        React__default.Children.map(children, function (elem) {
            if (React__default.isValidElement(elem)) {
                if (React__default.Children.count(elem.props.children))
                    render = true;
            }
        });
        return render;
    }, [children]);
    return (React__default.createElement("div", { className: className, style: style },
        React__default.createElement(ValueContext.Provider, { value: { internalValue: internalValue, internalOnChange: internalOnChange } },
            isWide ? (React__default.createElement("div", { className: "tab-nav" },
                React__default.createElement("div", null,
                    React__default.createElement("nav", null, React__default.Children.map(children, function (child, idx) {
                        if (React__default.isValidElement(child)) {
                            return React__default.cloneElement(child, { key: idx });
                        }
                    }))))) : (React__default.createElement(Select, { value: internalValue, onChange: internalOnChange }, React__default.Children.map(children, function (child, idx) {
                if (React__default.isValidElement(child)) {
                    return (React__default.createElement(Select.Option, { key: idx, label: child.props.label, value: child.props.value }, child.props.icon ? (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("span", { className: "tab-nav-selectoption" }, child.props.icon),
                        React__default.createElement("span", { className: "tab-nav-selectlabel" }, child.props.label))) : (child.props.label)));
                }
            }))),
            renderPanels && (React__default.createElement("div", { className: "tab-panels" }, React__default.Children.map(children, function (child) {
                if (React__default.isValidElement(child)) {
                    return (React__default.createElement(Panel, { active: internalValue === child.props.value, keepAlive: keepAlive, forceRender: child.props.forceRender }, child.props.children));
                }
            }))))));
}
function TabsItem(_a) {
    var _b;
    var className = _a.className, style = _a.style, label = _a.label, value = _a.value, icon = _a.icon;
    var _c = useContext(ValueContext), internalValue = _c.internalValue, internalOnChange = _c.internalOnChange;
    return (React__default.createElement("a", { href: "#", onClick: function (e) {
            e.preventDefault();
            internalOnChange(value);
        }, className: classnames("tab-item", (_b = {
                selected: value === internalValue
            },
            _b[className] = className,
            _b)), style: style },
        icon,
        label));
}
var Tabs = InternalTabs;
Tabs.Item = TabsItem;
TabsItem.displayName = "Tabs.Item";
var Panel = function (_a) {
    var children = _a.children, active = _a.active, forceRender = _a.forceRender, keepAlive = _a.keepAlive;
    if (!children)
        return null;
    if (active || forceRender || keepAlive) {
        return (React__default.createElement("div", { className: classnames({
                hidden: !active
            }) }, children));
    }
    return null;
};

function escapeStringRegexp$1(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin$1 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$1 = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20f0';

/** Used to compose unicode capture groups. */
var rsCombo$1 = '[' + rsComboMarksRange$1 + rsComboSymbolsRange$1 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark$1 = RegExp(rsCombo$1, 'g');

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters$1 = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf$1(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter$1 = basePropertyOf$1(deburredLetters$1);

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$2.toString;

/** Built-in value references. */
var Symbol$2 = root$1.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol$1(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString$1(value);
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr$1(string) {
  string = toString$1(string);
  return string && string.replace(reLatin$1, deburrLetter$1).replace(reComboMark$1, '');
}

var lodash_deburr = deburr$1;

function escapeStringRegexp(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
}

const replacements = [
	// German umlauts
	['ß', 'ss'],
	['ẞ', 'Ss'],
	['ä', 'ae'],
	['Ä', 'Ae'],
	['ö', 'oe'],
	['Ö', 'Oe'],
	['ü', 'ue'],
	['Ü', 'Ue'],

	// Latin
	['À', 'A'],
	['Á', 'A'],
	['Â', 'A'],
	['Ã', 'A'],
	['Ä', 'Ae'],
	['Å', 'A'],
	['Æ', 'AE'],
	['Ç', 'C'],
	['È', 'E'],
	['É', 'E'],
	['Ê', 'E'],
	['Ë', 'E'],
	['Ì', 'I'],
	['Í', 'I'],
	['Î', 'I'],
	['Ï', 'I'],
	['Ð', 'D'],
	['Ñ', 'N'],
	['Ò', 'O'],
	['Ó', 'O'],
	['Ô', 'O'],
	['Õ', 'O'],
	['Ö', 'Oe'],
	['Ő', 'O'],
	['Ø', 'O'],
	['Ù', 'U'],
	['Ú', 'U'],
	['Û', 'U'],
	['Ü', 'Ue'],
	['Ű', 'U'],
	['Ý', 'Y'],
	['Þ', 'TH'],
	['ß', 'ss'],
	['à', 'a'],
	['á', 'a'],
	['â', 'a'],
	['ã', 'a'],
	['ä', 'ae'],
	['å', 'a'],
	['æ', 'ae'],
	['ç', 'c'],
	['è', 'e'],
	['é', 'e'],
	['ê', 'e'],
	['ë', 'e'],
	['ì', 'i'],
	['í', 'i'],
	['î', 'i'],
	['ï', 'i'],
	['ð', 'd'],
	['ñ', 'n'],
	['ò', 'o'],
	['ó', 'o'],
	['ô', 'o'],
	['õ', 'o'],
	['ö', 'oe'],
	['ő', 'o'],
	['ø', 'o'],
	['ù', 'u'],
	['ú', 'u'],
	['û', 'u'],
	['ü', 'ue'],
	['ű', 'u'],
	['ý', 'y'],
	['þ', 'th'],
	['ÿ', 'y'],
	['ẞ', 'SS'],

	// Vietnamese
	['à', 'a'],
	['À', 'A'],
	['á', 'a'],
	['Á', 'A'],
	['â', 'a'],
	['Â', 'A'],
	['ã', 'a'],
	['Ã', 'A'],
	['è', 'e'],
	['È', 'E'],
	['é', 'e'],
	['É', 'E'],
	['ê', 'e'],
	['Ê', 'E'],
	['ì', 'i'],
	['Ì', 'I'],
	['í', 'i'],
	['Í', 'I'],
	['ò', 'o'],
	['Ò', 'O'],
	['ó', 'o'],
	['Ó', 'O'],
	['ô', 'o'],
	['Ô', 'O'],
	['õ', 'o'],
	['Õ', 'O'],
	['ù', 'u'],
	['Ù', 'U'],
	['ú', 'u'],
	['Ú', 'U'],
	['ý', 'y'],
	['Ý', 'Y'],
	['ă', 'a'],
	['Ă', 'A'],
	['Đ', 'D'],
	['đ', 'd'],
	['ĩ', 'i'],
	['Ĩ', 'I'],
	['ũ', 'u'],
	['Ũ', 'U'],
	['ơ', 'o'],
	['Ơ', 'O'],
	['ư', 'u'],
	['Ư', 'U'],
	['ạ', 'a'],
	['Ạ', 'A'],
	['ả', 'a'],
	['Ả', 'A'],
	['ấ', 'a'],
	['Ấ', 'A'],
	['ầ', 'a'],
	['Ầ', 'A'],
	['ẩ', 'a'],
	['Ẩ', 'A'],
	['ẫ', 'a'],
	['Ẫ', 'A'],
	['ậ', 'a'],
	['Ậ', 'A'],
	['ắ', 'a'],
	['Ắ', 'A'],
	['ằ', 'a'],
	['Ằ', 'A'],
	['ẳ', 'a'],
	['Ẳ', 'A'],
	['ẵ', 'a'],
	['Ẵ', 'A'],
	['ặ', 'a'],
	['Ặ', 'A'],
	['ẹ', 'e'],
	['Ẹ', 'E'],
	['ẻ', 'e'],
	['Ẻ', 'E'],
	['ẽ', 'e'],
	['Ẽ', 'E'],
	['ế', 'e'],
	['Ế', 'E'],
	['ề', 'e'],
	['Ề', 'E'],
	['ể', 'e'],
	['Ể', 'E'],
	['ễ', 'e'],
	['Ễ', 'E'],
	['ệ', 'e'],
	['Ệ', 'E'],
	['ỉ', 'i'],
	['Ỉ', 'I'],
	['ị', 'i'],
	['Ị', 'I'],
	['ọ', 'o'],
	['Ọ', 'O'],
	['ỏ', 'o'],
	['Ỏ', 'O'],
	['ố', 'o'],
	['Ố', 'O'],
	['ồ', 'o'],
	['Ồ', 'O'],
	['ổ', 'o'],
	['Ổ', 'O'],
	['ỗ', 'o'],
	['Ỗ', 'O'],
	['ộ', 'o'],
	['Ộ', 'O'],
	['ớ', 'o'],
	['Ớ', 'O'],
	['ờ', 'o'],
	['Ờ', 'O'],
	['ở', 'o'],
	['Ở', 'O'],
	['ỡ', 'o'],
	['Ỡ', 'O'],
	['ợ', 'o'],
	['Ợ', 'O'],
	['ụ', 'u'],
	['Ụ', 'U'],
	['ủ', 'u'],
	['Ủ', 'U'],
	['ứ', 'u'],
	['Ứ', 'U'],
	['ừ', 'u'],
	['Ừ', 'U'],
	['ử', 'u'],
	['Ử', 'U'],
	['ữ', 'u'],
	['Ữ', 'U'],
	['ự', 'u'],
	['Ự', 'U'],
	['ỳ', 'y'],
	['Ỳ', 'Y'],
	['ỵ', 'y'],
	['Ỵ', 'Y'],
	['ỷ', 'y'],
	['Ỷ', 'Y'],
	['ỹ', 'y'],
	['Ỹ', 'Y'],

	// Arabic
	['ء', 'e'],
	['آ', 'a'],
	['أ', 'a'],
	['ؤ', 'w'],
	['إ', 'i'],
	['ئ', 'y'],
	['ا', 'a'],
	['ب', 'b'],
	['ة', 't'],
	['ت', 't'],
	['ث', 'th'],
	['ج', 'j'],
	['ح', 'h'],
	['خ', 'kh'],
	['د', 'd'],
	['ذ', 'dh'],
	['ر', 'r'],
	['ز', 'z'],
	['س', 's'],
	['ش', 'sh'],
	['ص', 's'],
	['ض', 'd'],
	['ط', 't'],
	['ظ', 'z'],
	['ع', 'e'],
	['غ', 'gh'],
	['ـ', '_'],
	['ف', 'f'],
	['ق', 'q'],
	['ك', 'k'],
	['ل', 'l'],
	['م', 'm'],
	['ن', 'n'],
	['ه', 'h'],
	['و', 'w'],
	['ى', 'a'],
	['ي', 'y'],
	['َ‎', 'a'],
	['ُ', 'u'],
	['ِ‎', 'i'],
	['٠', '0'],
	['١', '1'],
	['٢', '2'],
	['٣', '3'],
	['٤', '4'],
	['٥', '5'],
	['٦', '6'],
	['٧', '7'],
	['٨', '8'],
	['٩', '9'],

	// Persian / Farsi
	['چ', 'ch'],
	['ک', 'k'],
	['گ', 'g'],
	['پ', 'p'],
	['ژ', 'zh'],
	['ی', 'y'],
	['۰', '0'],
	['۱', '1'],
	['۲', '2'],
	['۳', '3'],
	['۴', '4'],
	['۵', '5'],
	['۶', '6'],
	['۷', '7'],
	['۸', '8'],
	['۹', '9'],

	// Pashto
	['ټ', 'p'],
	['ځ', 'z'],
	['څ', 'c'],
	['ډ', 'd'],
	['ﺫ', 'd'],
	['ﺭ', 'r'],
	['ړ', 'r'],
	['ﺯ', 'z'],
	['ږ', 'g'],
	['ښ', 'x'],
	['ګ', 'g'],
	['ڼ', 'n'],
	['ۀ', 'e'],
	['ې', 'e'],
	['ۍ', 'ai'],

	// Urdu
	['ٹ', 't'],
	['ڈ', 'd'],
	['ڑ', 'r'],
	['ں', 'n'],
	['ہ', 'h'],
	['ھ', 'h'],
	['ے', 'e'],

	// Russian
	['А', 'A'],
	['а', 'a'],
	['Б', 'B'],
	['б', 'b'],
	['В', 'V'],
	['в', 'v'],
	['Г', 'G'],
	['г', 'g'],
	['Д', 'D'],
	['д', 'd'],
	['ъе', 'ye'],
	['Ъе', 'Ye'],
	['ъЕ', 'yE'],
	['ЪЕ', 'YE'],
	['Е', 'E'],
	['е', 'e'],
	['Ё', 'Yo'],
	['ё', 'yo'],
	['Ж', 'Zh'],
	['ж', 'zh'],
	['З', 'Z'],
	['з', 'z'],
	['И', 'I'],
	['и', 'i'],
	['ый', 'iy'],
	['Ый', 'Iy'],
	['ЫЙ', 'IY'],
	['ыЙ', 'iY'],
	['Й', 'Y'],
	['й', 'y'],
	['К', 'K'],
	['к', 'k'],
	['Л', 'L'],
	['л', 'l'],
	['М', 'M'],
	['м', 'm'],
	['Н', 'N'],
	['н', 'n'],
	['О', 'O'],
	['о', 'o'],
	['П', 'P'],
	['п', 'p'],
	['Р', 'R'],
	['р', 'r'],
	['С', 'S'],
	['с', 's'],
	['Т', 'T'],
	['т', 't'],
	['У', 'U'],
	['у', 'u'],
	['Ф', 'F'],
	['ф', 'f'],
	['Х', 'Kh'],
	['х', 'kh'],
	['Ц', 'Ts'],
	['ц', 'ts'],
	['Ч', 'Ch'],
	['ч', 'ch'],
	['Ш', 'Sh'],
	['ш', 'sh'],
	['Щ', 'Sch'],
	['щ', 'sch'],
	['Ъ', ''],
	['ъ', ''],
	['Ы', 'Y'],
	['ы', 'y'],
	['Ь', ''],
	['ь', ''],
	['Э', 'E'],
	['э', 'e'],
	['Ю', 'Yu'],
	['ю', 'yu'],
	['Я', 'Ya'],
	['я', 'ya'],

	// Romanian
	['ă', 'a'],
	['Ă', 'A'],
	['ș', 's'],
	['Ș', 'S'],
	['ț', 't'],
	['Ț', 'T'],
	['ţ', 't'],
	['Ţ', 'T'],

	// Turkish
	['ş', 's'],
	['Ş', 'S'],
	['ç', 'c'],
	['Ç', 'C'],
	['ğ', 'g'],
	['Ğ', 'G'],
	['ı', 'i'],
	['İ', 'I'],

	// Armenian
	['ա', 'a'],
	['Ա', 'A'],
	['բ', 'b'],
	['Բ', 'B'],
	['գ', 'g'],
	['Գ', 'G'],
	['դ', 'd'],
	['Դ', 'D'],
	['ե', 'ye'],
	['Ե', 'Ye'],
	['զ', 'z'],
	['Զ', 'Z'],
	['է', 'e'],
	['Է', 'E'],
	['ը', 'y'],
	['Ը', 'Y'],
	['թ', 't'],
	['Թ', 'T'],
	['ժ', 'zh'],
	['Ժ', 'Zh'],
	['ի', 'i'],
	['Ի', 'I'],
	['լ', 'l'],
	['Լ', 'L'],
	['խ', 'kh'],
	['Խ', 'Kh'],
	['ծ', 'ts'],
	['Ծ', 'Ts'],
	['կ', 'k'],
	['Կ', 'K'],
	['հ', 'h'],
	['Հ', 'H'],
	['ձ', 'dz'],
	['Ձ', 'Dz'],
	['ղ', 'gh'],
	['Ղ', 'Gh'],
	['ճ', 'tch'],
	['Ճ', 'Tch'],
	['մ', 'm'],
	['Մ', 'M'],
	['յ', 'y'],
	['Յ', 'Y'],
	['ն', 'n'],
	['Ն', 'N'],
	['շ', 'sh'],
	['Շ', 'Sh'],
	['ո', 'vo'],
	['Ո', 'Vo'],
	['չ', 'ch'],
	['Չ', 'Ch'],
	['պ', 'p'],
	['Պ', 'P'],
	['ջ', 'j'],
	['Ջ', 'J'],
	['ռ', 'r'],
	['Ռ', 'R'],
	['ս', 's'],
	['Ս', 'S'],
	['վ', 'v'],
	['Վ', 'V'],
	['տ', 't'],
	['Տ', 'T'],
	['ր', 'r'],
	['Ր', 'R'],
	['ց', 'c'],
	['Ց', 'C'],
	['ու', 'u'],
	['ՈՒ', 'U'],
	['Ու', 'U'],
	['փ', 'p'],
	['Փ', 'P'],
	['ք', 'q'],
	['Ք', 'Q'],
	['օ', 'o'],
	['Օ', 'O'],
	['ֆ', 'f'],
	['Ֆ', 'F'],
	['և', 'yev'],

	// Georgian
	['ა', 'a'],
	['ბ', 'b'],
	['გ', 'g'],
	['დ', 'd'],
	['ე', 'e'],
	['ვ', 'v'],
	['ზ', 'z'],
	['თ', 't'],
	['ი', 'i'],
	['კ', 'k'],
	['ლ', 'l'],
	['მ', 'm'],
	['ნ', 'n'],
	['ო', 'o'],
	['პ', 'p'],
	['ჟ', 'zh'],
	['რ', 'r'],
	['ს', 's'],
	['ტ', 't'],
	['უ', 'u'],
	['ფ', 'ph'],
	['ქ', 'q'],
	['ღ', 'gh'],
	['ყ', 'k'],
	['შ', 'sh'],
	['ჩ', 'ch'],
	['ც', 'ts'],
	['ძ', 'dz'],
	['წ', 'ts'],
	['ჭ', 'tch'],
	['ხ', 'kh'],
	['ჯ', 'j'],
	['ჰ', 'h'],

	// Czech
	['č', 'c'],
	['ď', 'd'],
	['ě', 'e'],
	['ň', 'n'],
	['ř', 'r'],
	['š', 's'],
	['ť', 't'],
	['ů', 'u'],
	['ž', 'z'],
	['Č', 'C'],
	['Ď', 'D'],
	['Ě', 'E'],
	['Ň', 'N'],
	['Ř', 'R'],
	['Š', 'S'],
	['Ť', 'T'],
	['Ů', 'U'],
	['Ž', 'Z'],

	// Dhivehi
	['ހ', 'h'],
	['ށ', 'sh'],
	['ނ', 'n'],
	['ރ', 'r'],
	['ބ', 'b'],
	['ޅ', 'lh'],
	['ކ', 'k'],
	['އ', 'a'],
	['ވ', 'v'],
	['މ', 'm'],
	['ފ', 'f'],
	['ދ', 'dh'],
	['ތ', 'th'],
	['ލ', 'l'],
	['ގ', 'g'],
	['ޏ', 'gn'],
	['ސ', 's'],
	['ޑ', 'd'],
	['ޒ', 'z'],
	['ޓ', 't'],
	['ޔ', 'y'],
	['ޕ', 'p'],
	['ޖ', 'j'],
	['ޗ', 'ch'],
	['ޘ', 'tt'],
	['ޙ', 'hh'],
	['ޚ', 'kh'],
	['ޛ', 'th'],
	['ޜ', 'z'],
	['ޝ', 'sh'],
	['ޞ', 's'],
	['ޟ', 'd'],
	['ޠ', 't'],
	['ޡ', 'z'],
	['ޢ', 'a'],
	['ޣ', 'gh'],
	['ޤ', 'q'],
	['ޥ', 'w'],
	['ަ', 'a'],
	['ާ', 'aa'],
	['ި', 'i'],
	['ީ', 'ee'],
	['ު', 'u'],
	['ޫ', 'oo'],
	['ެ', 'e'],
	['ޭ', 'ey'],
	['ޮ', 'o'],
	['ޯ', 'oa'],
	['ް', ''],

	// Greek
	['α', 'a'],
	['β', 'v'],
	['γ', 'g'],
	['δ', 'd'],
	['ε', 'e'],
	['ζ', 'z'],
	['η', 'i'],
	['θ', 'th'],
	['ι', 'i'],
	['κ', 'k'],
	['λ', 'l'],
	['μ', 'm'],
	['ν', 'n'],
	['ξ', 'ks'],
	['ο', 'o'],
	['π', 'p'],
	['ρ', 'r'],
	['σ', 's'],
	['τ', 't'],
	['υ', 'y'],
	['φ', 'f'],
	['χ', 'x'],
	['ψ', 'ps'],
	['ω', 'o'],
	['ά', 'a'],
	['έ', 'e'],
	['ί', 'i'],
	['ό', 'o'],
	['ύ', 'y'],
	['ή', 'i'],
	['ώ', 'o'],
	['ς', 's'],
	['ϊ', 'i'],
	['ΰ', 'y'],
	['ϋ', 'y'],
	['ΐ', 'i'],
	['Α', 'A'],
	['Β', 'B'],
	['Γ', 'G'],
	['Δ', 'D'],
	['Ε', 'E'],
	['Ζ', 'Z'],
	['Η', 'I'],
	['Θ', 'TH'],
	['Ι', 'I'],
	['Κ', 'K'],
	['Λ', 'L'],
	['Μ', 'M'],
	['Ν', 'N'],
	['Ξ', 'KS'],
	['Ο', 'O'],
	['Π', 'P'],
	['Ρ', 'R'],
	['Σ', 'S'],
	['Τ', 'T'],
	['Υ', 'Y'],
	['Φ', 'F'],
	['Χ', 'X'],
	['Ψ', 'PS'],
	['Ω', 'O'],
	['Ά', 'A'],
	['Έ', 'E'],
	['Ί', 'I'],
	['Ό', 'O'],
	['Ύ', 'Y'],
	['Ή', 'I'],
	['Ώ', 'O'],
	['Ϊ', 'I'],
	['Ϋ', 'Y'],

	// Disabled as it conflicts with German and Latin.
	// Hungarian
	// ['ä', 'a'],
	// ['Ä', 'A'],
	// ['ö', 'o'],
	// ['Ö', 'O'],
	// ['ü', 'u'],
	// ['Ü', 'U'],
	// ['ű', 'u'],
	// ['Ű', 'U'],

	// Latvian
	['ā', 'a'],
	['ē', 'e'],
	['ģ', 'g'],
	['ī', 'i'],
	['ķ', 'k'],
	['ļ', 'l'],
	['ņ', 'n'],
	['ū', 'u'],
	['Ā', 'A'],
	['Ē', 'E'],
	['Ģ', 'G'],
	['Ī', 'I'],
	['Ķ', 'K'],
	['Ļ', 'L'],
	['Ņ', 'N'],
	['Ū', 'U'],
	['č', 'c'],
	['š', 's'],
	['ž', 'z'],
	['Č', 'C'],
	['Š', 'S'],
	['Ž', 'Z'],

	// Lithuanian
	['ą', 'a'],
	['č', 'c'],
	['ę', 'e'],
	['ė', 'e'],
	['į', 'i'],
	['š', 's'],
	['ų', 'u'],
	['ū', 'u'],
	['ž', 'z'],
	['Ą', 'A'],
	['Č', 'C'],
	['Ę', 'E'],
	['Ė', 'E'],
	['Į', 'I'],
	['Š', 'S'],
	['Ų', 'U'],
	['Ū', 'U'],

	// Macedonian
	['Ќ', 'Kj'],
	['ќ', 'kj'],
	['Љ', 'Lj'],
	['љ', 'lj'],
	['Њ', 'Nj'],
	['њ', 'nj'],
	['Тс', 'Ts'],
	['тс', 'ts'],

	// Polish
	['ą', 'a'],
	['ć', 'c'],
	['ę', 'e'],
	['ł', 'l'],
	['ń', 'n'],
	['ś', 's'],
	['ź', 'z'],
	['ż', 'z'],
	['Ą', 'A'],
	['Ć', 'C'],
	['Ę', 'E'],
	['Ł', 'L'],
	['Ń', 'N'],
	['Ś', 'S'],
	['Ź', 'Z'],
	['Ż', 'Z'],

	// Disabled as it conflicts with Vietnamese.
	// Serbian
	// ['љ', 'lj'],
	// ['њ', 'nj'],
	// ['Љ', 'Lj'],
	// ['Њ', 'Nj'],
	// ['đ', 'dj'],
	// ['Đ', 'Dj'],
	// ['ђ', 'dj'],
	// ['ј', 'j'],
	// ['ћ', 'c'],
	// ['џ', 'dz'],
	// ['Ђ', 'Dj'],
	// ['Ј', 'j'],
	// ['Ћ', 'C'],
	// ['Џ', 'Dz'],

	// Disabled as it conflicts with German and Latin.
	// Slovak
	// ['ä', 'a'],
	// ['Ä', 'A'],
	// ['ľ', 'l'],
	// ['ĺ', 'l'],
	// ['ŕ', 'r'],
	// ['Ľ', 'L'],
	// ['Ĺ', 'L'],
	// ['Ŕ', 'R'],

	// Disabled as it conflicts with German and Latin.
	// Swedish
	// ['å', 'o'],
	// ['Å', 'o'],
	// ['ä', 'a'],
	// ['Ä', 'A'],
	// ['ë', 'e'],
	// ['Ë', 'E'],
	// ['ö', 'o'],
	// ['Ö', 'O'],

	// Ukrainian
	['Є', 'Ye'],
	['І', 'I'],
	['Ї', 'Yi'],
	['Ґ', 'G'],
	['є', 'ye'],
	['і', 'i'],
	['ї', 'yi'],
	['ґ', 'g'],

	// Dutch
	['Ĳ', 'IJ'],
	['ĳ', 'ij'],

	// Danish
	// ['Æ', 'Ae'],
	// ['Ø', 'Oe'],
	// ['Å', 'Aa'],
	// ['æ', 'ae'],
	// ['ø', 'oe'],
	// ['å', 'aa']

	// Currencies
	['¢', 'c'],
	['¥', 'Y'],
	['߿', 'b'],
	['৳', 't'],
	['૱', 'Bo'],
	['฿', 'B'],
	['₠', 'CE'],
	['₡', 'C'],
	['₢', 'Cr'],
	['₣', 'F'],
	['₥', 'm'],
	['₦', 'N'],
	['₧', 'Pt'],
	['₨', 'Rs'],
	['₩', 'W'],
	['₫', 's'],
	['€', 'E'],
	['₭', 'K'],
	['₮', 'T'],
	['₯', 'Dp'],
	['₰', 'S'],
	['₱', 'P'],
	['₲', 'G'],
	['₳', 'A'],
	['₴', 'S'],
	['₵', 'C'],
	['₶', 'tt'],
	['₷', 'S'],
	['₸', 'T'],
	['₹', 'R'],
	['₺', 'L'],
	['₽', 'P'],
	['₿', 'B'],
	['﹩', '$'],
	['￠', 'c'],
	['￥', 'Y'],
	['￦', 'W'],

	// Latin
	['𝐀', 'A'],
	['𝐁', 'B'],
	['𝐂', 'C'],
	['𝐃', 'D'],
	['𝐄', 'E'],
	['𝐅', 'F'],
	['𝐆', 'G'],
	['𝐇', 'H'],
	['𝐈', 'I'],
	['𝐉', 'J'],
	['𝐊', 'K'],
	['𝐋', 'L'],
	['𝐌', 'M'],
	['𝐍', 'N'],
	['𝐎', 'O'],
	['𝐏', 'P'],
	['𝐐', 'Q'],
	['𝐑', 'R'],
	['𝐒', 'S'],
	['𝐓', 'T'],
	['𝐔', 'U'],
	['𝐕', 'V'],
	['𝐖', 'W'],
	['𝐗', 'X'],
	['𝐘', 'Y'],
	['𝐙', 'Z'],
	['𝐚', 'a'],
	['𝐛', 'b'],
	['𝐜', 'c'],
	['𝐝', 'd'],
	['𝐞', 'e'],
	['𝐟', 'f'],
	['𝐠', 'g'],
	['𝐡', 'h'],
	['𝐢', 'i'],
	['𝐣', 'j'],
	['𝐤', 'k'],
	['𝐥', 'l'],
	['𝐦', 'm'],
	['𝐧', 'n'],
	['𝐨', 'o'],
	['𝐩', 'p'],
	['𝐪', 'q'],
	['𝐫', 'r'],
	['𝐬', 's'],
	['𝐭', 't'],
	['𝐮', 'u'],
	['𝐯', 'v'],
	['𝐰', 'w'],
	['𝐱', 'x'],
	['𝐲', 'y'],
	['𝐳', 'z'],
	['𝐴', 'A'],
	['𝐵', 'B'],
	['𝐶', 'C'],
	['𝐷', 'D'],
	['𝐸', 'E'],
	['𝐹', 'F'],
	['𝐺', 'G'],
	['𝐻', 'H'],
	['𝐼', 'I'],
	['𝐽', 'J'],
	['𝐾', 'K'],
	['𝐿', 'L'],
	['𝑀', 'M'],
	['𝑁', 'N'],
	['𝑂', 'O'],
	['𝑃', 'P'],
	['𝑄', 'Q'],
	['𝑅', 'R'],
	['𝑆', 'S'],
	['𝑇', 'T'],
	['𝑈', 'U'],
	['𝑉', 'V'],
	['𝑊', 'W'],
	['𝑋', 'X'],
	['𝑌', 'Y'],
	['𝑍', 'Z'],
	['𝑎', 'a'],
	['𝑏', 'b'],
	['𝑐', 'c'],
	['𝑑', 'd'],
	['𝑒', 'e'],
	['𝑓', 'f'],
	['𝑔', 'g'],
	['𝑖', 'i'],
	['𝑗', 'j'],
	['𝑘', 'k'],
	['𝑙', 'l'],
	['𝑚', 'm'],
	['𝑛', 'n'],
	['𝑜', 'o'],
	['𝑝', 'p'],
	['𝑞', 'q'],
	['𝑟', 'r'],
	['𝑠', 's'],
	['𝑡', 't'],
	['𝑢', 'u'],
	['𝑣', 'v'],
	['𝑤', 'w'],
	['𝑥', 'x'],
	['𝑦', 'y'],
	['𝑧', 'z'],
	['𝑨', 'A'],
	['𝑩', 'B'],
	['𝑪', 'C'],
	['𝑫', 'D'],
	['𝑬', 'E'],
	['𝑭', 'F'],
	['𝑮', 'G'],
	['𝑯', 'H'],
	['𝑰', 'I'],
	['𝑱', 'J'],
	['𝑲', 'K'],
	['𝑳', 'L'],
	['𝑴', 'M'],
	['𝑵', 'N'],
	['𝑶', 'O'],
	['𝑷', 'P'],
	['𝑸', 'Q'],
	['𝑹', 'R'],
	['𝑺', 'S'],
	['𝑻', 'T'],
	['𝑼', 'U'],
	['𝑽', 'V'],
	['𝑾', 'W'],
	['𝑿', 'X'],
	['𝒀', 'Y'],
	['𝒁', 'Z'],
	['𝒂', 'a'],
	['𝒃', 'b'],
	['𝒄', 'c'],
	['𝒅', 'd'],
	['𝒆', 'e'],
	['𝒇', 'f'],
	['𝒈', 'g'],
	['𝒉', 'h'],
	['𝒊', 'i'],
	['𝒋', 'j'],
	['𝒌', 'k'],
	['𝒍', 'l'],
	['𝒎', 'm'],
	['𝒏', 'n'],
	['𝒐', 'o'],
	['𝒑', 'p'],
	['𝒒', 'q'],
	['𝒓', 'r'],
	['𝒔', 's'],
	['𝒕', 't'],
	['𝒖', 'u'],
	['𝒗', 'v'],
	['𝒘', 'w'],
	['𝒙', 'x'],
	['𝒚', 'y'],
	['𝒛', 'z'],
	['𝒜', 'A'],
	['𝒞', 'C'],
	['𝒟', 'D'],
	['𝒢', 'g'],
	['𝒥', 'J'],
	['𝒦', 'K'],
	['𝒩', 'N'],
	['𝒪', 'O'],
	['𝒫', 'P'],
	['𝒬', 'Q'],
	['𝒮', 'S'],
	['𝒯', 'T'],
	['𝒰', 'U'],
	['𝒱', 'V'],
	['𝒲', 'W'],
	['𝒳', 'X'],
	['𝒴', 'Y'],
	['𝒵', 'Z'],
	['𝒶', 'a'],
	['𝒷', 'b'],
	['𝒸', 'c'],
	['𝒹', 'd'],
	['𝒻', 'f'],
	['𝒽', 'h'],
	['𝒾', 'i'],
	['𝒿', 'j'],
	['𝓀', 'h'],
	['𝓁', 'l'],
	['𝓂', 'm'],
	['𝓃', 'n'],
	['𝓅', 'p'],
	['𝓆', 'q'],
	['𝓇', 'r'],
	['𝓈', 's'],
	['𝓉', 't'],
	['𝓊', 'u'],
	['𝓋', 'v'],
	['𝓌', 'w'],
	['𝓍', 'x'],
	['𝓎', 'y'],
	['𝓏', 'z'],
	['𝓐', 'A'],
	['𝓑', 'B'],
	['𝓒', 'C'],
	['𝓓', 'D'],
	['𝓔', 'E'],
	['𝓕', 'F'],
	['𝓖', 'G'],
	['𝓗', 'H'],
	['𝓘', 'I'],
	['𝓙', 'J'],
	['𝓚', 'K'],
	['𝓛', 'L'],
	['𝓜', 'M'],
	['𝓝', 'N'],
	['𝓞', 'O'],
	['𝓟', 'P'],
	['𝓠', 'Q'],
	['𝓡', 'R'],
	['𝓢', 'S'],
	['𝓣', 'T'],
	['𝓤', 'U'],
	['𝓥', 'V'],
	['𝓦', 'W'],
	['𝓧', 'X'],
	['𝓨', 'Y'],
	['𝓩', 'Z'],
	['𝓪', 'a'],
	['𝓫', 'b'],
	['𝓬', 'c'],
	['𝓭', 'd'],
	['𝓮', 'e'],
	['𝓯', 'f'],
	['𝓰', 'g'],
	['𝓱', 'h'],
	['𝓲', 'i'],
	['𝓳', 'j'],
	['𝓴', 'k'],
	['𝓵', 'l'],
	['𝓶', 'm'],
	['𝓷', 'n'],
	['𝓸', 'o'],
	['𝓹', 'p'],
	['𝓺', 'q'],
	['𝓻', 'r'],
	['𝓼', 's'],
	['𝓽', 't'],
	['𝓾', 'u'],
	['𝓿', 'v'],
	['𝔀', 'w'],
	['𝔁', 'x'],
	['𝔂', 'y'],
	['𝔃', 'z'],
	['𝔄', 'A'],
	['𝔅', 'B'],
	['𝔇', 'D'],
	['𝔈', 'E'],
	['𝔉', 'F'],
	['𝔊', 'G'],
	['𝔍', 'J'],
	['𝔎', 'K'],
	['𝔏', 'L'],
	['𝔐', 'M'],
	['𝔑', 'N'],
	['𝔒', 'O'],
	['𝔓', 'P'],
	['𝔔', 'Q'],
	['𝔖', 'S'],
	['𝔗', 'T'],
	['𝔘', 'U'],
	['𝔙', 'V'],
	['𝔚', 'W'],
	['𝔛', 'X'],
	['𝔜', 'Y'],
	['𝔞', 'a'],
	['𝔟', 'b'],
	['𝔠', 'c'],
	['𝔡', 'd'],
	['𝔢', 'e'],
	['𝔣', 'f'],
	['𝔤', 'g'],
	['𝔥', 'h'],
	['𝔦', 'i'],
	['𝔧', 'j'],
	['𝔨', 'k'],
	['𝔩', 'l'],
	['𝔪', 'm'],
	['𝔫', 'n'],
	['𝔬', 'o'],
	['𝔭', 'p'],
	['𝔮', 'q'],
	['𝔯', 'r'],
	['𝔰', 's'],
	['𝔱', 't'],
	['𝔲', 'u'],
	['𝔳', 'v'],
	['𝔴', 'w'],
	['𝔵', 'x'],
	['𝔶', 'y'],
	['𝔷', 'z'],
	['𝔸', 'A'],
	['𝔹', 'B'],
	['𝔻', 'D'],
	['𝔼', 'E'],
	['𝔽', 'F'],
	['𝔾', 'G'],
	['𝕀', 'I'],
	['𝕁', 'J'],
	['𝕂', 'K'],
	['𝕃', 'L'],
	['𝕄', 'M'],
	['𝕆', 'N'],
	['𝕊', 'S'],
	['𝕋', 'T'],
	['𝕌', 'U'],
	['𝕍', 'V'],
	['𝕎', 'W'],
	['𝕏', 'X'],
	['𝕐', 'Y'],
	['𝕒', 'a'],
	['𝕓', 'b'],
	['𝕔', 'c'],
	['𝕕', 'd'],
	['𝕖', 'e'],
	['𝕗', 'f'],
	['𝕘', 'g'],
	['𝕙', 'h'],
	['𝕚', 'i'],
	['𝕛', 'j'],
	['𝕜', 'k'],
	['𝕝', 'l'],
	['𝕞', 'm'],
	['𝕟', 'n'],
	['𝕠', 'o'],
	['𝕡', 'p'],
	['𝕢', 'q'],
	['𝕣', 'r'],
	['𝕤', 's'],
	['𝕥', 't'],
	['𝕦', 'u'],
	['𝕧', 'v'],
	['𝕨', 'w'],
	['𝕩', 'x'],
	['𝕪', 'y'],
	['𝕫', 'z'],
	['𝕬', 'A'],
	['𝕭', 'B'],
	['𝕮', 'C'],
	['𝕯', 'D'],
	['𝕰', 'E'],
	['𝕱', 'F'],
	['𝕲', 'G'],
	['𝕳', 'H'],
	['𝕴', 'I'],
	['𝕵', 'J'],
	['𝕶', 'K'],
	['𝕷', 'L'],
	['𝕸', 'M'],
	['𝕹', 'N'],
	['𝕺', 'O'],
	['𝕻', 'P'],
	['𝕼', 'Q'],
	['𝕽', 'R'],
	['𝕾', 'S'],
	['𝕿', 'T'],
	['𝖀', 'U'],
	['𝖁', 'V'],
	['𝖂', 'W'],
	['𝖃', 'X'],
	['𝖄', 'Y'],
	['𝖅', 'Z'],
	['𝖆', 'a'],
	['𝖇', 'b'],
	['𝖈', 'c'],
	['𝖉', 'd'],
	['𝖊', 'e'],
	['𝖋', 'f'],
	['𝖌', 'g'],
	['𝖍', 'h'],
	['𝖎', 'i'],
	['𝖏', 'j'],
	['𝖐', 'k'],
	['𝖑', 'l'],
	['𝖒', 'm'],
	['𝖓', 'n'],
	['𝖔', 'o'],
	['𝖕', 'p'],
	['𝖖', 'q'],
	['𝖗', 'r'],
	['𝖘', 's'],
	['𝖙', 't'],
	['𝖚', 'u'],
	['𝖛', 'v'],
	['𝖜', 'w'],
	['𝖝', 'x'],
	['𝖞', 'y'],
	['𝖟', 'z'],
	['𝖠', 'A'],
	['𝖡', 'B'],
	['𝖢', 'C'],
	['𝖣', 'D'],
	['𝖤', 'E'],
	['𝖥', 'F'],
	['𝖦', 'G'],
	['𝖧', 'H'],
	['𝖨', 'I'],
	['𝖩', 'J'],
	['𝖪', 'K'],
	['𝖫', 'L'],
	['𝖬', 'M'],
	['𝖭', 'N'],
	['𝖮', 'O'],
	['𝖯', 'P'],
	['𝖰', 'Q'],
	['𝖱', 'R'],
	['𝖲', 'S'],
	['𝖳', 'T'],
	['𝖴', 'U'],
	['𝖵', 'V'],
	['𝖶', 'W'],
	['𝖷', 'X'],
	['𝖸', 'Y'],
	['𝖹', 'Z'],
	['𝖺', 'a'],
	['𝖻', 'b'],
	['𝖼', 'c'],
	['𝖽', 'd'],
	['𝖾', 'e'],
	['𝖿', 'f'],
	['𝗀', 'g'],
	['𝗁', 'h'],
	['𝗂', 'i'],
	['𝗃', 'j'],
	['𝗄', 'k'],
	['𝗅', 'l'],
	['𝗆', 'm'],
	['𝗇', 'n'],
	['𝗈', 'o'],
	['𝗉', 'p'],
	['𝗊', 'q'],
	['𝗋', 'r'],
	['𝗌', 's'],
	['𝗍', 't'],
	['𝗎', 'u'],
	['𝗏', 'v'],
	['𝗐', 'w'],
	['𝗑', 'x'],
	['𝗒', 'y'],
	['𝗓', 'z'],
	['𝗔', 'A'],
	['𝗕', 'B'],
	['𝗖', 'C'],
	['𝗗', 'D'],
	['𝗘', 'E'],
	['𝗙', 'F'],
	['𝗚', 'G'],
	['𝗛', 'H'],
	['𝗜', 'I'],
	['𝗝', 'J'],
	['𝗞', 'K'],
	['𝗟', 'L'],
	['𝗠', 'M'],
	['𝗡', 'N'],
	['𝗢', 'O'],
	['𝗣', 'P'],
	['𝗤', 'Q'],
	['𝗥', 'R'],
	['𝗦', 'S'],
	['𝗧', 'T'],
	['𝗨', 'U'],
	['𝗩', 'V'],
	['𝗪', 'W'],
	['𝗫', 'X'],
	['𝗬', 'Y'],
	['𝗭', 'Z'],
	['𝗮', 'a'],
	['𝗯', 'b'],
	['𝗰', 'c'],
	['𝗱', 'd'],
	['𝗲', 'e'],
	['𝗳', 'f'],
	['𝗴', 'g'],
	['𝗵', 'h'],
	['𝗶', 'i'],
	['𝗷', 'j'],
	['𝗸', 'k'],
	['𝗹', 'l'],
	['𝗺', 'm'],
	['𝗻', 'n'],
	['𝗼', 'o'],
	['𝗽', 'p'],
	['𝗾', 'q'],
	['𝗿', 'r'],
	['𝘀', 's'],
	['𝘁', 't'],
	['𝘂', 'u'],
	['𝘃', 'v'],
	['𝘄', 'w'],
	['𝘅', 'x'],
	['𝘆', 'y'],
	['𝘇', 'z'],
	['𝘈', 'A'],
	['𝘉', 'B'],
	['𝘊', 'C'],
	['𝘋', 'D'],
	['𝘌', 'E'],
	['𝘍', 'F'],
	['𝘎', 'G'],
	['𝘏', 'H'],
	['𝘐', 'I'],
	['𝘑', 'J'],
	['𝘒', 'K'],
	['𝘓', 'L'],
	['𝘔', 'M'],
	['𝘕', 'N'],
	['𝘖', 'O'],
	['𝘗', 'P'],
	['𝘘', 'Q'],
	['𝘙', 'R'],
	['𝘚', 'S'],
	['𝘛', 'T'],
	['𝘜', 'U'],
	['𝘝', 'V'],
	['𝘞', 'W'],
	['𝘟', 'X'],
	['𝘠', 'Y'],
	['𝘡', 'Z'],
	['𝘢', 'a'],
	['𝘣', 'b'],
	['𝘤', 'c'],
	['𝘥', 'd'],
	['𝘦', 'e'],
	['𝘧', 'f'],
	['𝘨', 'g'],
	['𝘩', 'h'],
	['𝘪', 'i'],
	['𝘫', 'j'],
	['𝘬', 'k'],
	['𝘭', 'l'],
	['𝘮', 'm'],
	['𝘯', 'n'],
	['𝘰', 'o'],
	['𝘱', 'p'],
	['𝘲', 'q'],
	['𝘳', 'r'],
	['𝘴', 's'],
	['𝘵', 't'],
	['𝘶', 'u'],
	['𝘷', 'v'],
	['𝘸', 'w'],
	['𝘹', 'x'],
	['𝘺', 'y'],
	['𝘻', 'z'],
	['𝘼', 'A'],
	['𝘽', 'B'],
	['𝘾', 'C'],
	['𝘿', 'D'],
	['𝙀', 'E'],
	['𝙁', 'F'],
	['𝙂', 'G'],
	['𝙃', 'H'],
	['𝙄', 'I'],
	['𝙅', 'J'],
	['𝙆', 'K'],
	['𝙇', 'L'],
	['𝙈', 'M'],
	['𝙉', 'N'],
	['𝙊', 'O'],
	['𝙋', 'P'],
	['𝙌', 'Q'],
	['𝙍', 'R'],
	['𝙎', 'S'],
	['𝙏', 'T'],
	['𝙐', 'U'],
	['𝙑', 'V'],
	['𝙒', 'W'],
	['𝙓', 'X'],
	['𝙔', 'Y'],
	['𝙕', 'Z'],
	['𝙖', 'a'],
	['𝙗', 'b'],
	['𝙘', 'c'],
	['𝙙', 'd'],
	['𝙚', 'e'],
	['𝙛', 'f'],
	['𝙜', 'g'],
	['𝙝', 'h'],
	['𝙞', 'i'],
	['𝙟', 'j'],
	['𝙠', 'k'],
	['𝙡', 'l'],
	['𝙢', 'm'],
	['𝙣', 'n'],
	['𝙤', 'o'],
	['𝙥', 'p'],
	['𝙦', 'q'],
	['𝙧', 'r'],
	['𝙨', 's'],
	['𝙩', 't'],
	['𝙪', 'u'],
	['𝙫', 'v'],
	['𝙬', 'w'],
	['𝙭', 'x'],
	['𝙮', 'y'],
	['𝙯', 'z'],
	['𝙰', 'A'],
	['𝙱', 'B'],
	['𝙲', 'C'],
	['𝙳', 'D'],
	['𝙴', 'E'],
	['𝙵', 'F'],
	['𝙶', 'G'],
	['𝙷', 'H'],
	['𝙸', 'I'],
	['𝙹', 'J'],
	['𝙺', 'K'],
	['𝙻', 'L'],
	['𝙼', 'M'],
	['𝙽', 'N'],
	['𝙾', 'O'],
	['𝙿', 'P'],
	['𝚀', 'Q'],
	['𝚁', 'R'],
	['𝚂', 'S'],
	['𝚃', 'T'],
	['𝚄', 'U'],
	['𝚅', 'V'],
	['𝚆', 'W'],
	['𝚇', 'X'],
	['𝚈', 'Y'],
	['𝚉', 'Z'],
	['𝚊', 'a'],
	['𝚋', 'b'],
	['𝚌', 'c'],
	['𝚍', 'd'],
	['𝚎', 'e'],
	['𝚏', 'f'],
	['𝚐', 'g'],
	['𝚑', 'h'],
	['𝚒', 'i'],
	['𝚓', 'j'],
	['𝚔', 'k'],
	['𝚕', 'l'],
	['𝚖', 'm'],
	['𝚗', 'n'],
	['𝚘', 'o'],
	['𝚙', 'p'],
	['𝚚', 'q'],
	['𝚛', 'r'],
	['𝚜', 's'],
	['𝚝', 't'],
	['𝚞', 'u'],
	['𝚟', 'v'],
	['𝚠', 'w'],
	['𝚡', 'x'],
	['𝚢', 'y'],
	['𝚣', 'z'],

	// Dotless letters
	['𝚤', 'l'],
	['𝚥', 'j'],

	// Greek
	['𝛢', 'A'],
	['𝛣', 'B'],
	['𝛤', 'G'],
	['𝛥', 'D'],
	['𝛦', 'E'],
	['𝛧', 'Z'],
	['𝛨', 'I'],
	['𝛩', 'TH'],
	['𝛪', 'I'],
	['𝛫', 'K'],
	['𝛬', 'L'],
	['𝛭', 'M'],
	['𝛮', 'N'],
	['𝛯', 'KS'],
	['𝛰', 'O'],
	['𝛱', 'P'],
	['𝛲', 'R'],
	['𝛳', 'TH'],
	['𝛴', 'S'],
	['𝛵', 'T'],
	['𝛶', 'Y'],
	['𝛷', 'F'],
	['𝛸', 'x'],
	['𝛹', 'PS'],
	['𝛺', 'O'],
	['𝛻', 'D'],
	['𝛼', 'a'],
	['𝛽', 'b'],
	['𝛾', 'g'],
	['𝛿', 'd'],
	['𝜀', 'e'],
	['𝜁', 'z'],
	['𝜂', 'i'],
	['𝜃', 'th'],
	['𝜄', 'i'],
	['𝜅', 'k'],
	['𝜆', 'l'],
	['𝜇', 'm'],
	['𝜈', 'n'],
	['𝜉', 'ks'],
	['𝜊', 'o'],
	['𝜋', 'p'],
	['𝜌', 'r'],
	['𝜍', 's'],
	['𝜎', 's'],
	['𝜏', 't'],
	['𝜐', 'y'],
	['𝜑', 'f'],
	['𝜒', 'x'],
	['𝜓', 'ps'],
	['𝜔', 'o'],
	['𝜕', 'd'],
	['𝜖', 'E'],
	['𝜗', 'TH'],
	['𝜘', 'K'],
	['𝜙', 'f'],
	['𝜚', 'r'],
	['𝜛', 'p'],
	['𝜜', 'A'],
	['𝜝', 'V'],
	['𝜞', 'G'],
	['𝜟', 'D'],
	['𝜠', 'E'],
	['𝜡', 'Z'],
	['𝜢', 'I'],
	['𝜣', 'TH'],
	['𝜤', 'I'],
	['𝜥', 'K'],
	['𝜦', 'L'],
	['𝜧', 'M'],
	['𝜨', 'N'],
	['𝜩', 'KS'],
	['𝜪', 'O'],
	['𝜫', 'P'],
	['𝜬', 'S'],
	['𝜭', 'TH'],
	['𝜮', 'S'],
	['𝜯', 'T'],
	['𝜰', 'Y'],
	['𝜱', 'F'],
	['𝜲', 'X'],
	['𝜳', 'PS'],
	['𝜴', 'O'],
	['𝜵', 'D'],
	['𝜶', 'a'],
	['𝜷', 'v'],
	['𝜸', 'g'],
	['𝜹', 'd'],
	['𝜺', 'e'],
	['𝜻', 'z'],
	['𝜼', 'i'],
	['𝜽', 'th'],
	['𝜾', 'i'],
	['𝜿', 'k'],
	['𝝀', 'l'],
	['𝝁', 'm'],
	['𝝂', 'n'],
	['𝝃', 'ks'],
	['𝝄', 'o'],
	['𝝅', 'p'],
	['𝝆', 'r'],
	['𝝇', 's'],
	['𝝈', 's'],
	['𝝉', 't'],
	['𝝊', 'y'],
	['𝝋', 'f'],
	['𝝌', 'x'],
	['𝝍', 'ps'],
	['𝝎', 'o'],
	['𝝏', 'a'],
	['𝝐', 'e'],
	['𝝑', 'i'],
	['𝝒', 'k'],
	['𝝓', 'f'],
	['𝝔', 'r'],
	['𝝕', 'p'],
	['𝝖', 'A'],
	['𝝗', 'B'],
	['𝝘', 'G'],
	['𝝙', 'D'],
	['𝝚', 'E'],
	['𝝛', 'Z'],
	['𝝜', 'I'],
	['𝝝', 'TH'],
	['𝝞', 'I'],
	['𝝟', 'K'],
	['𝝠', 'L'],
	['𝝡', 'M'],
	['𝝢', 'N'],
	['𝝣', 'KS'],
	['𝝤', 'O'],
	['𝝥', 'P'],
	['𝝦', 'R'],
	['𝝧', 'TH'],
	['𝝨', 'S'],
	['𝝩', 'T'],
	['𝝪', 'Y'],
	['𝝫', 'F'],
	['𝝬', 'X'],
	['𝝭', 'PS'],
	['𝝮', 'O'],
	['𝝯', 'D'],
	['𝝰', 'a'],
	['𝝱', 'v'],
	['𝝲', 'g'],
	['𝝳', 'd'],
	['𝝴', 'e'],
	['𝝵', 'z'],
	['𝝶', 'i'],
	['𝝷', 'th'],
	['𝝸', 'i'],
	['𝝹', 'k'],
	['𝝺', 'l'],
	['𝝻', 'm'],
	['𝝼', 'n'],
	['𝝽', 'ks'],
	['𝝾', 'o'],
	['𝝿', 'p'],
	['𝞀', 'r'],
	['𝞁', 's'],
	['𝞂', 's'],
	['𝞃', 't'],
	['𝞄', 'y'],
	['𝞅', 'f'],
	['𝞆', 'x'],
	['𝞇', 'ps'],
	['𝞈', 'o'],
	['𝞉', 'a'],
	['𝞊', 'e'],
	['𝞋', 'i'],
	['𝞌', 'k'],
	['𝞍', 'f'],
	['𝞎', 'r'],
	['𝞏', 'p'],
	['𝞐', 'A'],
	['𝞑', 'V'],
	['𝞒', 'G'],
	['𝞓', 'D'],
	['𝞔', 'E'],
	['𝞕', 'Z'],
	['𝞖', 'I'],
	['𝞗', 'TH'],
	['𝞘', 'I'],
	['𝞙', 'K'],
	['𝞚', 'L'],
	['𝞛', 'M'],
	['𝞜', 'N'],
	['𝞝', 'KS'],
	['𝞞', 'O'],
	['𝞟', 'P'],
	['𝞠', 'S'],
	['𝞡', 'TH'],
	['𝞢', 'S'],
	['𝞣', 'T'],
	['𝞤', 'Y'],
	['𝞥', 'F'],
	['𝞦', 'X'],
	['𝞧', 'PS'],
	['𝞨', 'O'],
	['𝞩', 'D'],
	['𝞪', 'av'],
	['𝞫', 'g'],
	['𝞬', 'd'],
	['𝞭', 'e'],
	['𝞮', 'z'],
	['𝞯', 'i'],
	['𝞰', 'i'],
	['𝞱', 'th'],
	['𝞲', 'i'],
	['𝞳', 'k'],
	['𝞴', 'l'],
	['𝞵', 'm'],
	['𝞶', 'n'],
	['𝞷', 'ks'],
	['𝞸', 'o'],
	['𝞹', 'p'],
	['𝞺', 'r'],
	['𝞻', 's'],
	['𝞼', 's'],
	['𝞽', 't'],
	['𝞾', 'y'],
	['𝞿', 'f'],
	['𝟀', 'x'],
	['𝟁', 'ps'],
	['𝟂', 'o'],
	['𝟃', 'a'],
	['𝟄', 'e'],
	['𝟅', 'i'],
	['𝟆', 'k'],
	['𝟇', 'f'],
	['𝟈', 'r'],
	['𝟉', 'p'],
	['𝟊', 'F'],
	['𝟋', 'f'],
	['⒜', '(a)'],
	['⒝', '(b)'],
	['⒞', '(c)'],
	['⒟', '(d)'],
	['⒠', '(e)'],
	['⒡', '(f)'],
	['⒢', '(g)'],
	['⒣', '(h)'],
	['⒤', '(i)'],
	['⒥', '(j)'],
	['⒦', '(k)'],
	['⒧', '(l)'],
	['⒨', '(m)'],
	['⒩', '(n)'],
	['⒪', '(o)'],
	['⒫', '(p)'],
	['⒬', '(q)'],
	['⒭', '(r)'],
	['⒮', '(s)'],
	['⒯', '(t)'],
	['⒰', '(u)'],
	['⒱', '(v)'],
	['⒲', '(w)'],
	['⒳', '(x)'],
	['⒴', '(y)'],
	['⒵', '(z)'],
	['Ⓐ', '(A)'],
	['Ⓑ', '(B)'],
	['Ⓒ', '(C)'],
	['Ⓓ', '(D)'],
	['Ⓔ', '(E)'],
	['Ⓕ', '(F)'],
	['Ⓖ', '(G)'],
	['Ⓗ', '(H)'],
	['Ⓘ', '(I)'],
	['Ⓙ', '(J)'],
	['Ⓚ', '(K)'],
	['Ⓛ', '(L)'],
	['Ⓝ', '(N)'],
	['Ⓞ', '(O)'],
	['Ⓟ', '(P)'],
	['Ⓠ', '(Q)'],
	['Ⓡ', '(R)'],
	['Ⓢ', '(S)'],
	['Ⓣ', '(T)'],
	['Ⓤ', '(U)'],
	['Ⓥ', '(V)'],
	['Ⓦ', '(W)'],
	['Ⓧ', '(X)'],
	['Ⓨ', '(Y)'],
	['Ⓩ', '(Z)'],
	['ⓐ', '(a)'],
	['ⓑ', '(b)'],
	['ⓒ', '(b)'],
	['ⓓ', '(c)'],
	['ⓔ', '(e)'],
	['ⓕ', '(f)'],
	['ⓖ', '(g)'],
	['ⓗ', '(h)'],
	['ⓘ', '(i)'],
	['ⓙ', '(j)'],
	['ⓚ', '(k)'],
	['ⓛ', '(l)'],
	['ⓜ', '(m)'],
	['ⓝ', '(n)'],
	['ⓞ', '(o)'],
	['ⓟ', '(p)'],
	['ⓠ', '(q)'],
	['ⓡ', '(r)'],
	['ⓢ', '(s)'],
	['ⓣ', '(t)'],
	['ⓤ', '(u)'],
	['ⓥ', '(v)'],
	['ⓦ', '(w)'],
	['ⓧ', '(x)'],
	['ⓨ', '(y)'],
	['ⓩ', '(z)'],

	// Maltese
	['Ċ', 'C'],
	['ċ', 'c'],
	['Ġ', 'G'],
	['ġ', 'g'],
	['Ħ', 'H'],
	['ħ', 'h'],
	['Ż', 'Z'],
	['ż', 'z'],

	// Numbers
	['𝟎', '0'],
	['𝟏', '1'],
	['𝟐', '2'],
	['𝟑', '3'],
	['𝟒', '4'],
	['𝟓', '5'],
	['𝟔', '6'],
	['𝟕', '7'],
	['𝟖', '8'],
	['𝟗', '9'],
	['𝟘', '0'],
	['𝟙', '1'],
	['𝟚', '2'],
	['𝟛', '3'],
	['𝟜', '4'],
	['𝟝', '5'],
	['𝟞', '6'],
	['𝟟', '7'],
	['𝟠', '8'],
	['𝟡', '9'],
	['𝟢', '0'],
	['𝟣', '1'],
	['𝟤', '2'],
	['𝟥', '3'],
	['𝟦', '4'],
	['𝟧', '5'],
	['𝟨', '6'],
	['𝟩', '7'],
	['𝟪', '8'],
	['𝟫', '9'],
	['𝟬', '0'],
	['𝟭', '1'],
	['𝟮', '2'],
	['𝟯', '3'],
	['𝟰', '4'],
	['𝟱', '5'],
	['𝟲', '6'],
	['𝟳', '7'],
	['𝟴', '8'],
	['𝟵', '9'],
	['𝟶', '0'],
	['𝟷', '1'],
	['𝟸', '2'],
	['𝟹', '3'],
	['𝟺', '4'],
	['𝟻', '5'],
	['𝟼', '6'],
	['𝟽', '7'],
	['𝟾', '8'],
	['𝟿', '9'],
	['①', '1'],
	['②', '2'],
	['③', '3'],
	['④', '4'],
	['⑤', '5'],
	['⑥', '6'],
	['⑦', '7'],
	['⑧', '8'],
	['⑨', '9'],
	['⑩', '10'],
	['⑪', '11'],
	['⑫', '12'],
	['⑬', '13'],
	['⑭', '14'],
	['⑮', '15'],
	['⑯', '16'],
	['⑰', '17'],
	['⑱', '18'],
	['⑲', '19'],
	['⑳', '20'],
	['⑴', '1'],
	['⑵', '2'],
	['⑶', '3'],
	['⑷', '4'],
	['⑸', '5'],
	['⑹', '6'],
	['⑺', '7'],
	['⑻', '8'],
	['⑼', '9'],
	['⑽', '10'],
	['⑾', '11'],
	['⑿', '12'],
	['⒀', '13'],
	['⒁', '14'],
	['⒂', '15'],
	['⒃', '16'],
	['⒄', '17'],
	['⒅', '18'],
	['⒆', '19'],
	['⒇', '20'],
	['⒈', '1.'],
	['⒉', '2.'],
	['⒊', '3.'],
	['⒋', '4.'],
	['⒌', '5.'],
	['⒍', '6.'],
	['⒎', '7.'],
	['⒏', '8.'],
	['⒐', '9.'],
	['⒑', '10.'],
	['⒒', '11.'],
	['⒓', '12.'],
	['⒔', '13.'],
	['⒕', '14.'],
	['⒖', '15.'],
	['⒗', '16.'],
	['⒘', '17.'],
	['⒙', '18.'],
	['⒚', '19.'],
	['⒛', '20.'],
	['⓪', '0'],
	['⓫', '11'],
	['⓬', '12'],
	['⓭', '13'],
	['⓮', '14'],
	['⓯', '15'],
	['⓰', '16'],
	['⓱', '17'],
	['⓲', '18'],
	['⓳', '19'],
	['⓴', '20'],
	['⓵', '1'],
	['⓶', '2'],
	['⓷', '3'],
	['⓸', '4'],
	['⓹', '5'],
	['⓺', '6'],
	['⓻', '7'],
	['⓼', '8'],
	['⓽', '9'],
	['⓾', '10'],
	['⓿', '0'],

	// Punctuation
	['🙰', '&'],
	['🙱', '&'],
	['🙲', '&'],
	['🙳', '&'],
	['🙴', '&'],
	['🙵', '&'],
	['🙶', '"'],
	['🙷', '"'],
	['🙸', '"'],
	['‽', '?!'],
	['🙹', '?!'],
	['🙺', '?!'],
	['🙻', '?!'],
	['🙼', '/'],
	['🙽', '\\'],

	// Alchemy
	['🜇', 'AR'],
	['🜈', 'V'],
	['🜉', 'V'],
	['🜆', 'VR'],
	['🜅', 'VF'],
	['🜩', '2'],
	['🜪', '5'],
	['🝡', 'f'],
	['🝢', 'W'],
	['🝣', 'U'],
	['🝧', 'V'],
	['🝨', 'T'],
	['🝪', 'V'],
	['🝫', 'MB'],
	['🝬', 'VB'],
	['🝲', '3B'],
	['🝳', '3B'],

	// Emojis
	['💯', '100'],
	['🔙', 'BACK'],
	['🔚', 'END'],
	['🔛', 'ON!'],
	['🔜', 'SOON'],
	['🔝', 'TOP'],
	['🔞', '18'],
	['🔤', 'abc'],
	['🔠', 'ABCD'],
	['🔡', 'abcd'],
	['🔢', '1234'],
	['🔣', 'T&@%'],
	['#️⃣', '#'],
	['*️⃣', '*'],
	['0️⃣', '0'],
	['1️⃣', '1'],
	['2️⃣', '2'],
	['3️⃣', '3'],
	['4️⃣', '4'],
	['5️⃣', '5'],
	['6️⃣', '6'],
	['7️⃣', '7'],
	['8️⃣', '8'],
	['9️⃣', '9'],
	['🔟', '10'],
	['🅰️', 'A'],
	['🅱️', 'B'],
	['🆎', 'AB'],
	['🆑', 'CL'],
	['🅾️', 'O'],
	['🅿', 'P'],
	['🆘', 'SOS'],
	['🅲', 'C'],
	['🅳', 'D'],
	['🅴', 'E'],
	['🅵', 'F'],
	['🅶', 'G'],
	['🅷', 'H'],
	['🅸', 'I'],
	['🅹', 'J'],
	['🅺', 'K'],
	['🅻', 'L'],
	['🅼', 'M'],
	['🅽', 'N'],
	['🆀', 'Q'],
	['🆁', 'R'],
	['🆂', 'S'],
	['🆃', 'T'],
	['🆄', 'U'],
	['🆅', 'V'],
	['🆆', 'W'],
	['🆇', 'X'],
	['🆈', 'Y'],
	['🆉', 'Z']
];

const doCustomReplacements = (string, replacements) => {
	for (const [key, value] of replacements) {
		// TODO: Use `String#replaceAll()` when targeting Node.js 16.
		string = string.replace(new RegExp(escapeStringRegexp(key), 'g'), value);
	}

	return string;
};

function transliterate(string, options) {
	if (typeof string !== 'string') {
		throw new TypeError(`Expected a string, got \`${typeof string}\``);
	}

	options = {
		customReplacements: [],
		...options
	};

	const customReplacements = new Map([
		...replacements,
		...options.customReplacements
	]);

	string = string.normalize();
	string = doCustomReplacements(string, customReplacements);
	string = lodash_deburr(string);

	return string;
}

const overridableReplacements = [
	['&', ' and '],
	['🦄', ' unicorn '],
	['♥', ' love ']
];

const decamelize = string => {
	return string
		// Separate capitalized words.
		.replace(/([A-Z]{2,})(\d+)/g, '$1 $2')
		.replace(/([a-z\d]+)([A-Z]{2,})/g, '$1 $2')

		.replace(/([a-z\d])([A-Z])/g, '$1 $2')
		.replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1 $2');
};

const removeMootSeparators = (string, separator) => {
	const escapedSeparator = escapeStringRegexp$1(separator);

	return string
		.replace(new RegExp(`${escapedSeparator}{2,}`, 'g'), separator)
		.replace(new RegExp(`^${escapedSeparator}|${escapedSeparator}$`, 'g'), '');
};

function slugify(string, options) {
	if (typeof string !== 'string') {
		throw new TypeError(`Expected a string, got \`${typeof string}\``);
	}

	options = {
		separator: '-',
		lowercase: true,
		decamelize: true,
		customReplacements: [],
		preserveLeadingUnderscore: false,
		preserveTrailingDash: false,
		...options
	};

	const shouldPrependUnderscore = options.preserveLeadingUnderscore && string.startsWith('_');
	const shouldAppendDash = options.preserveTrailingDash && string.endsWith('-');

	const customReplacements = new Map([
		...overridableReplacements,
		...options.customReplacements
	]);

	string = transliterate(string, {customReplacements});

	if (options.decamelize) {
		string = decamelize(string);
	}

	let patternSlug = /[^a-zA-Z\d]+/g;

	if (options.lowercase) {
		string = string.toLowerCase();
		patternSlug = /[^a-z\d]+/g;
	}

	string = string.replace(patternSlug, options.separator);
	string = string.replace(/\\/g, '');
	if (options.separator) {
		string = removeMootSeparators(string, options.separator);
	}

	if (shouldPrependUnderscore) {
		string = `_${string}`;
	}

	if (shouldAppendDash) {
		string = `${string}-`;
	}

	return string;
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = _basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString_1(string);
  return string && string.replace(reLatin, _deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr;

function TagsInput(_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? "Écrire puis entrer..." : _b, value = _a.value, onChange = _a.onChange, _c = _a.tags, tags = _c === void 0 ? [] : _c, _d = _a.messages, messages = _d === void 0 ? {} : _d;
    var inputRef = useRef();
    var triggerRef = useRef();
    var _e = __read(useState(""), 2), inputValue = _e[0], setInputValue = _e[1];
    var _f = __read(useState(false), 2), isOpen = _f[0], setOpen = _f[1];
    function handleKeydown(e) {
        switch (e.key) {
            case Keys.Enter:
                e.preventDefault();
                if (inputValue === "")
                    return;
                var slug_1 = slugify(inputValue);
                var inValue = value.find(function (t) { return slugify(t.name) === slug_1; });
                if (inValue) {
                    setInputValue("");
                    return;
                }
                var existingTag = tags.find(function (t) { return slugify(t.name) === slug_1; });
                addTag({ id: existingTag ? existingTag.id : undefined, name: inputValue.trim() });
                setInputValue("");
                break;
            case Keys.Backspace:
                if (inputValue === "") {
                    e.preventDefault();
                    var copy = value.slice(0);
                    copy.pop();
                    onChange(copy);
                }
                break;
        }
    }
    function removeTag(idx) {
        var copy = value.slice(0);
        copy.splice(idx, 1);
        onChange(copy);
        nextFrame(function () {
            inputRef.current.focus();
        });
    }
    function addTag(tag) {
        onChange(__spreadArray(__spreadArray([], __read(value), false), [tag], false));
        nextFrame(function () {
            inputRef.current.focus();
        });
    }
    return (React__default.createElement("div", { className: "tags-input-wrapper" },
        React__default.createElement("div", { ref: triggerRef, className: classnames("tags-input", {
                "tags-input-selected": isOpen
            }), onClick: function () { return setOpen(true); } },
            value.map(function (t, idx) { return (React__default.createElement(Tag, __assign({ key: idx }, t, { remove: function () { return removeTag(idx); } }))); }),
            React__default.createElement("input", { ref: inputRef, placeholder: placeholder, value: inputValue, onChange: function (e) { return setInputValue(e.target.value); }, onKeyDown: handleKeydown })),
        tags.length > 0 && (React__default.createElement(Transition, { show: isOpen },
            React__default.createElement(TagsPopup, { targetRef: triggerRef, onClose: function () { return setOpen(false); } },
                React__default.createElement(TagList, { tags: tags, addTag: addTag, value: value, searchMessage: messages.searchPlaceholder }))))));
}
function Tag(_a) {
    var name = _a.name, remove = _a.remove;
    return (React__default.createElement(TagBadge, { onClose: remove, appearance: "primary", isClosable: true }, name));
}
function TagsPopup(_a) {
    var children = _a.children, targetRef = _a.targetRef, onClose = _a.onClose;
    var _b = __read(useState(null), 2), popperElement = _b[0], setPopperElement = _b[1];
    var stackRef = useRef();
    useResizeObserver(targetRef, function () {
        forceUpdate();
    });
    useFocusTrap(stackRef, true, true, stackRef);
    var _c = usePopper(targetRef.current, popperElement, {
        placement: "bottom",
        modifiers: [
            { name: "flip" },
            { name: "preventOverflow" },
            {
                name: "offset",
                options: {
                    offset: [0, 10]
                }
            },
            sameWidth
        ]
    }), styles = _c.styles, attributes = _c.attributes, forceUpdate = _c.forceUpdate;
    useWindowEvent("keydown", function (e) {
        if (e.key !== Keys.Escape)
            return;
        if (!stack.isLast(stackRef.current))
            return;
        onClose();
    });
    useWindowEvent("pointerdown", function (e) {
        if (!stack.isLast(stackRef.current))
            return;
        if (stackRef.current.contains(e.target))
            return;
        if (targetRef.current.contains(e.target))
            return;
        onClose();
    });
    return (React__default.createElement(Portal$1, null,
        React__default.createElement(StackElement, { elRef: stackRef },
            React__default.createElement("div", __assign({ ref: setPopperElement, style: styles.popper }, attributes.popper),
                React__default.createElement(Transition.Child, { enter: "popover-transition-enter", enterFrom: "popover-transition-enterFrom", enterTo: "popover-transition-enterTo", leave: "popover-transition-leave", leaveFrom: "popover-transition-leaveFrom", leaveTo: "popover-transition-leaveTo", className: "popover-wrapper-transition tag-popup", as: "div" },
                    React__default.createElement("div", { ref: stackRef }, children))))));
}
function TagList(_a) {
    var addTag = _a.addTag, value = _a.value, tags = _a.tags, _b = _a.searchMessage, searchMessage = _b === void 0 ? "Rechercher un tag..." : _b;
    var _c = __read(useState(""), 2), search = _c[0], setSearch = _c[1];
    var filtered = useMemo(function () {
        var exp = new RegExp(deburr_1(search), "i");
        return tags.filter(function (t) {
            var tag = value.find(function (st) { return st.id === t.id; });
            if (tag)
                return false;
            if (search) {
                if (exp.test(deburr_1(t.name)))
                    return true;
                return false;
            }
            return true;
        });
    }, [search, tags, value]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Input$1, { leadingIcon: React__default.createElement(SearchIcon$1, null), allowClear: true, placeholder: searchMessage, value: search, onChange: setSearch }),
        React__default.createElement("div", { className: "flex flex-wrap mt-4" }, filtered.map(function (tag) { return (React__default.createElement(TagBadge, { key: tag.id, appearance: "default", onClick: function () { return addTag(tag); }, className: "my-1 mr-1.5 cursor-pointer" }, tag.name)); }))));
}
function TagBadge(_a) {
    var _b;
    var _c = _a.isClosable, isClosable = _c === void 0 ? false : _c, _d = _a.appearance, appearance = _d === void 0 ? "default" : _d, children = _a.children, onClick = _a.onClick, onClose = _a.onClose, className = _a.className;
    return (React__default.createElement("span", { className: classnames("tag-badge", (_b = {
                "tag-badge-primary": appearance === "primary",
                "tag-badge-isclosable": isClosable
            },
            _b[className] = className,
            _b)), onClick: function (e) {
            e.stopPropagation();
            if (typeof onClick === "function")
                onClick();
        } },
        children,
        isClosable && (React__default.createElement("button", { type: "button", className: "tag-badge-close", onClick: onClose },
            React__default.createElement("svg", { stroke: "currentColor", fill: "none", viewBox: "0 0 8 8" },
                React__default.createElement("path", { strokeLinecap: "round", strokeWidth: "1.5", d: "M1 1l6 6m0-6L1 7" }))))));
}

function InternalTextArea(_a, ref) {
    var _b;
    var className = _a.className, style = _a.style, validationState = _a.validationState, isLoading = _a.isLoading, props = __rest(_a, ["className", "style", "validationState", "isLoading"]);
    var hasError = validationState === "invalid";
    return (React__default.createElement("div", { className: classnames("form-input-wrapper", {
            "form-input-error": hasError
        }) },
        React__default.createElement("textarea", __assign({}, props, { rows: props.rows || 4, className: classnames("form-input", (_b = {},
                _b[className] = className,
                _b)), style: style, ref: ref })),
        (isLoading || hasError) && (React__default.createElement("div", { className: "form-input-icon form-input-icon-trailing" },
            hasError && React__default.createElement(ExclamationCircleIcon$1, null),
            isLoading && React__default.createElement(LoadingIcon, null)))));
}
var TextArea = React__default.forwardRef(InternalTextArea);

var TimePickerContext = createContext(null);
function useTimePickerContext() {
    return useContext(TimePickerContext);
}

function TrailingNode(_a) {
    var _b = _a.hasError, hasError = _b === void 0 ? false : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c;
    var _d = useTimePickerContext(), opts = _d.opts, value = _d.value, onChange = _d.onChange, toggle = _d.toggle;
    var canClear = useMemo(function () {
        if (!opts.allowClear)
            return false;
        if (value.hours > 0 || value.minutes > 0 || value.seconds > 0)
            return true;
        return false;
    }, [opts.allowClear, value.hours, value.minutes, value.seconds]);
    return (React__default.createElement("div", { className: "timepicker-input-controls" },
        canClear && (React__default.createElement(IconButton, { onClick: function () { return onChange(null); } },
            React__default.createElement(XCircleIcon$3, null))),
        hasError && React__default.createElement(ExclamationCircleIcon$1, { className: "icon-exclamation" }),
        isLoading ? (React__default.createElement(LoadingIcon, null)) : (React__default.createElement(IconButton, { className: "timepicker-input-control-clock", onClick: toggle },
            React__default.createElement(ClockIcon$1, null)))));
}
function Input(_a) {
    var _b;
    var className = _a.className, targetRef = _a.targetRef, validationState = _a.validationState;
    var hasError = validationState === "invalid";
    var isLoading = validationState === "loading";
    var _c = useTimePickerContext(), opts = _c.opts, value = _c.value, onChange = _c.onChange;
    return (React__default.createElement("div", { tabIndex: 0, ref: targetRef, className: classnames("timepicker-input", (_b = {}, _b[className] = className, _b["form-input-error"] = hasError, _b)) },
        React__default.createElement("div", { className: "timepicker-input-group" },
            opts.hours && (React__default.createElement("input", { name: "hours", min: "0", max: "23", step: "1", type: "number", maxLength: 2, placeholder: "00", className: classnames("timepicker-input-item", {
                    "calendar-input-invalid": hasError
                }), value: String(value.hours).padStart(2, "0"), onChange: function (e) { return onChange(__assign(__assign({}, value), { hours: clamp(Number(e.target.value), 0, 23) })); } })),
            opts.minutes && opts.hours && React__default.createElement(React__default.Fragment, null, "\u2008:\u2008"),
            opts.minutes && (React__default.createElement("input", { name: "minutes", min: "0", max: "59", step: "1", type: "number", maxLength: 2, placeholder: "00", className: classnames("timepicker-input-item", {
                    "calendar-input-invalid": hasError
                }), value: String(value.minutes).padStart(2, "0"), onChange: function (e) { return onChange(__assign(__assign({}, value), { minutes: clamp(Number(e.target.value), 0, 59) })); } })),
            opts.seconds && (opts.minutes || opts.hours) && React__default.createElement(React__default.Fragment, null, "\u2008:\u2008"),
            opts.seconds && (React__default.createElement("input", { name: "seconds", min: "0", max: "59", step: "1", type: "number", maxLength: 2, placeholder: "00", className: classnames("timepicker-input-item", {
                    "calendar-input-invalid": hasError
                }), value: String(value.seconds).padStart(2, "0"), onChange: function (e) { return onChange(__assign(__assign({}, value), { seconds: clamp(Number(e.target.value), 0, 59) })); } }))),
        React__default.createElement(TrailingNode, __assign({}, { hasError: hasError, isLoading: isLoading }))));
}
var clamp = function (value, min, max) { return Math.min(Math.max(min, value), max); };

var Column = React__default.memo(function Column(_a) {
    var type = _a.type;
    var value = useTimePickerContext().value;
    var numbers = useMemo(function () {
        return Array.from({ length: type === "minutes" || type === "seconds" ? 60 : 24 }, function (_v, n) { return [
            n,
            String(n).padStart(2, "0")
        ]; });
    }, [type]);
    var ulRef = useRef(null);
    var liRefs = useRef(new Map());
    useLayoutEffect(function () {
        var li = type === "hours"
            ? liRefs.current.get(value.hours)
            : type === "minutes"
                ? liRefs.current.get(value.minutes)
                : liRefs.current.get(value.seconds);
        if (li)
            nextFrame(function () { return (ulRef.current.scrollTop = li.offsetTop); });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React__default.createElement("ul", { className: "timepicker-column", ref: ulRef }, numbers.map(function (_a) {
        var _b = __read(_a, 2), n = _b[0], name = _b[1];
        return (React__default.createElement(ColumnItem, { key: n, value: n, name: name, type: type, ulRef: ulRef, liRefs: liRefs }));
    })));
});
var ColumnItem = React__default.memo(function ColumnItem(_a) {
    var value = _a.value, name = _a.name, type = _a.type, ulRef = _a.ulRef, liRefs = _a.liRefs;
    var _b = useTimePickerContext(), duration = _b.value, onChange = _b.onChange;
    var selected = useMemo(function () {
        if (type === "hours" && duration.hours === value)
            return true;
        if (type === "minutes" && duration.minutes === value)
            return true;
        if (type === "seconds" && duration.seconds === value)
            return true;
        return false;
    }, [duration.hours, duration.minutes, duration.seconds, type, value]);
    return (React__default.createElement("li", { ref: function (element) {
            liRefs.current.set(value, element);
        }, className: classnames({ "timepicker-item-selected": selected }), onClick: function () {
            var _a;
            onChange(__assign(__assign({}, duration), (_a = {}, _a[type] = value, _a)));
            nextFrame(function () {
                return ulRef.current.scrollTo({ top: liRefs.current.get(value).offsetTop, behavior: "smooth" });
            });
        } },
        React__default.createElement("div", null, name)));
});

var numbers = "\\d+(?:[\\.,]\\d+)?";
var timePattern = "T(".concat(numbers, "H)?(").concat(numbers, "M)?(").concat(numbers, "S)?");
var iso8601Time = "P(?:(?:".concat(timePattern, ")?)");
var objMap = ["hours", "minutes", "seconds"];
var pattern = new RegExp(iso8601Time);
function parse(duration) {
    return duration
        .match(pattern)
        .slice(1)
        .reduce(function (prev, next, idx) {
        prev[objMap[idx]] = parseFloat(next) || 0;
        return prev;
    }, {});
}
function format(_a) {
    var hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
    var str = "PT0S";
    if (hours > 0) {
        if (minutes > 0) {
            if (seconds > 0)
                str = "PT".concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
            else
                str = "PT".concat(hours, "H").concat(minutes, "M");
        }
        else
            str = "PT".concat(hours, "H").concat(seconds, "S");
    }
    else if (minutes > 0) {
        if (seconds > 0)
            str = "PT".concat(minutes, "M").concat(seconds, "S");
        else
            str = "PT".concat(minutes, "M");
    }
    else
        str = "PT".concat(seconds, "S");
    return str;
}

function TimePicker(_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.allowClear, allowClear = _b === void 0 ? true : _b, _c = _a.hours, hours = _c === void 0 ? true : _c, _d = _a.minutes, minutes = _d === void 0 ? true : _d, _e = _a.seconds, seconds = _e === void 0 ? false : _e, className = _a.className, container = _a.container, validationState = _a.validationState;
    var parsedValue = parse(value || "PT0S");
    var _f = __read(useState(false), 2), isOpen = _f[0], setIsOpen = _f[1];
    var inputRef = useRef();
    var toggle = useCallback(function () { return setIsOpen(function (v) { return !v; }); }, []);
    var onClose = useCallback(function (e) {
        if (typeof e === "undefined" && isOpen) {
            setIsOpen(false);
        }
        else if (e.target instanceof Node && !inputRef.current.contains(e.target)) {
            setIsOpen(false);
        }
        else
            e.target.focus();
    }, [isOpen]);
    var handleChange = useCallback(function (value) {
        if (typeof onChange === "function")
            onChange(value === null ? null : format(value));
    }, [onChange]);
    return (React__default.createElement(TimePickerContext.Provider, { value: {
            value: parsedValue,
            onChange: handleChange,
            isOpen: isOpen,
            toggle: toggle,
            opts: { allowClear: allowClear, hours: hours, minutes: minutes, seconds: seconds }
        } },
        React__default.createElement(Input, { className: className, targetRef: inputRef, validationState: validationState }),
        React__default.createElement(Outer, { targetRef: inputRef, isOpen: isOpen, onClose: onClose, shouldCloseOnBlur: true, placement: "bottom", container: container },
            React__default.createElement("div", { className: "timepicker-panel" },
                React__default.createElement("div", { className: "timepicker-container" },
                    hours && React__default.createElement(Column, { type: "hours" }),
                    minutes && React__default.createElement(Column, { type: "minutes" }),
                    seconds && React__default.createElement(Column, { type: "seconds" }))))));
}

function Toggle(_a) {
    var _b;
    var checked = _a.checked, _c = _a.defaultChecked, defaultChecked = _c === void 0 ? false : _c, onChange = _a.onChange, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, children = _a.children, className = _a.className, style = _a.style;
    var _e = __read(useControlledState(checked, defaultChecked || false, onChange), 2), internalChecked = _e[0], internalOnChange = _e[1];
    return (React__default.createElement(Switch.Group, { as: "div", className: classnames("toggle-container", (_b = {
                "toggle-disabled": isDisabled
            },
            _b[className] = className,
            _b)), style: style },
        React__default.createElement(Switch, { checked: internalChecked, onChange: internalOnChange, className: classnames("toggle", {
                "toggle-checked": internalChecked
            }), disabled: isDisabled, type: "button" },
            React__default.createElement("span", { "aria-hidden": "true", className: "toggle-handle" })),
        children && (React__default.createElement(Switch.Label, { as: "div", className: "toggle-label-container" }, children))));
}

export { Alert, Badge, Breadcrumb, Button, Calendar, Card, Checkbox, ClockPicker, ConfigProvider, DatePicker, DateTimePicker, Drawer, Dropdown, Form, IconButton, Input$1 as Input, InputPassword, Link, List, LoadingIcon, Menu, Modal, Pagination, Pin, Popover, Radio, Select, Table, Tabs, TagsInput, TextArea, TimePicker, Toggle, Tooltip, notifier };
//# sourceMappingURL=index.js.map
